PJQ.collections.drawings = {};

PJQ.models.drawings = {};

PJQ.views.drawings = {};

//Routes
PJQ.modules.drawings = {
    routes: [
        {
            route: 'projects/:projectId/drawings',
            name: 'drawings',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "drawings");
            }
        },
        {
            route: 'projects/:projectId/drawings/:versionId',
            name: 'drawings',
            callback: function (projectId, versionId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "drawings", {
                    versionId: versionId
                });
            }
        },
        {
            route: 'drawings/share/:accessKey',
            name: 'shareDrawings',
            callback: function (accessKey) {
                new PJQ.ajax.Request({
                    endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                        {
                            endpoint: 'drawings'
                        },
                        {
                            endpoint: 'share',
                            value: accessKey
                        }
                    ])
                }).get().success(_.bind(function (data) {
                    let versions = new PJQ.collections.drawings.Versions(data.versions),
                        attachments = new PJQ.collections.files.Files(data.attachments),
                        hasDrawings = _.find(versions.models, function (version) {
                            return _.size(version.drawings.models) > 0;
                        }) != null, prj;

                    if (data.projectId > 0) {
                        prj = new PJQ.models.projects.Project({
                            projectId: data.projectId
                        });
                    } else {
                        prj = null;
                    }

                    if (_.size(attachments.models) === 0 && !hasDrawings) {
                        let tmp = new PJQ.templating.Template(PJQ.constants.modules.DRAWINGS, 'share-not-available');
                        PJQ.templating.TemplateRenderer.renderTemplate(false, tmp, PJQ.app.$el);
                    } else {
                        new PJQ.ajax.Request({
                            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                                {
                                    endpoint: 'orders'
                                },
                                {
                                    endpoint: 'settings'
                                }
                            ])
                        }).get().done(_.bind(function (settings) {
                            let $container = $('<div>', {
                                class: 'p-3'
                            });
                            PJQ.app.$el.html($container);
                            if (_.size(attachments.models) > 0 || settings.downloadPerFileFee > 0) {
                                versions.createPsuedoFolders(attachments);

                                _.each(attachments.models, function (attachment) {
                                    if (attachment.get('isFolder'))
                                        attachment.isFetched = true;
                                });

                                PJQ.app.view.renderView(PJQ.views.projects.Attachments, {
                                    el: $container,
                                    project: prj,
                                    collection: attachments,
                                    forShare: true,
                                    isAdmin: false,
                                    orderSettings: settings,
                                    accessKey: accessKey
                                });
                            } else {
                                PJQ.app.view.renderView(PJQ.views.drawings.Dashboard, {
                                    el: $container,
                                    project: prj,
                                    collection: versions,
                                    forShare: true,
                                    orderSettings: settings,
                                    accessKey: accessKey
                                });
                            }
                        }, this));
                    }

                }, this)).fail(_.bind(function (data) {
                    if (data.responseJSON.message == 'BUSY') {
                        PJQ.app.$el.html(`
							<div class="d-flex align-items-center justify-content-center ht-100 text-align-center wd-100">
								<div>
									<div><i class="fal fa-circle-exclamation fa-9x text-orange mb-2"></i></div>
									<div class="fs-36">Drawing Share Unavailable</div>
									<div class="fs-24">Files for this project are currently being processed.<br />Please try again later.</div>
								</div>
							</div>
						`);
                    } else if (data.responseJSON.message == 'OFFLINE') {
                        PJQ.app.$el.html(`
							<div class="d-flex align-items-center justify-content-center ht-100 text-align-center wd-100">
								<div>
									<div><i class="fal fa-circle-exclamation fa-9x text-orange mb-2"></i></div>
									<div class="fs-36">Drawing Share Unavailable</div>
									<div class="fs-24">This project is currently unavailable for download.<br />Please try again later, or check with the sender if the issue persists.</div>
								</div>
							</div>
						`);
                    } else {
                        PJQ.app.$el.html(`
							<div class="d-flex align-items-center justify-content-center ht-100 text-align-center wd-100">
								<div>
									<div><i class="fal fa-clock fa-9x text-orange mb-2"></i></div>
									<div class="fs-36">Drawing Share Expired</div>
									<div class="fs-24">This drawing share has expired and can no longer be viewed</div>
								</div>
							</div>
						`);
                    }
                }, this));
            }
        }
    ]
};

PJQ.constants.drawings = {
    dashboardModes: {
        VIEW: 'VIEW',
        EDIT: 'EDIT',
        SELECT: 'SELECT'
    },
    downloadStatus: {
        FAILED: -1,
        NEW: 0,
        QUEUED: 1,
        IN_PROGRESS: 2,
        COMPLETE: 3
    },
    downloadFrameId: 'pjqDownload',
    imageExtensions: ['jpg', 'jpeg', 'png', 'bmp', 'gif'],
    annotationTypes: {
        INSPECT: 'INSPECT',
        PEN: 'PEN',
        HIGHLIGHTER: 'HIGHLIGHTER',
        LINE: 'LINE',
        ARROW: 'ARROW',
        RECTANGLE: 'RECT',
        ELLIPSE: 'ELLIPSE',
        CLOUD: 'CLOUD',
        LINK_RECTANGLE: 'LINK_RECT',
        LINK_ELLIPSE: 'LINK_ELLIPSE',
        LINK_CLOUD: 'LINK_CLOUD',
        TEXT: 'TEXT',
        PHOTO: 'PHOTO',
        RULER: 'RULER',
        AREA_RECT: 'AREA_RECT',
        RULER_FREE_FORM: 'RULER_FREE_FROM',
        AREA_FREE_FORM: 'AREA_FREE_FORM',
        CALIBRATION: 'CALIBRATION',
        PIN_PUNCH_LIST_ITEM: 'PIN_PUNCH_LIST_ITEM',
        PIN_ACTION_ITEM: 'PIN_ACTION_ITEM',
        PIN_RFI: 'PIN_RFI',
        PIN_SUBMITTAL: 'PIN_SUBMITTAL'
    },
    annotationTypeNames: {
        INSPECT: 'Inspect/Select',
        LINE: 'Line',
        PEN: 'Pen',
        HIGHLIGHTER: 'Highlighter',
        ARROW: 'Arrow',
        RECTANGLE: 'Rectangle',
        ELLIPSE: 'Ellipse',
        CLOUD: 'Cloud',
        LINK_RECTANGLE: 'Rectangle Link',
        LINK_ELLIPSE: 'Ellipse Link',
        LINK_CLOUD: 'Cloud Link',
        TEXT: 'Text Box',
        PHOTO: 'Photo',
        RULER: 'Ruler',
        AREA_RECT: 'Area Rectangle',
        RULER_FREE_FORM: 'Free Form Ruler',
        AREA_FREE_FORM: 'Free Form Area',
        CALIBRATION: 'Calibration',
        PIN_PUNCH_LIST_ITEM: 'Punch List Item',
        PIN_ACTION_ITEM: 'Action Item',
        PIN_RFI: 'RFI',
        PIN_SUBMITTAL: 'Submittal'
    },
    refTypes: {
        DRAWING: 'DRAWING',
        PUNCH_LIST_ITEM: 'PUNCH',
        ACTION_ITEM: 'ACTION',
        RFI: 'RFI',
        SUBMITTAL: 'SUBMITTAL'
    },
    dragPoints: {
        START: 'START',
        END: 'END',
        TOP_LEFT: 'TL',
        TOP_RIGHT: 'TR',
        BOTTOM_LEFT: 'BL',
        BOTTOM_RIGHT: 'BR'
    },
    scaleTypes: {
        IMPERIAL: 'IMPERIAL',
        METRIC: 'METRIC'
    }
};

PJQ.app.addRoutes(PJQ.modules.drawings.routes);
PJQ.models.drawings.Annotation = PJQ.models.BaseModel.extend({
    idAttribute: 'annotationId',
    notifyName: 'Annotation',
    minWidth: 0,
    minHeight: 0,
    afterInit: function () {
        if (PJQ.helpers.objectHelpers.checkNested(PJQ.app, 'session', 'preferences')) {
            this.options.isAPIv2 = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_DRAWING_ANNOTATION_REFS);
        }
    },
    endpoint: function (options) {
        if (!options) {
            options = {};
        }

        options.isAPIv2 = this.options.isAPIv2 = [PJQ.constants.drawings.annotationTypes.PIN_RFI,
            PJQ.constants.drawings.annotationTypes.PIN_PUNCH_LIST_ITEM,
            PJQ.constants.drawings.annotationTypes.PIN_ACTION_ITEM,
            PJQ.constants.drawings.annotationTypes.PIN_SUBMITTAL].indexOf(this.get('type')) !== -1;

        if (this.id > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'drawings'
                },
                {
                    endpoint: 'annotations',
                    value: this.id
                }
            ]);
        }
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'drawings',
                value: this.get('drawingId')
            },
            {
                endpoint: 'annotations'
            }
        ]);
    },
    canEdit: function () {
        return (PJQ.app.session.user != null && this.get('userId') === -PJQ.app.session.user.id) || this.get('canEdit');
    },
    canEditColor: function (type) {
        if (type == null) {
            type = this.get('type');
        }
        return type !== PJQ.constants.drawings.annotationTypes.PIN_PUNCH_LIST_ITEM && type !== PJQ.constants.drawings.annotationTypes.PIN_ACTION_ITEM
            && type !== PJQ.constants.drawings.annotationTypes.PIN_RFI && type !== PJQ.constants.drawings.annotationTypes.PIN_SUBMITTAL;
    },
    parse: function (model) {
        if (!model) {
            return model;
        }

        if (_.size(model.attachments) > 0) {
            this.attachments = new PJQ.collections.drawings.AnnotationAttachments(model.attachments);
        } else if (this.attachments == null) {
            this.attachments = new PJQ.collections.drawings.AnnotationAttachments();
        }

        if (model.refData && model.refId > 0) {
            switch (model.refType) {
                case PJQ.constants.drawings.refTypes.PUNCH_LIST_ITEM:
                    model.refData.punchlistItemId = model.refId;
                    this.punchListItem = new PJQ.models.punchlists.PunchlistItem(model.refData);
                    break;
                case PJQ.constants.drawings.refTypes.ACTION_ITEM:
                    model.refData.actionItemId = model.refId;
                    this.actionItem = new PJQ.models.actionItems.ActionItem(model.refData);
                    break;
            }
        }

        return model;
    },
    getDisplayName: function () {
        return '';
    },
    getDeepLink: function () {
        return null;
    },
    drawDragPoints: function (ct, scale) {
        this.dragPoints = [];
    },
    getStrokeColor: function () {
        return this.get('color');
    },
    stroke: function (ct, scale) {
        let strokeColor = this.getStrokeColor();
        if (strokeColor) {
            ct.lineWidth = 6 / scale;
            ct.setLineDash([0]);
            ct.strokeStyle = strokeColor;
            ct.stroke();
        }
    },
    getFillColor: function () {
        return this.get('color') + '75';
    },
    fill: function (ct) {
        let fillColor = this.getFillColor();
        if (fillColor) {
            ct.fillStyle = fillColor;
            ct.fill();
        }
    },
    start: function (x, y) {
        this.set({
            start: {
                x: Math.round(x),
                y: Math.round(y)
            }
        });

        if (this.attributes.end == null) {
            this.end(x, y);
        }
    },
    end: function (x, y, normalize = false) {
        this.set({
            end: {
                x: Math.round(x),
                y: Math.round(y)
            }
        });

        if (normalize) {
            this.normalizeCoords();
        }

        if (this.minHeight > this.attributes.end.y - this.attributes.start.y) {
            this.attributes.end.y = this.attributes.start.y + this.minHeight;
        }

        if (this.minWidth > this.attributes.end.x - this.attributes.start.x) {
            this.attributes.end.x = this.attributes.start.x + this.minWidth;
        }
    },
    move: function (xDiff, yDiff, maxX, maxY) {
        let start = this.attributes.start,
            end = this.attributes.end,
            newStartX = start.x + xDiff,
            newStartY = start.y + yDiff,
            newEndX = end.x + xDiff,
            newEndY = end.y + yDiff;

        if (newStartX < 0) {
            newEndX -= newStartX;
            newStartX = 0;
        } else if (newEndX >= maxX) {
            newStartX -= newEndX - maxX;
            newEndX = maxX;
        }

        if (newStartY < 0) {
            newEndY -= newStartY;
            newStartY = 0;
        } else if (newEndY >= maxY) {
            newStartY -= newEndY - maxY;
            newEndY = maxY;
        }

        this.start(newStartX, newStartY);
        this.end(newEndX, newEndY);
    },
    moveDragPoint: function (dragPoint, x, y) {
        let start = this.attributes.start,
            end = this.attributes.end;
        switch (dragPoint.position) {
            case PJQ.constants.drawings.dragPoints.TOP_LEFT:
            case PJQ.constants.drawings.dragPoints.START:
                this.start(x, y);
                break;
            case PJQ.constants.drawings.dragPoints.BOTTOM_RIGHT:
            case PJQ.constants.drawings.dragPoints.END:
                this.end(x, y);
                break;
            case PJQ.constants.drawings.dragPoints.TOP_RIGHT:
                this.start(start.x, y);
                this.end(x, end.y);
                break;
            case PJQ.constants.drawings.dragPoints.BOTTOM_LEFT:
                this.start(x, start.y);
                this.end(end.x, y);
                break;
        }
    },
    getCoords(scale = 1) {
        let coords = this.getNormalizedCoords();
        if (coords == null) {
            return null;
        }

        let startX = coords.start.x / scale,
            startY = coords.start.y / scale,
            endX = coords.end.x / scale,
            endY = coords.end.y / scale;
        return {
            start: {
                x: startX,
                y: startY
            },
            end: {
                x: endX,
                y: endY
            },
            height: endY - startY,
            width: endX - startX
        };
    },
    encodePath: function () {
        return null;
    },
    decodePath: function () {
        return null;
    },
    normalizeCoords: function () {
        this.set(this.getNormalizedCoords());
    },
    getNormalizedCoords: function () {
        let start = this.get('start'),
            end = this.get('end');
        if (start == null || end == null) {
            return null;
        }
        return {
            start: start,
            end: end
        };
    },
    collides: function (x, y) {
        return false;
    },
    getCollidingDragPoint: function (x, y) {
        if (this.dragPoints == null) {
            return null;
        }

        return _.find(this.dragPoints, function (point) {
            return PJQ.helpers.trigHelpers.checkRectCollision(point.start, point.end, x, y);
        });
    },
    beforeSave: function () {
        if (this.attachments) {
            this.set('attachments', this.attachments.getChangedModels());
        }
    },
    publish: function (callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'drawings'
                },
                {
                    endpoint: 'annotations',
                    value: this.id
                },
                {
                    endpoint: 'publish'
                }
            ]),
            data: this.toJSON()
        }).put().done(_.bind(function () {
            if (typeof callback === 'function') {
                callback();
            }
        }, this)).fail(_.bind(function () {
            this.set('isPublished', !this.get('isPublished'));
            if (typeof callback === 'function') {
                callback();
            }
        }, this));
    }
});

PJQ.models.drawings.Pen = PJQ.models.drawings.Annotation.extend({
    getDisplayName: function () {
        return PJQ.constants.drawings.annotationTypeNames.PEN;
    },
    start: function (x, y) {
        // start in the case of pen creates a points array and adds the coordinate as the start point
        if (_.size(this.attributes.path) > 0) {
            this.attributes.path[0][0] = x;
            this.attributes.path[0][1] = y;
        } else if (_.size(this.path) === 0) {
            this.path = [[Math.floor(x), Math.floor(y)]];
        }
    },
    end: function (x, y) {
        if (this.path != null) {
            this.path.push([Math.floor(x), Math.floor(y)]);
        } else {
            this.start(x, y);
        }
    },
    normalizeCoords: function (stopDrawing) {
        if (stopDrawing && _.size(this.path) > 0) {
            let smooth = [],
                threshold = 25,
                prevX = null,
                prevY = null;
            _.each(this.path, function (point, index) {
                // remove points which are less than 25 units away (x and y) from the previous point
                let thisX = point[0],
                    thisY = point[1],
                    isAdd = false;
                if (prevX != null && prevY != null) {
                    let xDiff = thisX - prevX,
                        yDiff = thisY - prevY;
                    if ((xDiff > threshold || xDiff < -threshold) || (yDiff > threshold || yDiff < -threshold))
                        isAdd = true;
                } else {
                    isAdd = true;
                }

                if (isAdd) {
                    prevX = thisX;
                    prevY = thisY;
                    smooth.push(point);
                }

                // take every 10th point to cut down the amount of data stored for the path
                // this method results in about a 5% reduction from the above method
                // the downside to this method is thicker lines look blocky
                // if (index % 10 === 0) {
                // 	smooth.push(point);
                // }
            });
            this.encodePath(smooth);
        }
    },
    moveDragPoint: function (dragPoint, x, y) {
        let pts = this.get('path');
        if (_.size(pts) > 0) {
            switch (dragPoint.position) {
                case PJQ.constants.drawings.dragPoints.START:
                    pts[0][0] = Math.floor(x);
                    pts[0][1] = Math.floor(y);
                    break;
                case PJQ.constants.drawings.dragPoints.END:
                    let decodedPts = this.decodePath();
                    pts[0][0] = Math.floor(pts[0][0] + x - decodedPts[decodedPts.length - 1][0]);
                    pts[0][1] = Math.floor(pts[0][1] + y - decodedPts[decodedPts.length - 1][1]);
                    break;
            }
            this.set('path', pts);
        }
    },
    encodePath: function (pts) {
        // delta encode each point x/y coordinate corresponding to the previous
        let path = [],
            prevX = null,
            prevY = null;
        if (_.size(pts) > 0) {
            _.each(pts, function (point, index) {
                let thisX = pts[index][0],
                    thisY = pts[index][1],
                    deltaX,
                    deltaY;
                if (prevX != null && prevY != null) {
                    deltaX = thisX - prevX;
                    deltaY = thisY - prevY;
                } else {
                    deltaX = thisX;
                    deltaY = thisY;
                }
                prevX = thisX;
                prevY = thisY;
                path.push([deltaX, deltaY]);
            }, this);
        }
        this.set('path', path);
        return path;
    },
    decodePath: function () {
        // delta encode each point x/y coordinate corresponding to the previous
        let pts = this.get('path'),
            path = [],
            prevX = null,
            prevY = null;
        if (_.size(pts) > 0) {
            _.each(pts, function (point, index) {
                let thisX = pts[index][0],
                    thisY = pts[index][1],
                    deltaX,
                    deltaY;
                if (prevX != null && prevY != null) {
                    deltaX = prevX + thisX;
                    deltaY = prevY + thisY;
                } else {
                    deltaX = thisX;
                    deltaY = thisY;
                }
                prevX = deltaX;
                prevY = deltaY;
                path.push([deltaX, deltaY]);
            }, this);
        }
        return path;
    },
    collides: function (x, y) {
        if (_.size(this.get('path')) > 0) {
            let path = this.decodePath(),
                buffer = 20,
                start = {
                    x: 0,
                    y: 0
                };
            for (let i = 0; i < _.size(path); i++) {
                let end = {
                    x: path[i][0],
                    y: path[i][1]
                };
                if (i > 0) {
                    let dStart = PJQ.helpers.trigHelpers.distance(start.x, start.y, x, y),
                        dEnd = PJQ.helpers.trigHelpers.distance(end.x, end.y, x, y),
                        dComb = dStart + dEnd,
                        lineLen = PJQ.helpers.trigHelpers.distance(start.x, start.y, end.x, end.y);
                    if (dComb >= lineLen - buffer && dComb <= lineLen + buffer) {
                        return true;
                    }
                }
                start = end;
            }
        }
        return false;
    },
    draw: function (ct, scale) {
        let path;
        if (_.size(this.get('path')) > 0) {
            path = this.decodePath();
        } else if (_.size(this.path) > 0) {
            path = this.path;
        } else {
            path = null;
        }
        if (path != null) {
            ct.beginPath();
            let startX = null,
                startY = null;
            _.each(path, function (point) {
                let pointX = point[0] / scale,
                    pointY = point[1] / scale;
                if (startX == null && startY == null) {
                    startX = pointX;
                    startY = pointY;
                    ct.moveTo(startX, startY);
                } else {
                    ct.lineTo(pointX, pointY);
                }
            });
            this.stroke(ct, scale);
        }
    },
    getCoords: function (scale) {
        let result = {
            start: {
                x: 0,
                y: 0
            },
            end: {
                x: 0,
                y: 0
            }
        };
        let path = this.decodePath(),
            ptCount = _.size(path);
        if (ptCount > 0) {
            result.start.x = path[0][0] / scale;
            result.start.y = path[0][1] / scale;
            if (ptCount > 1) {
                result.end.x = path[ptCount - 1][0] / scale;
                result.end.y = path[ptCount - 1][1] / scale;
            }
        }
        return result;
    },
    drawDragPoints: function (ct, scale) {
        let ptWidth = 15,
            coords = this.getCoords(scale),
            hfPtWidth = ptWidth / 2,
            sStartX = coords.start.x - hfPtWidth,
            sStartY = coords.start.y - hfPtWidth,
            eStartX = coords.end.x - hfPtWidth,
            eStartY = coords.end.y - hfPtWidth

        this.dragPoints = [
            {
                position: PJQ.constants.drawings.dragPoints.START,
                start: {
                    x: sStartX,
                    y: sStartY
                },
                end: {
                    x: sStartX + ptWidth,
                    y: sStartY + ptWidth
                }
            },
            {
                position: PJQ.constants.drawings.dragPoints.END,
                start: {
                    x: eStartX,
                    y: eStartY
                },
                end: {
                    x: eStartX + ptWidth,
                    y: eStartY + ptWidth
                }
            }
        ];

        ct.beginPath();
        ct.lineWidth = 3;
        ct.strokeStyle = '#343a40';
        ct.setLineDash([]);
        _.each(this.dragPoints, function (point) {
            ct.clearRect(point.start.x, point.start.y, ptWidth, ptWidth);
            PJQ.helpers.canvasHelpers.drawRoundRect(ct, point.start.x, point.start.y, ptWidth, ptWidth, 4, false, true)
        });
    }
});

PJQ.models.drawings.Highlighter = PJQ.models.drawings.Pen.extend({
    getDisplayName: function () {
        return PJQ.constants.drawings.annotationTypeNames.HIGHLIGHTER;
    },
    stroke: function (ct, scale) {
        let strokeColor = this.getStrokeColor();
        if (strokeColor) {
            let ts = this.get('textSize');
            ct.lineWidth = Math.max(20, ts ? ts : 0) / scale;
            ct.setLineDash([0]);
            let rgb = PJQ.helpers.colorHelpers.getRGBFromHex(strokeColor);
            ct.strokeStyle = 'rgba(' + rgb.R.toString() + ',' + rgb.G.toString() + ',' + rgb.B.toString() + ', 0.5)';
            ct.stroke();
        }
    },
});

PJQ.models.drawings.Line = PJQ.models.drawings.Annotation.extend({
    getDisplayName: function () {
        return PJQ.constants.drawings.annotationTypeNames.LINE;
    },
    end: function (x, y, normalize = false) {
        this.set({
            end: {
                x: Math.round(x),
                y: Math.round(y)
            }
        });

        if (normalize) {
            this.normalizeCoords();
        }
    },
    collides: function (x, y) {
        let start = this.get('start'),
            end = this.get('end');

        if (start == null || end == null) {
            return false;
        }

        let dStart = PJQ.helpers.trigHelpers.distance(start.x, start.y, x, y),
            dEnd = PJQ.helpers.trigHelpers.distance(end.x, end.y, x, y),
            dComb = dStart + dEnd,
            lineLen = PJQ.helpers.trigHelpers.distance(start.x, start.y, end.x, end.y),
            buffer = 20;
        if (dComb >= lineLen - buffer && dComb <= lineLen + buffer) {
            return true;
        }
    },
    draw: function (ct, scale) {
        let coords = this.getCoords(scale);
        if (coords == null) {
            return;
        }

        ct.beginPath();
        ct.moveTo(coords.start.x, coords.start.y);
        ct.lineTo(coords.end.x, coords.end.y);

        this.stroke(ct, scale);
    },
    drawDragPoints: function (ct, scale) {
        let ptWidth = 15,
            coords = this.getCoords(scale),
            hfPtWidth = ptWidth / 2,
            sStartX = coords.start.x - hfPtWidth,
            sStartY = coords.start.y - hfPtWidth,
            eStartX = coords.end.x - hfPtWidth,
            eStartY = coords.end.y - hfPtWidth

        this.dragPoints = [
            {
                position: PJQ.constants.drawings.dragPoints.START,
                start: {
                    x: sStartX,
                    y: sStartY
                },
                end: {
                    x: sStartX + ptWidth,
                    y: sStartY + ptWidth
                }
            },
            {
                position: PJQ.constants.drawings.dragPoints.END,
                start: {
                    x: eStartX,
                    y: eStartY
                },
                end: {
                    x: eStartX + ptWidth,
                    y: eStartY + ptWidth
                }
            }
        ];

        ct.beginPath();
        ct.lineWidth = 3;
        ct.strokeStyle = '#343a40';
        ct.setLineDash([]);
        _.each(this.dragPoints, function (point) {
            ct.clearRect(point.start.x, point.start.y, ptWidth, ptWidth);
            PJQ.helpers.canvasHelpers.drawRoundRect(ct, point.start.x, point.start.y, ptWidth, ptWidth, 4, false, true)
        });
    }
});

PJQ.models.drawings.Arrow = PJQ.models.drawings.Line.extend({
    getDisplayName: function () {
        return PJQ.constants.drawings.annotationTypeNames.ARROW;
    },
    draw: function (ct, scale) {
        let coords = this.getCoords(scale);
        if (coords == null) {
            return;
        }

        let headLength = 100 / scale,
            dx = coords.end.x - coords.start.x,
            dy = coords.end.y - coords.start.y,
            angle = Math.atan2(dy, dx);

        ct.beginPath();
        ct.moveTo(coords.start.x, coords.start.y);
        ct.lineTo(coords.end.x, coords.end.y);

        ct.lineTo(coords.end.x - headLength * Math.cos(angle - Math.PI / 6), coords.end.y - headLength * Math.sin(angle - Math.PI / 6));

        ct.moveTo(coords.end.x, coords.end.y);
        ct.lineTo(coords.end.x - headLength * Math.cos(angle + Math.PI / 6), coords.end.y - headLength * Math.sin(angle + Math.PI / 6));

        this.stroke(ct, scale);
    }
});

PJQ.models.drawings.Rectangle = PJQ.models.drawings.Annotation.extend({
    getDisplayName: function () {
        return PJQ.constants.drawings.annotationTypeNames.RECTANGLE;
    },
    minWidth: 100,
    minHeight: 100,
    getNormalizedCoords: function () {
        let start = this.get('start'),
            end = this.get('end');
        if (start == null || end == null) {
            return null;
        }

        let result = {
            start: start,
            end: end
        };
        if (start.x > end.x && start.y > end.y) {
            // starts at bottom right - swap end/start points
            result = {
                start: end,
                end: start
            };
        } else if (start.y > end.y) {
            // starts at bottom left
            result = {
                start: {
                    x: start.x,
                    y: end.y
                },
                end: {
                    x: end.x,
                    y: start.y
                }
            };
        } else if (start.x > end.x) {
            // starts at top right
            result = {
                start: {
                    x: end.x,
                    y: start.y
                },
                end: {
                    x: start.x,
                    y: end.y
                }
            };
        }
        return result;
    },
    collides: function (x, y) {
        let start = this.get('start'),
            end = this.get('end');

        if (start == null || end == null) {
            return false;
        }

        return PJQ.helpers.trigHelpers.checkRectCollision(start, end, x, y);
    },
    draw: function (ct, scale) {
        let coords = this.getCoords(scale);
        if (coords == null) {
            return;
        }

        ct.beginPath();
        ct.rect(coords.start.x, coords.start.y, coords.width, coords.height);

        this.stroke(ct, scale);

        if (typeof this.drawLink === 'function') {
            this.drawLink(ct, scale);
        }
    },
    drawDragPoints: function (ct, scale) {
        let ptWidth = 16,
            margin = 10 / scale,
            coords = this.getCoords(scale),
            tlStartX = coords.start.x - ptWidth - margin,
            tlStartY = coords.start.y - ptWidth - margin,
            brStartX = coords.end.x + margin,
            brStartY = coords.end.y + margin,
            trStartX = coords.end.x + margin,
            trStartY = coords.start.y - ptWidth - margin,
            blStartX = coords.start.x - ptWidth - margin,
            blStartY = coords.end.y + margin;

        ct.beginPath();
        ct.rect(tlStartX + (ptWidth / 2), tlStartY + (ptWidth / 2), brStartX - tlStartX, brStartY - tlStartY);
        ct.setLineDash([6]);
        ct.lineWidth = 3;
        ct.strokeStyle = '#343a40';
        ct.stroke()

        this.dragPoints = [{
            position: PJQ.constants.drawings.dragPoints.TOP_LEFT,
            start: {
                x: tlStartX,
                y: tlStartY
            },
            end: {
                x: tlStartX + ptWidth,
                y: tlStartY + ptWidth
            }
        }, {
            position: PJQ.constants.drawings.dragPoints.BOTTOM_RIGHT,
            start: {
                x: brStartX,
                y: brStartY
            },
            end: {
                x: brStartX + ptWidth,
                y: brStartY + ptWidth
            }
        }, {
            position: PJQ.constants.drawings.dragPoints.TOP_RIGHT,
            start: {
                x: trStartX,
                y: trStartY
            },
            end: {
                x: trStartX + ptWidth,
                y: trStartY + ptWidth
            }
        }, {
            position: PJQ.constants.drawings.dragPoints.BOTTOM_LEFT,
            start: {
                x: blStartX,
                y: blStartY
            },
            end: {
                x: blStartX + ptWidth,
                y: blStartY + ptWidth
            }
        }];

        ct.beginPath();
        ct.lineWidth = 3;
        ct.strokeStyle = '#343a40';
        ct.setLineDash([]);
        _.each(this.dragPoints, function (point) {
            ct.clearRect(point.start.x, point.start.y, ptWidth, ptWidth);
            PJQ.helpers.canvasHelpers.drawRoundRect(ct, point.start.x, point.start.y, ptWidth, ptWidth, 4, false, true)
        });
    }
});

PJQ.models.drawings.Ellipse = PJQ.models.drawings.Rectangle.extend({
    getDisplayName: function () {
        return PJQ.constants.drawings.annotationTypeNames.ELLIPSE;
    },
    draw: function (ct, scale) {
        let coords = this.getCoords(scale);
        if (coords == null) {
            return;
        }

        let radiusX = (coords.end.x - coords.start.x) * 0.5,
            radiusY = (coords.end.y - coords.start.y) * 0.5,
            centerX = coords.start.x + radiusX,
            centerY = coords.start.y + radiusY,
            step = 0.01,
            a = step,
            pi2 = Math.PI * 2 - step;

        ct.beginPath();
        ct.moveTo(centerX + radiusX * Math.cos(0), centerY + radiusY * Math.sin(0));
        for (; a < pi2; a += step) {
            ct.lineTo(centerX + radiusX * Math.cos(a),
                centerY + radiusY * Math.sin(a));
        }
        ct.closePath();

        this.stroke(ct, scale);

        if (typeof this.drawLink === 'function') {
            this.drawLink(ct, scale);
        }
    }
});

PJQ.models.drawings.Cloud = PJQ.models.drawings.Rectangle.extend({
    getDisplayName: function () {
        return PJQ.constants.drawings.annotationTypeNames.CLOUD;
    },
    draw: function (ct, scale) {
        let coords = this.getCoords(scale);
        if (coords == null) {
            return;
        }

        let lastX = coords.start.x,
            lastY = coords.start.y,
            bumpWidth = 60 / scale,
            bumpWidthHalf = bumpWidth / 2,
            bumpHeight = bumpWidth / 3;

        ct.beginPath();
        ct.moveTo(lastX, lastY);
        while (lastX < coords.end.x) {
            if (lastX + bumpWidth > coords.end.x) {
                let thisBumpWidth = coords.end.x - lastX,
                    thisBumpHeight = (thisBumpWidth / bumpWidth) * bumpHeight;
                ct.bezierCurveTo(lastX + (thisBumpWidth / 2), lastY - thisBumpHeight, lastX + (thisBumpWidth / 2), lastY - thisBumpHeight, coords.end.x, lastY);
                lastX = coords.end.x;
            } else {
                ct.bezierCurveTo(lastX + bumpWidthHalf, lastY - bumpHeight, lastX + bumpWidthHalf, lastY - bumpHeight, lastX + bumpWidth, lastY);
                lastX += bumpWidth;
            }
        }
        while (lastY < coords.end.y) {
            if (lastY + bumpWidth > coords.end.y) {
                let thisBumpWidth = coords.end.y - lastY,
                    thisBumpHeight = (thisBumpWidth / bumpWidth) * bumpHeight;
                ct.bezierCurveTo(lastX + thisBumpHeight, lastY + (thisBumpWidth / 2), lastX + thisBumpHeight, lastY + (thisBumpWidth / 2), lastX, coords.end.y);
                lastY = coords.end.y;
            } else {
                ct.bezierCurveTo(lastX + bumpHeight, lastY + bumpWidthHalf, lastX + bumpHeight, lastY + bumpWidthHalf, lastX, lastY + bumpWidth);
                lastY += bumpWidth;
            }
        }
        while (lastX > coords.start.x) {
            if (lastX - bumpWidth < coords.start.x) {
                let thisBumpWidth = lastX - coords.start.x,
                    thisBumpHeight = (thisBumpWidth / bumpWidth) * bumpHeight;
                ct.bezierCurveTo(lastX - (thisBumpWidth / 2), lastY + thisBumpHeight, lastX - (thisBumpWidth / 2), lastY + thisBumpHeight, coords.start.x, lastY);
                lastX = coords.start.x;
            } else {
                ct.bezierCurveTo(lastX - bumpWidthHalf, lastY + bumpHeight, lastX - bumpWidthHalf, lastY + bumpHeight, lastX - bumpWidth, lastY);
                lastX -= bumpWidth;
            }
        }
        while (lastY > coords.start.y) {
            if (lastY - bumpWidth < coords.start.y) {
                let thisBumpWidth = lastY - coords.start.y,
                    thisBumpHeight = (thisBumpWidth / bumpWidth) * bumpHeight;
                ct.bezierCurveTo(lastX - thisBumpHeight, lastY - (thisBumpWidth / 2), lastX - thisBumpHeight, lastY - (thisBumpWidth / 2), lastX, coords.start.y);
                lastY = coords.start.y;
            } else {
                ct.bezierCurveTo(lastX - bumpHeight, lastY - bumpWidthHalf, lastX - bumpHeight, lastY - bumpWidthHalf, lastX, lastY - bumpWidth);
                lastY -= bumpWidth;
            }
        }
        ct.closePath();

        this.stroke(ct, scale);

        if (typeof this.drawLink === 'function') {
            this.drawLink(ct, scale);
        }
    }
});

PJQ.models.drawings.Text = PJQ.models.drawings.Rectangle.extend({
    beforeConstruct: function (attributes) {
        attributes.text = attributes.text != null ? attributes.text : "";
        attributes.textSize = attributes.textSize != null ? attributes.textSize : 100;
    },
    getDisplayName: function () {
        return PJQ.constants.drawings.annotationTypeNames.TEXT;
    },
    getTextSize: function (scale = 1) {
        let ts = this.get('textSize');
        return (60 * ((ts ? ts : 100) / 100) / scale);
    },
    draw: function (ct, scale, options = {}) {
        let coords = this.getCoords(scale);
        if (coords == null) {
            return;
        }

        let textSize = this.getTextSize(scale);
        ct.beginPath();
        ct.fillStyle = this.getStrokeColor();
        ct.font = textSize + 'px Roboto';

        // we start the y position at y + textsize because
        // the y coordinate of text is at the bottom of the characters
        let y = coords.start.y + textSize,
            words = this.attributes.text.split(' '),
            line = '';
        for (let n = 0; n < words.length; n++) {
            let testLine = line + words[n],
                metrics = ct.measureText(testLine + ' '),
                testWidth = metrics.width;
            if (testWidth > coords.width && n > 0) {
                ct.fillText(line, coords.start.x, y);
                line = words[n] + ' ';
                y += textSize;
            } else {
                line = testLine + ' ';
            }
        }
        ct.fillText(line, coords.start.x, y);

        if (options.isDrawing) {
            ct.beginPath();
            ct.rect(coords.start.x, coords.start.y, coords.width, coords.height);
            ct.setLineDash([6]);
            ct.lineWidth = 6 / scale;
            ct.strokeStyle = '#343a40';
            ct.stroke();
        }
    }
});

PJQ.models.drawings.Pin = PJQ.models.drawings.Annotation.extend({
    getDisplayName: function () {
        return "";
    },
    end: function (x, y) {
        PJQ.models.drawings.Annotation.prototype.end.call(this, x, y)
        return this.start(x, y);
    },
    move: function (xDiff, yDiff, maxX, maxY) {
        let newX = this.attributes.start.x + xDiff,
            newY = this.attributes.start.y + yDiff;
        if (newX < 0) {
            newX = 0;
        } else if (newX > maxX) {
            newX = maxX;
        }

        if (newY < 0) {
            newY = 0;
        } else if (newY > maxY) {
            newY = maxY;
        }

        this.end(newX, newY);
    },
    collides: function (x, y) {
        let start = this.get('start');
        if (start == null) {
            return false;
        }

        let isHf = this.getIconSize() / 2;
        return PJQ.helpers.trigHelpers.checkRectCollision({
            x: start.x - isHf,
            y: start.y - isHf
        }, {
            x: start.x + isHf,
            y: start.y + isHf
        }, x, y);
    },
    getIcon: function () {
        return "\uF041";
    },
    getIconSize: function (scale = 1) {
        return (80 / scale);
    },
    draw: function (ct, scale) {
        let coords = this.getCoords(scale);
        if (coords == null) {
            return;
        }

        let is = this.getIconSize(scale),
            isHf = is / 2,
            font = '900 ' + is + 'px "Font Awesome 5 Pro"';
        ct.beginPath();
        ct.font = font;
        ct.fillStyle = this.getStrokeColor();
        ct.fillText(this.getIcon(), coords.start.x - isHf, coords.start.y + isHf);
    }
});

PJQ.models.drawings.PinRFI = PJQ.models.drawings.Pin.extend({
    getDisplayName: function () {
        return PJQ.constants.drawings.annotationTypeNames.PIN_RFI;
    },
    getIcon: function () {
        return "\uF60b";
    }
});

PJQ.models.drawings.PinPunchListItem = PJQ.models.drawings.Pin.extend({
    getDisplayName: function () {
        let res = PJQ.constants.drawings.annotationTypeNames.PIN_PUNCH_LIST_ITEM;
        if (this.punchListItem != null) {
            res += ' #' + this.punchListItem.get('itemNumber');
        }
        return res
    },
    getIcon: function () {
        return "\uF606";
    },
    getStrokeColor: function () {
        if (this.punchListItem != null) {
            return this.punchListItem.getStatusColor();
        }
        return PJQ.models.drawings.Pin.prototype.getStrokeColor.call(this);
    },
    getFillColor: function () {
        if (this.punchListItem != null) {
            return this.punchListItem.getStatusColor() + '75';
        }
        return PJQ.models.drawings.Pin.prototype.getFillColor.call(this);
    },
    getDeepLink: function () {
        return this.punchListItem?.getDeepLink();
    },
    setPunchListItem: function (item) {
        this.set({
            refId: item.id,
            refType: PJQ.constants.drawings.refTypes.PUNCH_LIST_ITEM,
            refData: {
                id: item.id,
                title: item.get('title'),
                itemNumber: item.get('itemNumber'),
                status: item.get('status'),
            },
            isDirty: true
        });
        this.punchListItem = item;
    }
});

PJQ.models.drawings.PinActionItem = PJQ.models.drawings.Pin.extend({
    getDisplayName: function () {
        let res = PJQ.constants.drawings.annotationTypeNames.PIN_ACTION_ITEM;
        if (this.actionItem != null) {
            res += ' #' + this.actionItem.get('itemNumber');
        }
        return res
    },
    getIcon: function () {
        return "\uF608";
    },
    getStrokeColor: function () {
        if (this.actionItem != null) {
            return this.actionItem.getStatusColor();
        }
        return PJQ.models.drawings.Pin.prototype.getStrokeColor.call(this);
    },
    getFillColor: function () {
        if (this.actionItem != null) {
            return this.actionItem.getStatusColor() + '75';
        }
        return PJQ.models.drawings.Pin.prototype.getFillColor.call(this);
    },
    getDeepLink: function () {
        return this.actionItem?.getDeepLink();
    },
    setActionItem: function (item) {
        this.set({
            refId: item.id,
            refType: PJQ.constants.drawings.refTypes.ACTION_ITEM,
            refData: {
                id: item.id,
                title: item.get('title'),
                itemNumber: item.get('itemNumber'),
                status: item.get('status'),
            },
            isDirty: true
        });
        this.actionItem = item;
    },
});

PJQ.models.drawings.PinSubmittal = PJQ.models.drawings.Pin.extend({
    getDisplayName: function () {
        return PJQ.constants.drawings.annotationTypeNames.PIN_SUBMITTAL;
    },
    getIcon: function () {
        return "\uF041";
    }
});

PJQ.models.drawings.Photo = PJQ.models.drawings.Pin.extend({
    getDisplayName: function () {
        return PJQ.constants.drawings.annotationTypeNames.PHOTO;
    },
    getIcon: function () {
        return "\uF030";
    }
});

PJQ.models.drawings.LinkRectangle = PJQ.models.drawings.Rectangle.extend({
    getDisplayName: function () {
        return PJQ.constants.drawings.annotationTypeNames.LINK_RECTANGLE;
    },
    drawLink: function (ct, scale) {
        let coords = this.getCoords(scale);
        if (coords == null) {
            return null;
        }

        let is = (80 / scale),
            isHf = is / 2,
            font = '900 ' + is + 'px "Font Awesome 5 Pro"';
        document.fonts.load(font).then((_) => {
            ct.beginPath();
            ct.font = font;
            ct.fillStyle = this.getStrokeColor();
            ct.fillText("\uf0c1", coords.start.x + isHf, coords.end.y - isHf);
        })
    }
});

PJQ.models.drawings.LinkEllipse = PJQ.models.drawings.Ellipse.extend({
    getDisplayName: function () {
        return PJQ.constants.drawings.annotationTypeNames.LINK_ELLIPSE;
    },
    drawLink: function (ct, scale) {
        let coords = this.getCoords(scale);
        if (coords == null) {
            return null;
        }

        let is = (80 / scale),
            isHf = is / 2,
            font = '900 ' + is + 'px "Font Awesome 5 Pro"';
        document.fonts.load(font).then((_) => {
            let x = coords.start.x + (coords.width / 2),
                y = coords.end.y
            ct.beginPath();
            ct.font = font;
            ct.fillStyle = this.getStrokeColor();
            ct.fillText("\uf0c1", x - isHf, y - isHf);
        })
    }
});

PJQ.models.drawings.LinkCloud = PJQ.models.drawings.Cloud.extend({
    getDisplayName: function () {
        return PJQ.constants.drawings.annotationTypeNames.LINK_CLOUD;
    },
    drawLink: PJQ.models.drawings.LinkRectangle.prototype.drawLink
});

PJQ.models.drawings.Ruler = PJQ.models.drawings.Line.extend({
    getDisplayName: function () {
        return PJQ.constants.drawings.annotationTypeNames.RULER;
    },
    draw: function (ct, scale, options) {
        let coords = this.getCoords(scale);
        if (coords == null) {
            return;
        }

        // draw the line with a gap in the middle for the length text
        // to do this, we find 2 points offset "gap" pixels in either direction (scaled) from the center point of the line
        // we then draw 2 lines, 1 from the start to center offset 1 - the other from center offset 2 to the end
        let dx = coords.start.x - coords.end.x,
            dy = coords.start.y - coords.end.y,
            len = Math.sqrt(dx * dx + dy * dy) / 2,
            gap = Math.min(50, len / 4),
            textSize = (gap * 0.8) / scale,
            d1 = len - (gap / scale),
            d2 = len + (gap / scale),
            angle = Math.atan2(coords.end.y - coords.start.y, coords.end.x - coords.start.x),
            middle1 = {
                x: coords.start.x + d1 * Math.cos(angle),
                y: coords.start.y + d1 * Math.sin(angle)
            },
            middle2 = {
                x: coords.start.x + d2 * Math.cos(angle),
                y: coords.start.y + d2 * Math.sin(angle)
            };
        ct.beginPath();
        ct.moveTo(coords.start.x, coords.start.y);
        ct.lineTo(middle1.x, middle1.y);
        ct.moveTo(middle2.x, middle2.y);
        ct.lineTo(coords.end.x, coords.end.y);
        this.stroke(ct, scale);

        // write the ruler calculated length
        // we start the y position at y + textsize because
        // the y coordinate of text is at the bottom of the characters
        let rulerLength = this.getRulerLength(options.drawing.get('scale')),
            scaleType = options.drawing.get('scaleType'),
            rulerText = '';
        if (scaleType === PJQ.constants.drawings.scaleTypes.IMPERIAL) {
            let inches = rulerLength,
                feet = 0;
            if (inches > 12) {
                feet = Math.floor(inches / 12);
                rulerText = feet.toString() + "' " + (inches % 12).toString() + "\"";
            } else {
                rulerText = inches.toString() + "\"";
            }
        } else {

        }

        ct.beginPath();
        ct.fillStyle = this.getStrokeColor();
        ct.font = textSize + 'px Roboto';
        ct.fillText(rulerText, middle1.x, middle1.y);
    },
    getRulerLength: function (scale) {
        let start = this.get('start'),
            end = this.get('end'),
            dx = end.x - start.x,
            dy = end.y - start.y,
            d = Math.sqrt(dx * dx + dy * dy);
        return Math.round(d / scale);
    }
});

PJQ.models.drawings.AreaRectangle = PJQ.models.drawings.Rectangle.extend({
    getDisplayName: function () {
        return PJQ.constants.drawings.annotationTypeNames.AREA_RECT;
    }
});

PJQ.models.drawings.RulerFreeForm = PJQ.models.drawings.Pen.extend({
    getDisplayName: function () {
        return PJQ.constants.drawings.annotationTypeNames.RULER_FREE_FORM;
    }
});

PJQ.models.drawings.AreaFreeForm = PJQ.models.drawings.Pen.extend({
    getDisplayName: function () {
        return PJQ.constants.drawings.annotationTypeNames.AREA_FREE_FORM;
    }
});

PJQ.models.drawings.AnnotationAttachment = PJQ.models.files.File.extend({
    idAttribute: 'attachmentId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'drawings'
            },
            {
                endpoint: 'annotations',
                value: this.get('annotationId')
            },
            {
                endpoint: 'attachments',
                value: this.id
            }
        ]);
    }
});

PJQ.collections.drawings.Layers = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.drawings.Layer,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.projectId
            },
            {
                endpoint: 'layers'
            }
        ]);
    },
    fetchAnnotations: function (drawingId, callback) {
        if (_.indexOf(this.fetchedDrawingIds, drawingId) === -1) {
            if (this.fetchedDrawingIds == null) {
                this.fetchedDrawingIds = [drawingId];
            } else {
                this.fetchedDrawingIds.push(drawingId);
            }
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'drawings',
                        value: drawingId
                    },
                    {
                        endpoint: 'annotations'
                    }
                ])
            }).get().done(_.bind(function (annotations) {
                _.each(annotations, function (annotation) {
                    let layer = this.get(annotation.layerId);
                    if (layer != null) {
                        layer.annotations.add(annotation);
                    }
                }, this);
                callback();
            }, this)).fail(_.bind(function () {
                callback();
            }, this));
        } else {
            callback();
        }
    }
});

PJQ.collections.drawings.Annotations = PJQ.collections.BaseCollection.extend({
    afterInit: function () {
        if (PJQ.helpers.objectHelpers.checkNested(PJQ.app, 'session', 'preferences')) {
            this.options.isAPIv2 = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_DRAWING_ANNOTATION_REFS);
        }
    },
    model: function (attrs, options) {
        let mod;
        switch (attrs.type.toUpperCase()) {
            case PJQ.constants.drawings.annotationTypes.LINE:
                mod = PJQ.models.drawings.Line;
                break;
            case PJQ.constants.drawings.annotationTypes.PEN:
                mod = PJQ.models.drawings.Pen;
                break;
            case PJQ.constants.drawings.annotationTypes.HIGHLIGHTER:
                mod = PJQ.models.drawings.Highlighter;
                break;
            case PJQ.constants.drawings.annotationTypes.ARROW:
                mod = PJQ.models.drawings.Arrow;
                break;
            case PJQ.constants.drawings.annotationTypes.RECTANGLE:
                mod = PJQ.models.drawings.Rectangle;
                break;
            case PJQ.constants.drawings.annotationTypes.ELLIPSE:
                mod = PJQ.models.drawings.Ellipse;
                break;
            case PJQ.constants.drawings.annotationTypes.CLOUD:
                mod = PJQ.models.drawings.Cloud;
                break;
            case PJQ.constants.drawings.annotationTypes.LINK_RECTANGLE:
                mod = PJQ.models.drawings.LinkRectangle;
                break;
            case PJQ.constants.drawings.annotationTypes.LINK_ELLIPSE:
                mod = PJQ.models.drawings.LinkEllipse;
                break;
            case PJQ.constants.drawings.annotationTypes.LINK_CLOUD:
                mod = PJQ.models.drawings.LinkCloud;
                break;
            case PJQ.constants.drawings.annotationTypes.TEXT:
                mod = PJQ.models.drawings.Text;
                break;
            case PJQ.constants.drawings.annotationTypes.PHOTO:
                mod = PJQ.models.drawings.Photo;
                break;
            case PJQ.constants.drawings.annotationTypes.RULER:
                mod = PJQ.models.drawings.Ruler;
                break;
            case PJQ.constants.drawings.annotationTypes.AREA_RECT:
                mod = PJQ.models.drawings.AreaRectangle;
                break;
            case PJQ.constants.drawings.annotationTypes.RULER_FREE_FORM:
                mod = PJQ.models.drawings.RulerFreeForm;
                break;
            case PJQ.constants.drawings.annotationTypes.AREA_FREE_FORM:
                mod = PJQ.models.drawings.AreaFreeForm;
                break;
            case PJQ.constants.drawings.annotationTypes.PIN_RFI:
                mod = PJQ.models.drawings.PinRFI;
                break;
            case PJQ.constants.drawings.annotationTypes.PIN_PUNCH_LIST_ITEM:
                mod = PJQ.models.drawings.PinPunchListItem;
                break;
            case PJQ.constants.drawings.annotationTypes.PIN_ACTION_ITEM:
                mod = PJQ.models.drawings.PinActionItem;
                break;
            case PJQ.constants.drawings.annotationTypes.PIN_SUBMITTAL:
                mod = PJQ.models.drawings.PinSubmittal;
                break;
            default:
                mod = PJQ.models.drawings.Annotation;
                break;
        }
        return new mod(attrs, options)
    },
    merge: function (mergeAnnotations, contextId) {
        let fnMerge = (annotation) => {
            if ((contextId == null || annotation.get('contextId') === contextId) && (this.options.drawingId == null || this.options.drawingId === annotation.get('drawingId'))) {
                if (annotation.id > 0) {
                    let exist = this.findWhere({annotationId: annotation.id});
                    if (exist != null) {
                        this.remove(exist.cid);
                    }
                }
                this.add(annotation);
            }
        }
        if (PJQ.helpers.objectHelpers.refinedType(mergeAnnotations) === 'array') {
            _.each(mergeAnnotations, (annotation) => {
                fnMerge(annotation);
            });
        } else {
            fnMerge(mergeAnnotations);
        }
    },
    endpoint: function (options) {
        if (!options) {
            options = {};
        }

        options.isAPIv2 = this.options.isAPIv2 = [PJQ.constants.drawings.annotationTypes.PIN_RFI,
            PJQ.constants.drawings.annotationTypes.PIN_PUNCH_LIST_ITEM,
            PJQ.constants.drawings.annotationTypes.PIN_ACTION_ITEM,
            PJQ.constants.drawings.annotationTypes.PIN_SUBMITTAL].indexOf(this.get('type')) !== -1;

        let params;
        if (_.size(this.options.context) > 0 && this.options.contextId > 0) {
            params = [{
                parameter: 'context',
                value: this.options.context
            }, {
                parameter: 'contextId',
                value: this.options.contextId
            }];
        } else {
            params = [];
        }

        if (this.options.accessKey != null) {
            params.push({
                parameter: 'accessKey',
                value: this.options.accessKey
            });
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'drawings',
                value: this.options.drawingId
            },
            {
                endpoint: 'annotations'
            }
        ], params);
    },
    saveAll: function (callback) {
        let annotationsMap = {};
        _.each(this.models, (annotation) => {
            if (annotationsMap[annotation.get('drawingId')] == null) {
                annotationsMap[annotation.get('drawingId')] = [];
            }
            annotation.beforeSave();
            annotationsMap[annotation.get('drawingId')].push(annotation);
        });

        let saveAnnotations = _.map(annotationsMap, function (annotations) {
            return annotations;
        });
        let changedCt = _.size(saveAnnotations),
            saveNextAnnotation = (i) => {
                if (changedCt < i + 1) {
                    if (typeof callback === 'function') {
                        callback();
                    }
                    return;
                }
                let thisSet = saveAnnotations[i];
                if (_.size(thisSet) > 0) {
                    let drawingId = thisSet[0].get('drawingId');
                    new PJQ.ajax.Request({
                        endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                            {
                                endpoint: 'drawings',
                                value: drawingId
                            },
                            {
                                endpoint: 'annotations'
                            }
                        ]),
                        data: thisSet
                    }).put().done(_.bind(function (response) {
                        saveNextAnnotation(i + 1);
                    }, this));
                } else {
                    saveNextAnnotation(i + 1);
                }
            };
        saveNextAnnotation(0);
    }
});

PJQ.collections.drawings.AnnotationAttachments = PJQ.collections.files.Files.extend({
    model: PJQ.models.drawings.AnnotationAttachment
});
PJQ.views.drawings.EditAnnotation = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DRAWINGS, 'annotation-edit'),
        subTemplates: {
            textSizePicker: new PJQ.templating.Template(PJQ.constants.modules.DRAWINGS, 'text-size-picker')
        },
        focusText: false,
        isEditLink: false,
        onShapeChange: null,
        onPublish: null,
        canEdit: false,
        onDelete: null,
        onClose: null,
        onAnnotationDataChange: null,
        onAttachmentChange: null,
        onDrawingSelected: null
    },
    events: {
        "click .text-size-picker>button": "textSizeClicked",
        "click .version-drawing-outer": "drawingClicked",
        "click .btn-edit-link": "editLink",
        "click .btn-save-link": "saveLink",
        "click .btn-cancel-link": "cancelEditLink",
        "click .view-punch-list-item": "viewPunchListItemClicked",
        "click .view-action-item": "viewActionItemClicked",
        "click .btn-publish-annotation": "publish",
        "click .btn-delete-annotation": "delete",
        "click .btn-close-annotation": "close"
    },
    beforeFirstRender: function () {
        let type = this.model.get('type');
        if (type === PJQ.constants.drawings.annotationTypes.LINK_RECTANGLE || type === PJQ.constants.drawings.annotationTypes.LINK_ELLIPSE || type === PJQ.constants.drawings.annotationTypes.LINK_CLOUD) {
            if (this.model.get('refType') == null) {
                this.model.set('refType', PJQ.constants.drawings.refTypes.DRAWING);
            }
        }
    },
    renderData: function () {
        return {
            model: this.model,
            versions: this.options.versions,
            context: this.options.context,
            isEditLink: this.options.isEditLink,
            canEdit: this.options.canEdit,
            isAdmin: this.options.isAdmin
        };
    },
    afterRender: function () {
        let type = this.model.get('type');
        if (type === PJQ.constants.drawings.annotationTypes.LINK_RECTANGLE || type === PJQ.constants.drawings.annotationTypes.LINK_ELLIPSE || type === PJQ.constants.drawings.annotationTypes.LINK_CLOUD) {
            new PJQ.inputs.Selectpicker({
                el: this.$('.select-link-ref-type'),
                defaultValue: this.model.get('refType'),
                onChange: _.bind(function (value) {
                    this.model.set('refType', value);
                    this.render();
                }, this)
            });

            let choices = _.map(_.sortBy(this.options.versions.getUniqueDrawings(), (drawing) => {
                return drawing.get('sortOrder');
            }), (drawing) => {
                return {
                    id: drawing.id,
                    name: drawing.get('name')
                };
            });
            this.refIdPicker = new PJQ.inputs.Selectpicker({
                el: this.$('.select-link-ref-id'),
                defaultValue: this.model.get('refId'),
                isIntChoices: true,
                isLiveSearch: true,
                choices: choices,
                size: 15,
                onChange: _.bind(function (value) {
                    if (value > 0 && this.model.get('refId') == null) {
                        this.model.set('refId', value);
                        this.render();
                        this.onAnnotationDataChange();
                    }
                }, this)
            });
        } else if (type === PJQ.constants.drawings.annotationTypes.PHOTO) {
            this.fileUploader = new PJQ.views.files.FileUploaderGrid({
                el: this.$('.annotation-file-uploader'),
                collection: this.model.attachments,
                previewImageDimension: 140,
                canUpload: this.options.canEdit,
                canDelete: this.options.canEdit,
                onSuccess: _.bind(function () {
                    if (typeof this.options.onAttachmentChange === 'function') {
                        this.options.onAttachmentChange(this.model);
                    }
                }, this),
                onDelete: _.bind(function (attachment, callback) {
                    if (attachment.id > 0) {
                        attachment.set('isDeleted', true);
                    } else {
                        this.model.attachments.remove(attachment);
                    }
                    this.model.isDirty = true;

                    attachment.set('drawingId', this.model.id);
                    if (typeof this.options.onAttachmentChange === 'function') {
                        this.options.onAttachmentChange(this.model);
                    }
                    callback();
                }, this)
            });
        } else if (type === PJQ.constants.drawings.annotationTypes.TEXT) {
            this.renderTextSizePicker();

            if (this.options.focusText) {
                this.$('.input-annotation-text').focus();
            }
        } else if (type === PJQ.constants.drawings.annotationTypes.PIN_PUNCH_LIST_ITEM) {
            this.renderPunchListDetails();
        } else if (type === PJQ.constants.drawings.annotationTypes.PIN_ACTION_ITEM) {
            this.renderActionItemDetails();
        }

        new PJQ.Binder(this.$el, this.model, {
            watchElements: [
                'input',
                'textarea'
            ],
            afterChange: _.bind(function (_, attribute) {
                if (attribute === 'text') {
                    this.onShapeChange();
                } else {
                    this.onAnnotationDataChange();
                }
            }, this)
        });
    },
    editLink: function (e) {
        e.stopPropagation();
        this.options.isEditLink = true;
        this.render();
    },
    saveLink: function () {
        this.model.set('refId', this.refIdPicker.getValue());
        this.onAnnotationDataChange();
        this.cancelEditLink();
    },
    cancelEditLink: function () {
        this.options.isEditLink = false;
        this.render();
    },
    drawingClicked: function () {
        if (typeof this.options.onDrawingSelected === 'function') {
            let drawing = this.options.versions.getDrawing(this.model.get('refId'));
            if (drawing != null) {
                this.options.onDrawingSelected(drawing);
            }
        }
    },
    renderPunchListDetails: function () {
        let canAdd = this.options.project.permissions.hasPermission('punchList.canAdd'),
            choices,
            fnMapItems = () => {
                let items = _.map(this.punchListItems.models, (punchListItem) => {
                    return {
                        id: punchListItem.id,
                        name: '<strong>' + punchListItem.get('itemNumber') + '</strong>' + " - " + punchListItem.get('title')
                    };
                });
                if (!canAdd) {
                    return items;
                }

                return [
                    {
                        name: '',
                        choices: [
                            {
                                id: 0,
                                name: '<i class="fal fa-plus mr-1"></i>New Item'
                            }
                        ]
                    },
                    {
                        name: '',
                        choices: items
                    }
                ];
            }

        if (!(this.model.get('refId') > 0)) {
            if (this.punchListItems != null) {
                choices = fnMapItems();
            } else {
                choices = [];
            }

            let $selectItem = this.$('.select-punch-list-item'),
                punchListItemSelect = new PJQ.inputs.Selectpicker({
                    el: $selectItem,
                    isLiveSearch: true,
                    choices: choices,
                    isIntChoices: true,
                    pickerWidth: '275px',
                    onChange: (value) => {
                        if (value === 0) {
                            punchListItemSelect.setValue(null);
                            this.newPunchListItem();
                            return;
                        }

                        let item = this.punchListItems.get(value);
                        if (item == null) {
                            return;
                        }

                        this.model.setPunchListItem(item);
                        this.render();
                        this.onAnnotationDataChange();
                    }
                });

            let fnUpdateChoices = () => {
                punchListItemSelect.updateChoices(fnMapItems());
                setTimeout(() => {
                    punchListItemSelect.toggle();
                }, 100);
            };
            if (this.punchListItems != null) {
                fnUpdateChoices();
            } else {
                let loader = new PJQ.Loader($selectItem);
                this.options.project.fetchPunchListItems((punchListItems) => {
                    loader.remove();
                    this.punchListItems = punchListItems;
                    fnUpdateChoices();
                });
            }
        }
    },
    newPunchListItem: function () {
        let newItem = new PJQ.models.punchlists.PunchlistItem({
            projectId: this.options.project ? this.options.project.id : null
        });
        this.viewPunchListItem(newItem);
    },
    viewPunchListItemClicked: function (e) {
        let target = $(e.currentTarget),
            id = target.data('id'),
            item = this.model.punchListItem;
        if (item == null) {
            item = new PJQ.models.punchlists.PunchlistItem({
                id: id
            })
        }
        this.viewPunchListItem(item);
    },
    viewPunchListItem: function (item) {
        new PJQ.views.punchlists.PunchlistItemEditorModal({
            model: item,
            collection: this.punchListItems,
            project: this.options.project,
            onSave: () => {
                this.model.setPunchListItem(item);
                this.render();
                this.onAnnotationDataChange();
            }
        });
    },
    renderActionItemDetails: function () {
        let canAdd = this.options.project.permissions.hasPermission('actionItems.canAdd'),
            choices,
            fnMapItems = () => {
                let items = _.map(this.actionItems.models, (actionItem) => {
                    return {
                        id: actionItem.id,
                        name: '<strong>' + actionItem.get('itemNumber') + '</strong>' + " - " + actionItem.get('title')
                    };
                });
                if (!canAdd) {
                    return items;
                }

                return [
                    {
                        name: '',
                        choices: [
                            {
                                id: 0,
                                name: '<i class="fal fa-plus mr-1"></i>New Item'
                            }
                        ]
                    },
                    {
                        name: '',
                        choices: items
                    }
                ];
            }

        if (this.model.actionItem == null) {
            if (this.actionItems != null) {
                choices = fnMapItems();
            } else {
                choices = [];
            }

            let $selectItem = this.$('.select-action-item'),
                actionItemSelect = new PJQ.inputs.Selectpicker({
                    el: $selectItem,
                    isLiveSearch: true,
                    choices: choices,
                    isIntChoices: true,
                    pickerWidth: '275px',
                    onChange: (value) => {
                        if (value === 0) {
                            actionItemSelect.setValue(null);
                            this.newActionItem();
                            return;
                        }

                        let item = this.actionItems.get(value);
                        if (item == null) {
                            return;
                        }

                        this.model.setActionItem(item);
                        this.render();
                        this.onAnnotationDataChange();
                    }
                });

            let fnUpdateChoices = () => {
                actionItemSelect.updateChoices(fnMapItems());
                setTimeout(() => {
                    actionItemSelect.toggle();
                }, 100);
            };
            if (this.actionItems != null) {
                fnUpdateChoices();
            } else {
                let loader = new PJQ.Loader($selectItem);
                this.options.project.fetchActionItems((actionItems) => {
                    loader.remove();
                    this.actionItems = actionItems;
                    fnUpdateChoices();
                });
            }
        }
    },
    newActionItem: function () {
        let newItem = new PJQ.models.actionItems.ActionItem({
            projectId: this.options.project ? this.options.project.id : null
        });
        this.viewActionItem(newItem);
    },
    viewActionItemClicked: function (e) {
        let target = $(e.currentTarget),
            id = target.data('id'),
            item = this.model.actionItem
        if (item == null) {
            item = new PJQ.models.actionItems.ActionItem({
                id: id
            })
        }
        this.viewActionItem(item);
    },
    viewActionItem: function (item) {
        new PJQ.views.actionItems.ActionItemEditorModal({
            model: item,
            collection: this.actionItems,
            project: this.options.project,
            onSave: () => {
                this.model.setActionItem(item);
                this.render();
                this.onAnnotationDataChange();
            }
        });
    },
    renderTextSizePicker: function () {
        this.renderSubTemplate(false, this.options.subTemplates.textSizePicker, this.$('.text-size-outer'), {
            textSize: this.model.get('textSize')
        });
    },
    textSizeClicked: function (e) {
        e.stopPropagation();
        this.model.set('textSize', parseInt($(e.currentTarget).data('textSize')));
        this.renderTextSizePicker();
        this.onShapeChange();
    },
    onAnnotationDataChange: function () {
        if (typeof this.options.onAnnotationDataChange === 'function') {
            this.options.onAnnotationDataChange(this.model);
        }
    },
    onShapeChange: function () {
        if (typeof this.options.onShapeChange === 'function') {
            this.options.onShapeChange(this.model);
        }
    },
    publish: function () {
        if (typeof this.options.onPublish === 'function') {
            this.options.onPublish(this.model);
        }
        this.render();
    },
    delete: function () {
        if (typeof this.options.onDelete === 'function') {
            this.options.onDelete(this.model);
        }
        this.close();
    },
    close: function () {
        this.remove();
        if (typeof this.options.onClose === 'function') {
            this.options.onClose(this.model);
        }
    }
});


PJQ.views.drawings.DrawingBatchModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DRAWINGS, 'Modal-New-Drawing-Batch'),
        step: 1,
        subTemplates: {
            batchHeader: new PJQ.templating.Template(PJQ.constants.modules.DRAWINGS, 'Drawing-Batch-Header'),
            drawingTags: new PJQ.templating.Template(PJQ.constants.modules.DRAWINGS, 'Drawing-Tags'),
            drawingDetailHeader: new PJQ.templating.Template(PJQ.constants.modules.DRAWINGS, 'Upload-Drawing-Detail-Header'),
            sortDrawings: new PJQ.templating.Template(PJQ.constants.modules.DRAWINGS, 'Sort-Drawings')
        },
        isShowCloseButton: true
    },
    events: {
        'click .btn-next-step': 'nextStep',
        'click .btn-prev-step': 'previousStep',
        'change .checkbox-new-version': 'useNewVersion',
        'change .checkbox-existing-version': 'useExistingVersion',
        'click .existing-version': 'existingVersionSelected',
        'keyup .input-version-name': 'versionNameChanged',
        'click .select-batch-drawing': 'viewBatchDrawing',
        'click .btn-drawing-rotate-90': 'rotateBatchDrawing90Clicked',
        'click .btn-drawing-rotate-180': 'rotateBatchDrawing180Clicked',
        'click .btn-drawing-rotate-270': 'rotateBatchDrawing270Clicked',
        'click .btn-drawing-delete': 'deleteBatchDrawing',
        'click .btn-save': 'save',
        'click .btn-publish': 'publish',
        'click .btn-cancel': 'cancel',
        'click .btn-close': 'closeModal',
        'blur .input-drawing-name,.input-drawing-title,.input-drawing-tag': 'drawingBlur',
        'focus .input-drawing-name,.input-drawing-title,.input-drawing-tag': 'drawingFocus',
        'keydown .input-drawing-name': 'drawingNameKeydown',
        'keyup .input-drawing-name': 'drawingNameChanged',
        'keydown .input-drawing-title': 'drawingTitleKeydown',
        'keyup .input-drawing-title': 'drawingTitleChanged',
        'keydown .input-drawing-tag': 'drawingTagKeydown',
        'keyup .input-drawing-tag': 'drawingTagChanged',
        'click .btn-add-drawing-tag': 'addDrawingTagClicked',
        'click .btn-delete-tag': 'deleteTagClicked',
        'click .btn-upload-log': 'viewUploadLog',
        'change .checkbox-add-current-set': 'addToCurrentSetChanged',
        'change .checkbox-add-all-current-set': 'addAllToCurrentSetChanged',
        'change .checkbox-replace-current-set': 'replaceCurrentSetChanged',
        'change .cb-replace-existing-drawing': 'replaceExistingDrawingChanged',
        'click .btn-highlight-area': 'highlightArea'
    },
    highlightArea: function (e) {
        let drawing = this.model.drawings.models[0];
        new PJQ.views.drawings.DrawingAreaHighlight({
            model: drawing,
            batch: this.model,
            versions: this.options.versions,
            onSave: _.bind(function (result) {
                this.model.set({
                    nameArea: result.layers.name,
                    titleArea: result.layers.title
                });
                this.model.patch(this.model.attributes, {
                    success: _.bind(function () {
                        this.options.step = 3;
                        this.render();
                    }, this)
                });
            }, this)
        });
    },
    beforeModalCreated: function () {
        if (this.model == null) {
            this.model = new PJQ.models.drawings.DrawingBatch({
                projectId: this.options.project.id
            });

            if (this.options.version != null) {
                this.model.version = this.options.version;
                this.options.step = 2;
            }
        } else if (this.model.id > 0) {
            // we are continuing an existing upload
            this.options.step = 4;
            this.model.fetch({
                success: _.bind(function () {
                    this.setCurrentSetDefaults();
                    this.render();
                }, this)
            });
        }
    },
    setCurrentSetDefaults: function () {
        this.options.currentSetDefault = !PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.DRAWINGS_CURRENT_SET_DEFAULT_OFF);
        if (this.model) {
            _.each(this.model.drawings.models, function (drawing) {
                drawing.set("isCurrentSet", this.options.currentSetDefault);
            }, this);
        }
    },
    beforeRender: function () {
        this.options.fitHeight = this.options.step === 5;

        if (this.options.step === 4) {
            let publishedIds = [];
            _.each(this.model.drawings.models, function (drawing) {
                if (drawing.get('isPublished')) {
                    publishedIds.push(drawing.id);
                }
            });
            this.model.drawings.remove(publishedIds);
        }
    },
    getWidth: function () {
        let result;
        if (this.options.step === 4) {
            result = {
                minWidth: 400,
                maxWidth: '80%',
                width: 1200
            };
        } else {
            result = {
                minWidth: 600,
                maxWidth: this.options.maxWidth,
                width: this.options.width
            };
        }
        return result;
    },
    renderData: function () {
        return {
            model: this.model,
            versions: this.options.versions,
            step: this.options.step
        };
    },
    afterRender: function () {
        switch (this.options.step) {
            case 1:
                this.initVersionSelect();
                break;
            case 2:
                this.initFileUpload();
                break;
            case 3:
                this.initBatchWait();
                break;
            case 4:
                if (this.model.isFetched) {
                    this.initBatchPublish();
                }
                break;
            case 5:
                this.initBatchSort();
                break;
        }
    },
    initVersionSelect: function () {
        this.$(".input-version-name").focus();
        new PJQ.inputs.Datepicker({
            el: this.$('.input-version-date-issued'),
            isShowTimezone: false,
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE
            },
            onChange: _.bind(function (newDate) {
                this.model.version.set('issuedOn', newDate);
                this.validateNewVersion();
            }, this)
        });
        this.useNewVersion();
    },
    initFileUpload: function () {
        this.fileUploader = new PJQ.views.files.FileUploaderGrid({
            el: this.$('.version-file-uploader'),
            collection: this.model.uploads,
            allowedExtensions: ['pdf', 'tif', 'tiff'],
            style: 'list',
            onSuccess: _.bind(this.dataChanged, this),
            onFileStatusChange: _.bind(this.dataChanged, this),
            onDrop: _.bind(this.dataChanged, this),
            afterDelete: _.bind(this.dataChanged, this)
        });
    },
    dataChanged: function () {
        let uploadCount = _.size(this.model.uploads.models),
            hasUploads = uploadCount > 0,
            queued = 0,
            uploading = 0,
            success = 0;
        _.each(this.model.uploads.models, function (upload) {
            switch (upload.get('status')) {
                case 'queued':
                    queued++;
                    break;
                case 'uploading':
                    uploading++;
                    break;
                case 'success':
                    success++;
                    break;
            }

            let $queued = $('<span class="text-primary mr-2">Queued: ' + queued.toString() + '</span>');
            if (queued === 0) {
                $queued.addClass('op-6 font-weight-light');
            }

            let $uploaded = $('<span class="text-orange mr-2">Uploading: ' + uploading.toString() + '</span>');
            if (uploading === 0) {
                $uploaded.addClass('op-6 font-weight-light');
            }


            let $success = $('<span class="text-success">Uploaded: ' + success.toString() + '</span>');
            if (success === 0) {
                $success.addClass('op-6 font-weight-light');
            }

            this.$('.upload-files-status').empty().append([$queued, $uploaded, $success]);
        }, this);
        this.$('.btn-next-step').prop('disabled', !hasUploads || this.fileUploader.isUploading());
    },
    initBatchWait: function () {
        if (this.model.get('status') === 0 || this.model.get('status') === 1) {
            this.checkBatchStatus();
        } else {
            this.options.step++;
            this.render();
        }
    },
    initBatchPublish: function () {
        this.refreshTags();

        this.drawingVersionCounts = {};
        this.fullSet = null;

        _.each(_.filter(this.model.drawings.models, _.bind(function (drawing) {
            return !drawing.get('isPublished');
        }), this), _.bind(function (drawing) {

            if (_.size(drawing.get('name')) > 0 && _.size(drawing.get('tags')) == 0) {
                let matchedDrawing = null;
                _.each(this.options.versions.models, function (version) {
                    if (matchedDrawing == null) {
                        _.each(version.drawings.models, function (model) {
                            if (model.get('name') === drawing.get('name') && matchedDrawing == null && _.size(model.get('tags')) > 0) {
                                matchedDrawing = model;
                                drawing.set('tags', matchedDrawing.get('tags'));
                            }
                        });
                    }
                });
            }

            this.renderBatchDrawing(drawing);
        }, this));
        this.renderBatchDrawingAutoCompletes();

        this.renderReplaceCurrentSet();

        PJQ.app.lazyLoad().update();
    },
    renderBatchDrawingAutoCompletes: function () {
        new PJQ.inputs.AutocompleteInput({
            el: this.$('.input-drawing-name'),
            onSelect: (sel) => {
                this.drawingNameChanged(sel.e);
            },
            source: (req, res) => {
                if (_.size(req.term) === 0) {
                    return [];
                }
                res(_.filter(this.names, function (name) {
                    if (name.toLowerCase().indexOf(req.term.toLowerCase()) !== -1) {
                        return name;
                    }
                }));
            }
        });

        if (!PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DRAWING_HIDE_TAG)) {
            new PJQ.inputs.AutocompleteInput({
                el: this.$('.input-drawing-tag'),
                source: _.bind(function (req, res) {
                    if (_.size(req.term) === 0) {
                        return [];
                    }
                    res(_.filter(this.options.tags, function (tag) {
                        if (tag.toLowerCase().indexOf(req.term.toLowerCase()) !== -1) {
                            return tag;
                        }
                    }));
                }, this)
            });
        }
    },
    getBatchDrawingElement: function (drawing) {
        return this.$('.batch-drawing[data-cid="' + drawing.cid + '"]')
    },
    renderBatchDrawing: function (drawing) {
        if (this.fullSet == null) {
            this.fullSet = this.options.versions.getUniqueDrawings();
            this.names = [];
            _.each(this.fullSet, _.bind(function (fullSetDrawing) {
                let drawingName = fullSetDrawing.get('name');
                if (this.names.indexOf(drawingName) === -1) {
                    this.names.push(drawingName);
                }
            }, this));
        }

        let $drawing = this.getBatchDrawingElement(drawing),
            $header = $drawing.find('.drawing-details-header');

        let inCurrentSet = false,
            curSet = this.options.versions.get(-1);
        if (curSet != null) {
            inCurrentSet = curSet.drawings.findWhere({name: drawing.get('name')}) != null;
        }
        this.drawingVersionCounts[drawing.cid] = this.options.versions.getVersionStatsForDrawing(drawing);
        if (!this.drawingVersionCounts[drawing.cid].same) {
            drawing.set('keepExisting', false);
        }

        this.renderSubTemplate(false, this.options.subTemplates.drawingDetailHeader, $header, {
            inCurrentSet: inCurrentSet,
            versionCount: this.drawingVersionCounts[drawing.cid],
            drawing: drawing
        });

        this.renderDrawingTags(drawing);

        this.renderBatchHeader();
    },
    renderBatchHeader: function () {
        let newCount = 0,
            revisedCount = 0;
        _.each(this.drawingVersionCounts, function (count, cid) {
            let drawing = this.model.drawings.get(cid);
            if (drawing == null || drawing.get('isDeleted')) {
                return;
            }

            if (count.older + count.newer > 0) {
                revisedCount++;
            } else {
                newCount++;
            }
        }, this);
        this.renderSubTemplate(false, this.options.subTemplates.batchHeader, this.$('.batch-header'), {
            currentSetDefault: this.options.currentSetDefault,
            replaceCurrentSet: this.model.get('replaceCurrentSet'),
            newCount: newCount,
            revisedCount: revisedCount,
            totalCount: newCount + revisedCount
        });
    },
    initBatchSort: function () {
        this.sortDrawingsView = new PJQ.views.drawings.SortDrawings({
            el: this.$('.sort-drawings'),
            batch: this.model,
            versions: this.options.versions,
            afterRender: () => {
                this.$('.drawings-sort').css('height', parseInt(this.$('.modal-body').css('min-height')) - 220);
            }
        });
    },
    checkBatchStatus: function () {
        this.model.fetchStatus(_.bind(function (status) {
            if (status === 0 || status === 1) {
                this.model.statusTimeout = setTimeout(_.bind(function () {
                    this.checkBatchStatus();
                }, this), 2000);
            } else {
                this.model.fetch({
                    success: _.bind(function () {
                        this.setCurrentSetDefaults();
                        this.render();
                    }, this)
                });
            }
        }, this));
    },
    viewUploadLog: function () {
        this.close();
        new PJQ.views.drawings.DrawingUploadLogModal({
            project: this.options.project,
            versions: this.options.versions
        });
    },
    validateNewVersion: function (onSave = false) {
        let $name = this.$('.input-version-name'),
            versionNameExists = false,
            isNameValid = !onSave || _.size(this.model.version.get('name')) > 0,
            $issuedOn = this.$('.input-version-date-issued'),
            isIssuedValid = !onSave || this.model.version.get('issuedOn') != null;

        let newerVersionCount = 0;
        _.each(this.options.versions.models, _.bind(function (version) {
            if (new Date(this.model.version.get('issuedOn')) < new Date(version.get('issuedOn'))) {
                newerVersionCount++;
            }

            if (this.model.version.get('name').toLowerCase() === version.get('name').toLowerCase()) {
                versionNameExists = true;
            }
        }, this));
        isNameValid = isNameValid && !versionNameExists;

        PJQ.helpers.inputHelpers.setInputError($name, isNameValid);
        PJQ.helpers.inputHelpers.setInputError($issuedOn, isIssuedValid);

        let errors = '';
        if (newerVersionCount > 0) {
            errors += '<div class="text-info">There are ' + newerVersionCount.toString() + ' versions newer than this</div>';
        }
        if (versionNameExists) {
            errors += '<div class="text-danger">There is already a version with this name</div>';
        }
        this.$('.new-version-errors').html('<div>' + errors + '</div>');

        return isNameValid && isIssuedValid;
    },
    previousStep: function () {
        // this should only be allowed when going back from sorting to naming
        this.options.step--;
        this.render();
    },
    nextStep: function () {
        switch (this.options.step) {
            case 1:
                let hasFiles = _.size(this.model.files.models) > 0;
                if (this.model.version.isNew()) {
                    let isValid = this.validateNewVersion(true);
                    if (isValid) {
                        this.options.versions.add(this.model.version);
                        this.model.version.save(null, {
                            success: _.bind(function () {
                                if (hasFiles) {
                                    //skip the upload step
                                    this.options.step = this.options.step + 2;
                                    this.model.save(null, {
                                        success: _.bind(function () {
                                            this.render();
                                        }, this)
                                    });
                                } else {
                                    this.options.step++;
                                    this.render();
                                }
                            }, this)
                        });
                    }
                } else if (hasFiles) {
                    //skip the upload step
                    this.options.step = this.options.step + 2;
                    this.model.save(null, {
                        success: _.bind(function () {
                            this.render();
                        }, this)
                    });
                } else {
                    this.options.step++;
                    this.render();
                }
                break;
            case 2:
                this.model.save({
                    guid: this.fileUploader.options.uuid
                }, {
                    success: _.bind(function () {
                        this.options.step++;
                        this.render();
                    }, this)
                });
                break;
            case 4:
                let invalidDrawings = [],
                    drawingNames = {};
                _.each(this.model.drawings.models, function (drawing) {
                    if (drawing.get('isDeleted')) {
                        return;
                    }

                    let isValid = true;
                    if (drawingNames[drawing.get('name')] != null) {
                        invalidDrawings.push(drawing);
                        isValid = false;
                    }

                    drawingNames[drawing.get('name')] = {};
                    let $drawing = this.getBatchDrawingElement(drawing);
                    PJQ.helpers.inputHelpers.setInputError($drawing.find('.input-drawing-name'), isValid);
                }, this);

                if (_.size(invalidDrawings) > 0) {
                    this.setBatchError("Some drawings have duplicated names, please fix these before finalizing");
                } else {
                    this.setBatchError();
                    this.options.step++;
                    this.render();
                }
                break;
            default:
                this.options.step++;
                this.render();
                break;
        }
    },
    setBatchError: function (error) {
        let $err = this.$('.batch-error');
        if (error != null) {
            $err.html(error);
        } else {
            $err.empty();
        }
    },
    versionNameChanged: function (e) {
        let val = $(e.currentTarget).val(),
            valLen = _.size(val);
        if (valLen > 0 && e.keyCode === 13) {
            this.nextStep();
            return;
        }
        this.model.version.set("name", val);
        this.$(".btn-next-step").prop('disabled', valLen === 0);
        this.validateNewVersion();
    },
    useNewVersion: function () {
        this.$('.checkbox-new-version').prop('checked', true);
        this.$('.checkbox-existing-version').prop('checked', false);
        this.$('.new-version').removeClass('disabled');
        this.$('.existing-versions').addClass('disabled');
        this.model.version = new PJQ.models.drawings.Version({
            projectId: this.options.project.id,
            name: this.$('.input-version-name').val()
        });
    },
    useExistingVersion: function () {
        this.$('.checkbox-existing-version').prop('checked', true);
        this.$('.checkbox-new-version').prop('checked', false);
        this.$('.existing-versions').removeClass('disabled');
        this.$('.new-version').addClass('disabled');
        this.$(".btn-next-step").prop('disabled', false);
        this.model.version = this.options.versions.get(this.$('.existing-version.selected').data('cid'));
    },
    existingVersionSelected: function (e) {
        let $target = $(e.currentTarget);
        this.$('.existing-version').removeClass('selected');
        $target.addClass('selected');
        this.model.version = this.options.versions.get($target.data('cid'));
    },
    viewBatchDrawing: function (e) {
        this.$el.addClass('hidden');

        let $drawing = $(e.currentTarget).closest('.batch-drawing'),
            cid = $drawing.data('cid'),
            drawing = this.model.drawings.get(cid);
        new PJQ.views.drawings.DrawingViewer({
            model: drawing,
            batch: this.model,
            showSortableViewLink: false,
            isEdit: true,
            versions: this.options.versions,
            onClose: (changed) => {
                this.$el.removeClass('hidden');
                if (changed) {
                    this.render();
                }
            }
        });
    },
    rotateBatchDrawing90Clicked: function (e) {
        let $row = $(e.currentTarget).closest('.batch-drawing'),
            cid = $row.data('cid'),
            drawing = this.model.drawings.get(cid);
        this.rotateDrawing(drawing, 90);
    },
    rotateBatchDrawing180Clicked: function (e) {
        let $row = $(e.currentTarget).closest('.batch-drawing'),
            cid = $row.data('cid'),
            drawing = this.model.drawings.get(cid);
        this.rotateDrawing(drawing, 180);
    },
    rotateBatchDrawing270Clicked: function (e) {
        let $row = $(e.currentTarget).closest('.batch-drawing'),
            cid = $row.data('cid'),
            drawing = this.model.drawings.get(cid);
        this.rotateDrawing(drawing, 270);
    },
    rotateDrawing: function (drawing, degrees) {
        let $drawing = this.getBatchDrawingElement(drawing),
            rotateLoader = new PJQ.Loader($drawing);
        drawing.rotate(degrees, _.bind(function () {
            rotateLoader.remove();
            $drawing.find('.batch-drawing-thumb').attr('src', drawing.thumbUrl());
            $drawing.find('.batch-drawing-crop').attr('src', drawing.cropUrl());
            this.renderBatchDrawing(drawing);
        }, this));
    },
    deleteBatchDrawing: function (e) {
        let $row = $(e.currentTarget).closest('.batch-drawing'),
            cid = $row.data('cid'),
            drawing = this.model.drawings.get(cid);
        drawing.set('isDeleted', true);
        $row.remove();
        this.renderBatchHeader();
    },
    drawingBlur: function () {
        this.$('.batch-drawing').removeClass('focus');
    },
    drawingFocus: function (e) {
        let $target = $(e.currentTarget),
            $drawing = $target.closest('.batch-drawing');
        this.drawingBlur();
        $drawing.addClass('focus');
        $target.select();
    },
    drawingCenter: function ($drawing) {
        this.$el.scrollTop($drawing.position().top - $drawing.height())
    },
    drawingNameKeydown: function (e) {
        let $drawing = $(e.currentTarget).closest('.batch-drawing');
        if (e.which === 13 || (e.shiftKey && e.which === 40)) {
            let $next = this.nextDrawing($drawing);
            if (_.size($next) > 0) {
                $next.find('.input-drawing-name').focus();
            } else {
                this.firstDrawing().find('.input-drawing-title').focus();
            }
        } else if (e.shiftKey && (e.which === 8 || e.which === 38)) {
            let $prev = this.prevDrawing($drawing);
            $prev.find('.input-drawing-name').focus();
        }
    },
    drawingNameChanged: function (e) {
        let $target = $(e.target),
            $drawing = $target.closest('.batch-drawing'),
            cid = $drawing.data('cid'),
            drawing = this.model.drawings.get(cid),
            name = $target.val(),
            matchedDrawing = null;
        _.each(this.options.versions.models, function (version) {
            if (matchedDrawing == null) {
                _.each(version.drawings.models, function (drawing) {
                    if (drawing.get('name') === name && (matchedDrawing == null || _.size(matchedDrawing.get('title')) === 0)) {
                        matchedDrawing = drawing;
                    }
                });
            }
        });

        if (matchedDrawing != null) {
            let title = matchedDrawing.get('title'),
                tags = matchedDrawing.get('tags');
            drawing.set({
                name: name,
                title: title,
                tags: tags
            });
            $drawing.find('.input-drawing-title').val(title);
            this.renderDrawingTags(drawing, null);
        } else {
            drawing.set({
                name: name
            });
        }

        this.renderBatchDrawing(drawing);
    },
    drawingTitleKeydown: function (e) {
        let $drawing = $(e.currentTarget).closest('.batch-drawing');
        if (e.which === 13 || (e.shiftKey && e.which === 40)) {
            let $next = this.nextDrawing($drawing);
            if (_.size($next) > 0) {
                $next.find('.input-drawing-title').focus();
            } else {
                this.firstDrawing().find('.input-drawing-tag').focus();
            }
        } else if (e.shiftKey && (e.which === 8 || e.which === 38)) {
            let $prev = this.prevDrawing($drawing);
            $prev.find('.input-drawing-title').focus();
            return false;
        }
    },
    drawingTitleChanged: function (e) {
        let $target = $(e.currentTarget),
            cid = $target.closest('.batch-drawing').data('cid'),
            drawing = this.model.drawings.get(cid);
        drawing.set('title', $target.val());
    },
    drawingTagKeydown: function (e) {
        let $target = $(e.currentTarget),
            tag = $target.val(),
            $drawing = $target.closest('.batch-drawing'),
            drawing = this.model.drawings.get($drawing.data('cid'));
        if (e.shiftKey && (e.which === 13 || e.which === 40)) {
            let $next = this.nextDrawing($drawing);
            $next.find('.input-drawing-tag').focus();
            return false;
        } else if (e.shiftKey && (e.which === 8 || e.which === 38)) {
            let $prev = this.prevDrawing($drawing);
            $prev.find('.input-drawing-tag').focus();
            return false;
        } else if (e.which === 13) {
            this.addDrawingTags(drawing, tag);
            $target.val('');
            return false;
        } else if (e.which === 9) {
            this.nextDrawing($drawing);
        }
    },
    firstDrawing: function () {
        let $firstDrawing = this.$('.batch-drawing').first();
        this.drawingCenter($firstDrawing);
        return $firstDrawing;
    },
    prevDrawing: function ($drawing) {
        let $prevDrawing = $drawing.prev();
        if (_.size($prevDrawing) > 0) {
            this.drawingCenter($prevDrawing);
        }
        return $prevDrawing;
    },
    nextDrawing: function ($drawing) {
        let $nextDrawing = $drawing.next();
        if (_.size($nextDrawing) > 0) {
            this.drawingCenter($nextDrawing);
        }
        return $nextDrawing;
    },
    drawingTagChanged: function (e) {
        let $target = $(e.currentTarget);
        $target.siblings('.btn-add-drawing-tag').prop('disabled', _.size($target.val()) === 0);
    },
    addDrawingTagClicked: function (e) {
        let $target = $(e.currentTarget),
            $drawing = $target.closest('.batch-drawing'),
            $tag = $drawing.find('.input-drawing-tag'),
            tag = $tag.val();
        if (_.size(tag) > 0) {
            let drawing = this.model.drawings.get($drawing.data('cid'));
            this.addDrawingTags(drawing, tag);
            $tag.val('');
        }
    },
    deleteTagClicked: function (e) {
        let $target = $(e.currentTarget),
            tagName = $target.closest('.drawing-tag').data('name'),
            $drawing = $target.closest('.batch-drawing'),
            drawing = this.model.drawings.get($drawing.data('cid'));
        drawing.deleteTag(tagName, null, _.bind(function () {
            this.refreshTags();
            this.renderDrawingTags(drawing, _.bind(function ($drawing) {
                $drawing.find('.input-drawing-tag').focus();
            }, this));
        }, this));
    },
    addDrawingTags: function (drawing, tag) {
        let tags = [];
        if (_.size(tag) > 0) {
            _.each(tag.split(','), function (tag) {
                let tagTrim = tag.trim();
                if (_.size(tagTrim) > 0) {
                    tags.push(tagTrim);
                }
            });
        }

        drawing.addTags(tags, {
            save: false
        }, _.bind(function () {
            this.refreshTags();
            this.renderDrawingTags(drawing, _.bind(function ($drawing) {
                $drawing.find('.input-drawing-tag').focus();
            }, this));
        }, this));
    },
    renderDrawingTags: function (drawing, callback) {
        let $drawing = this.getBatchDrawingElement(drawing);
        this.renderSubTemplate(false, this.options.subTemplates.drawingTags, $drawing.find('.drawing-tags'), {
            tags: drawing.get('tags')
        }, function () {
            if (typeof callback === 'function') {
                callback($drawing);
            }
        });
    },
    refreshTags: function () {
        let batchTags = [];
        _.each(this.model.drawings.models, function (drawing) {
            let drawingTags = drawing.get('tags');
            if (_.size(drawingTags) > 0) {
                batchTags.push(...drawingTags);
            }
        });

        this.options.tags = [];
        _.each(_.union(_.uniq(batchTags), this.options.versions.getDrawingTags()), _.bind(function (tag) {
            if (_.size(tag) > 0 && this.options.tags.indexOf(tag) === -1) {
                this.options.tags.push(tag);
            }
        }, this));
    },
    addAllToCurrentSetChanged: function (e) {
        this.addAllToCurrent($(e.currentTarget).prop('checked'));
    },
    addAllToCurrent: function (shouldAdd) {
        this.$('.checkbox-add-all-current-set,.checkbox-add-current-set').prop('checked', shouldAdd);
        _.each(this.model.drawings.models, function (drawing) {
            drawing.set('isCurrentSet', shouldAdd);
        });
    },
    replaceCurrentSetChanged: function (e) {
        let $target = $(e.currentTarget),
            replaceCurrent = $target.prop('checked');
        this.model.set('replaceCurrentSet', replaceCurrent);
        this.addAllToCurrent(true);
        this.renderReplaceCurrentSet();
    },
    renderReplaceCurrentSet: function () {
        this.$('.checkbox-add-all-current-set,.checkbox-add-current-set').prop('disabled', this.model.get('replaceCurrentSet'));
    },
    addToCurrentSetChanged: function (e) {
        let $target = $(e.currentTarget),
            cid = $target.closest('.batch-drawing').data('cid'),
            drawing = this.model.drawings.get(cid),
            addCurrent = $target.prop('checked');

        drawing.set('isCurrentSet', addCurrent);

        if (!addCurrent) {
            this.$('.checkbox-add-all-current-set').prop('checked', false);
        }
    },
    replaceExistingDrawingChanged: function (e) {
        let $target = $(e.currentTarget),
            cid = $target.closest('.batch-drawing').data('cid'),
            drawing = this.model.drawings.get(cid),
            replaceExisting = $target.prop('checked');
        drawing.set('keepExisting', !replaceExisting);
    },
    cancel: function () {
        if (this.options.step === 4 || this.options.step === 5) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.save();
                }, this),
                onDontSave: _.bind(function () {
                    this.removeModal();
                }, this)
            });
        } else {
            this.removeModal();
        }
    },
    closeModal: function () {
        this.removeModal();
        if (this.model.statusTimeout != null) {
            clearTimeout(this.model.statusTimeout);
            this.model.statusTimeout = null;
        }
    },
    close: function () {
        if (this.options.step === 3) {
            this.closeModal();
        } else {
            this.cancel();
        }
    },
    save: function () {
        this.model.save(null, {
            success: _.bind(function () {
                this.removeModal();
            }, this)
        });
    },
    autoNotify: function (callback) {
        let verAppend = null,
            verName = '';
        if (this.options.versions != null) {
            let version = this.options.versions.get(this.model.get('versionId'));
            if (version != null) {
                verName = version.get('name');
                verAppend = ' (' + verName + ')';
            }
        }

        this.model = new PJQ.models.drawings.DrawingBatchNotification({
            batchId: this.model.id,
            subject: 'Drawings Published to ' + this.options.project.get('projectName') + (verAppend ?? ""),
            message: 'New drawings have been published to ' + this.options.project.get('projectName') + ' - <b>Version:</b> ' + verName + '.',
            allProjectContacts: true
        });
        this.model.save(null, {
            notify: false,
            success: () => {
                callback();
            },
            error: () => {
                callback();
            }
        });
    },
    publish: function (callback) {
        let hasNonCurSetPublish = _.find(this.model.drawings.models, function (drawing) {
                return drawing.get('versionId') === this.model.get('versionId') && drawing.get('isCurrentSet') === false;
            }, this) != null,
            fnPublish = (billRawFileUploadId, billDeerfieldTicketId, notes) => {
                new PJQ.Loader(this.$('.modal-content'));
                this.model.save(null, {
                    urlOptions: {
                        publish: true,
                        billRawFileUploadId: billRawFileUploadId,
                        billDeerfieldTicketId: billDeerfieldTicketId,
                        notes: notes
                    },
                    success: () => {
                        if ((billRawFileUploadId > 0 || billDeerfieldTicketId > 0) && this.model.get('docClerkOrderId') > 0) {
                            new PJQ.views.BaseModal({
                                header: "Doc Clerk Order Created",
                                body: 'The Order ID is ' + this.model.get('docClerkOrderId'),
                                isShowCancelButton: false
                            });
                        }

                        this.autoNotify(() => {
                            this.options.versions.fetch({
                                success: () => {
                                    this.removeModal();

                                    if (typeof callback === 'function') {
                                        callback();
                                    }
                                }
                            });
                        });
                    }
                });
            },
            fnPrePublish = _.bind(function () {
                if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_DOCUMENT_CLERK) && PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_RAW_FILE_UPLOAD_BILLING)) {
                    new PJQ.views.drawings.RawFileUploadBilling({
                        onContinue: _.bind(function (rawFileUploadId, deerfieldTicketId, notes) {
                            fnPublish(rawFileUploadId, deerfieldTicketId, notes);
                        }, this),
                        onSkip: _.bind(function () {
                            fnPublish();
                        }, this)
                    });
                } else
                    fnPublish();
            }, this);

        if (hasNonCurSetPublish) {
            new PJQ.views.BaseModal({
                header: "Confirm Publish",
                okButtonText: "Confirm",
                isShowSecondaryButton: true,
                secondaryButtonText: "Cancel",
                body: "You have selected for some drawings to not be published as part of the current set.  Please confirm this selection.",
                onOk: _.bind(function () {
                    fnPrePublish();
                }, this)
            });
        } else {
            fnPrePublish();
        }
    }
});

PJQ.views.drawings.RawFileUploadBilling = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DRAWINGS, 'Modal-Raw-File-Upload-Billing'),
        onSkip: _.noop(),
        onContinue: _.noop()
    },
    events: {
        'click .billing-skip': 'skipBilling',
        'click .billing-continue': 'continueBilling'
    },
    afterRender: function () {
        this.$('.billing-id').inputmask({
            alias: "integer",
            prefix: "",
            digits: 0,
            placeholder: " ",
            clearMaskOnLostFocus: true,
            rightAlign: false
        });

        this.billingReferenceSelectPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.billing-reference'),
            isIntChoices: false,
            isMultiple: false,
            mustSelectValue: true,
            defaultValue: 'rawFileUploadId'
        });
    },
    skipBilling: function () {
        if (typeof this.options.onSkip === 'function') {
            this.options.onSkip();
            this.removeModal();
        } else
            this.removeModal();
    },
    continueBilling: function () {
        let rawFileUploadId = 0,
            deerfieldTicketId = 0;

        if (this.billingReferenceSelectPicker.getValue() === 'rawFileUploadId')
            rawFileUploadId = parseInt(this.$('.billing-id').val());
        else
            deerfieldTicketId = parseInt(this.$('.billing-id').val());

        let rawFileUpload = new PJQ.models.rawFileUploads.RawFileUpload({
            rawFileUploadId: rawFileUploadId,
            projectId: PJQ.app.session.project.id
        });

        if (rawFileUploadId > 0) {
            rawFileUpload.fetch({
                success: _.bind(function () {
                    this.options.onContinue(rawFileUpload.id, null, this.$('.notes').val());
                    this.removeModal();
                }, this),
                error: _.bind(function () {
                    PJQ.notifications.notify.errorNotify({
                        message: 'Raw Upload Id not found, or does not match this Project.'
                    });
                }, this)
            });
        } else if (deerfieldTicketId > 0) {
            this.options.onContinue(null, deerfieldTicketId, this.$('.notes').val());
            this.removeModal();
        } else {
            PJQ.notifications.notify.errorNotify({
                message: 'Enter Raw Upload Id or Deerfield Ticket Id to continue.'
            });
        }
    }
});
PJQ.views.drawings.Dashboard = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DRAWINGS, 'Dashboard'),
        view: 'grid',
        mode: PJQ.constants.drawings.dashboardModes.VIEW,
        subTemplates: {
            versionGrid: new PJQ.templating.Template(PJQ.constants.modules.DRAWINGS, 'Dashboard-Version-Grid'),
            versionList: new PJQ.templating.Template(PJQ.constants.modules.DRAWINGS, 'Dashboard-Version-List'),
            versionStats: new PJQ.templating.Template(PJQ.constants.modules.DRAWINGS, 'Dashboard-Version-Stats'),
            versionSelect: new PJQ.templating.Template(PJQ.constants.modules.DRAWINGS, 'Drawing-Viewer-Version-Selector'),
            emptyState: new PJQ.templating.Template(PJQ.constants.modules.DRAWINGS, 'Dashboard-Empty-State')
        },
        isReadOnly: false
    },
    events: {
        'click .btn-share-drawings': 'shareDrawings',
        'click .btn-download-all-split': 'downloadAllSplit',
        'click .btn-download-all-merged': 'downloadAllMerged',
        'click .btn-download-version-split': 'downloadContextVersionSplit',
        'click .btn-download-version-merged': 'downloadContextVersionMerged',
        'click .btn-download-filtered-split': 'downloadFilteredSplit',
        'click .btn-download-filtered-merged': 'downloadFilteredMerged',
        'click .btn-download-advanced': 'downloadAdvanced',
        'click .btn-export-drawing-list': 'exportDrawingList',
        'click .btn-export-drawing-list-version': 'exportDrawingListVersion',
        'click .btn-order-version': 'orderContextVersion',
        'click .btn-order-filtered': 'orderFiltered',
        'click .btn-order-advanced': 'orderAdvanced',
        'click .btn-bulk-tag': 'bulkTag',
        'click .btn-sort-version': 'sortVersion',
        'click .btn-save-version': 'saveVersion',
        'click .btn-edit-version': 'editVersion',
        'keyup .input-drawing-name': 'drawingNameChanged',
        'keyup .input-drawing-title': 'drawingTitleChanged',
        'click .btn-cancel-edit-version': 'cancelEditVersion',
        'click .btn-new-batch': 'newBatch',
        'click .version-drawing-outer': 'drawingClicked',
        'click .version-select': 'versionSelected',
        'click .btn-manage-versions': 'manageVersions',
        'click .btn-upload-log': 'viewUploadLog',
        'keyup .input-drawings-search': 'renderContextVersion',
        'click .btn-view-grid': 'renderViewGrid',
        'click .btn-view-list': 'renderViewList',
        'click .btn-delete-drawing': 'deleteDrawing',
        'click .btn-drawing-rotate-90': 'rotateBatchDrawing90Clicked',
        'click .btn-drawing-rotate-180': 'rotateBatchDrawing180Clicked',
        'click .btn-drawing-rotate-270': 'rotateBatchDrawing270Clicked',
    },
    contextVersion: null,
    beforeFirstRender: function () {
        this.options.canEdit = PJQ.app.session.project != null
            && PJQ.app.session.project.hasPermission('drawings.isAdmin')
            && (PJQ.app.session.project.get('masterUserId') === PJQ.app.session.get('masterUserId'));
        if (PJQ.app.session.user == null || (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_DOCUMENT_CLERK_COMPANY) && PJQ.app.session.user.id !== 81732 &&
            !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_DOCUMENT_CLERK))) {
            this.options.canEdit = false;
        }
        this.options.canShare = PJQ.app.session.project != null
            && PJQ.app.session.project.hasPermission('drawings.canShare')
            && (PJQ.app.session.project.get('masterUserId') === PJQ.app.session.get('masterUserId'))
            && (!PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_SHARE_PEI)) &&
            (this.options.orderSettings == null || (this.options.orderSettings.get('downloadPerFileFee') === 0 || !PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_ADMIN_PAID_DOWNLOADS)));

        this.options.canDownload = true;
        this.options.isPaidDownload = false;
        this.options.canOrder = !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_ORDER_PRINT);

        if (!this.options.orderSettings && PJQ.app.session.project && PJQ.app.session.project.orderSettings)
            this.options.orderSettings = PJQ.app.session.project.orderSettings;

        if (this.options.orderSettings && PJQ.app.session.project != null && !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_DOCUMENT_CLERK)) {
            this.options.canDownload = this.options.orderSettings.get('downloadPerFileFee') === 0 || PJQ.app.session.project.get('masterUserId') === PJQ.app.session.get('masterUserId');
            this.options.isPaidDownload = !(this.options.orderSettings.get('downloadPerFileFee') === 0 || (PJQ.app.session.project.get('masterUserId') === PJQ.app.session.get('masterUserId') && !PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_ADMIN_PAID_DOWNLOADS)));
        }

        if (this.options.isReadOnly) {
            this.options.canEdit = false;
            this.options.canShare = false;
        }

        if (this.options.project != null) {
            this.options.hideIssuedOn = this.options.project.preferences.hasPref(PJQ.constants.preferenceTypes.HIDE_VERSION_SELECTOR_ISSUED_ON);
        } else {
            this.options.hideIssuedOn = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.HIDE_VERSION_SELECTOR_ISSUED_ON);
        }

        let fetchCallback = _.bind(function () {
            this.listenTo(this.collection, 'update', _.bind(function () {
                this.render();
            }, this));
            // set the context version to current set if it has drawings
            if (this.options.project != null && this.options.canEdit) {
                PJQ.helpers.drawings.getUnPublishedBatchesCount(this.options.project.id, _.bind(function (batchCount) {
                    this.unPublishedBatchCount = batchCount;
                    this.render();
                }, this));
            } else {
                this.render();
            }
        }, this);
        if (this.collection == null) {
            this.options.project.fetchVersions(_.bind(function (versions) {
                this.collection = versions;
                fetchCallback();
            }, this));
        } else {
            fetchCallback();
        }
    },
    beforeRender: function () {
        if (this.collection != null) {
            if (this.contextVersion == null && this.options.initOptions?.versionId > 0) {
                let mVersionId = parseInt(this.options.initOptions.versionId);
                this.contextVersion = _.find(this.collection.models, (version) => {
                    return version.id === mVersionId;
                });
            } else if (this.contextVersion == null) {
                this.contextVersion = _.find(this.collection.models, (version) => {
                    return version.id === -1;
                });
            }

            if (this.contextVersion != null && _.size(this.contextVersion.drawings.models) === 0 && _.size(this.collection.models) > 0) {
                this.contextVersion = this.contextVersion = _.find(this.collection.models, function (version) {
                    return _.size(version.drawings.models) > 0;
                });
            }

            if (this.contextVersion == null && _.size(this.collection.models) > 0) {
                this.contextVersion = this.collection.models[0];
            }
        }
    },
    renderData: function () {
        return {
            hideIssuedOn: this.options.hideIssuedOn,
            canEdit: this.options.canEdit,
            canShare: this.options.canShare,
            canDownload: this.options.canDownload,
            canOrder: this.options.canOrder,
            isPaidDownload: this.options.isPaidDownload,
            drawingCount: this.collection ? this.collection.getDrawingCount() : 0,
            versions: this.collection,
            view: this.options.view,
            mode: this.options.mode,
            search: this.options.search,
            contextVersion: this.contextVersion,
            unPublishedBatchCount: this.unPublishedBatchCount
        };
    },
    afterRender: function () {
        if (this.collection != null) {
            if (this.collection.getDrawingCount() > 0) {
                this.tagSelectPicker = new PJQ.inputs.Selectpicker({
                    el: this.$('select.drawings-filter'),
                    defaultValue: this.filterTags,
                    noneSelectedText: 'Filter Tags',
                    isMultiple: true,
                    onChange: _.bind(function (value) {
                        this.filterTags = value;
                        this.renderContextVersion();
                    }, this)
                });
                this.renderContextVersion();
                if (this.scrollTop > 0) {
                    this.$('.version-drawings').scrollTop(this.scrollTop);
                    this.scrollTop = null;
                }
            } else if (this.collection.isFetched) {
                this.renderEmptyState();
            }
        }
    },
    refresh: function () {
        this.scrollTop = $('.version-drawings').scrollTop();
        this.render();
    },
    deleteDrawing: function (e) {
        e.stopPropagation();

        let $drawing = $(e.currentTarget).closest('.version-drawing-outer'),
            drawing = this.contextVersion.drawings.get($drawing.data('cid')),
            self = this;
        new PJQ.views.modals.DeleteVersionModal({
            onDeleteInAll: function () {
                drawing.destroy({
                    success: function () {
                        _.each(self.collection.models, function (version) {
                            let verDrawing = _.find(version.drawings.models, function (compDrawing) {
                                return drawing.get('name') === compDrawing.get('name');
                            });
                            if (verDrawing != null) {
                                verDrawing.destroy();
                                version.drawings.remove(verDrawing);
                            }
                        });
                        $drawing.parent().remove();
                    }
                });
            },
            onDeleteInThis: function () {
                drawing.destroy({
                    success: function () {
                        let curSet = self.collection.get(-1);
                        if (curSet != null) {
                            let verDrawing = _.find(curSet.drawings.models, function (compDrawing) {
                                return drawing.get('name') === compDrawing.get('name');
                            });
                            if (verDrawing != null) {
                                verDrawing.destroy();
                                curSet.drawings.remove(verDrawing);
                            }
                        }
                        $drawing.parent().remove();
                    }
                });
            }
        });
    },
    rotateBatchDrawing90Clicked: function (e) {
        e.stopPropagation();
        this.rotateDrawing(e, 90);
    },
    rotateBatchDrawing180Clicked: function (e) {
        e.stopPropagation();
        this.rotateDrawing(e, 180);
    },
    rotateBatchDrawing270Clicked: function (e) {
        e.stopPropagation();
        this.rotateDrawing(e, 270);
    },
    rotateDrawing: function (e, degrees) {
        let $drawing = $(e.currentTarget).closest('.version-drawing-outer'),
            drawing = this.contextVersion.drawings.get($drawing.data('cid')),
            rotateLoader = new PJQ.Loader($drawing);
        drawing.rotate(degrees, _.bind(function () {
            rotateLoader.remove();
            $drawing.find('.version-drawing').attr('src', drawing.thumbUrl());
            rotateLoader.remove();
        }, this));
    },
    updateTagChoices: function () {
        if (this.tagSelectPicker != null) {
            let tags = this.contextVersion.getDrawingTags().sort(PJQ.helpers.sortHelpers.sortAlphaNum);
            this.tagSelectPicker.updateChoices(tags);
        }
    },
    renderViewGrid: function () {
        this.$('.btn-view-grid').removeClass('btn-light').addClass('btn-primary');
        this.$('.btn-view-list').removeClass('btn-primary').addClass('btn-light');
        this.options.view = 'grid';
        this.renderContextVersion();
    },
    renderViewList: function () {
        this.$('.btn-view-list').removeClass('btn-light').addClass('btn-primary');
        this.$('.btn-view-grid').removeClass('btn-primary').addClass('btn-light');
        this.options.view = 'list';
        this.renderContextVersion();
    },
    saveVersion: function () {
        this.contextVersion.drawings.options.project = this.options.project;

        let valid = true;
        _.each(this.contextVersion.drawings.models, function (drawing) {
            let thisValid = null == _.find(this.contextVersion.drawings.models, function (compareDrawing) {
                return drawing.cid !== compareDrawing.cid && drawing.get('name') === compareDrawing.get('name');
            });
            valid = valid && thisValid;

            let $drawing = this.$('.version-drawing-outer[data-cid="' + drawing.cid + '"]');
            PJQ.helpers.inputHelpers.setInputError($drawing.find('.input-drawing-name'), thisValid);
        }, this);

        if (!valid) {
            if (this.duplicateNameAlert == null) {
                this.duplicateNameAlert = new PJQ.Alert(this.$('.version-drawings'), {
                    type: 'danger',
                    isBefore: true,
                    text: 'Some of the drawings have duplicated names.  Drawing names must be unique per version.',
                    extraClasses: ['alert-duplicate-name']
                });
            }
            return;
        } else if (this.duplicateNameAlert != null) {
            this.duplicateNameAlert.destroy();
            this.duplicateNameAlert = null;
        }

        this.contextVersion.drawings.save({
            put: true,
            urlOptions: {
                isFileAPI: true
            },
            success: _.bind(function () {
                _.each(this.contextVersion.drawings.models, function (contextDrawing) {
                    _.each(this.collection.models, function (version) {
                        _.each(version.drawings.models, function (otherDrawing) {
                            if (otherDrawing.get('name') === contextDrawing.get('name')) {
                                otherDrawing.set('title', contextDrawing.get('title'), {
                                    silent: true
                                });
                            }
                        });
                    });
                }, this);

                this.options.mode = PJQ.constants.drawings.dashboardModes.VIEW;
                this.render();
            }, this)
        });
    },
    bulkTag: function () {
        new PJQ.views.drawings.BulkTagModal({
            collection: this.collection,
            onClose: _.bind(function () {
                this.render();
            }, this)
        });
    },
    sortVersion: function () {
        new PJQ.views.drawings.SortDrawingsModal({
            versions: this.collection,
            sortVersion: this.contextVersion,
            sortFullSet: true,
            onDone: _.bind(function () {
                this.render();
            }, this)
        });
    },
    editVersion: function () {
        this.options.mode = PJQ.constants.drawings.dashboardModes.EDIT;
        this.render();
    },
    cancelEditVersion: function () {
        _.each(this.contextVersion.drawings.models, function (drawing) {
            drawing.restore();
        });
        this.options.mode = PJQ.constants.drawings.dashboardModes.VIEW;
        this.render();
    },
    getFilteredDrawings: function () {
        this.options.search = this.$('.input-drawings-search').val().toLowerCase();

        let result,
            isSearch = _.size(this.options.search) > 0,
            isFilterTags = _.size(this.filterTags) > 0;
        if (isSearch || isFilterTags) {
            result = [];
            _.each(this.contextVersion.drawings.models, _.bind(function (drawing) {
                if (isSearch && drawing.get('name').toLowerCase().indexOf(this.options.search) === -1 && drawing.get('title').toLowerCase().indexOf(this.options.search) === -1) {
                    return false;
                }
                if (isFilterTags && _.find(this.filterTags, function (filterTag) {
                    return _.find(drawing.get('tags'), function (drawingTag) {
                        return filterTag === drawingTag;
                    }) != null;
                }) == null) {
                    return false;
                }
                result.push(drawing);
            }, this));
        } else {
            result = this.contextVersion.drawings.models;
        }
        return result;
    },
    renderEmptyState: function () {
        this.renderSubTemplate(false, this.options.subTemplates.emptyState, this.$('.version-drawings'), {
            canEdit: this.options.canEdit
        });
    },
    renderContextVersion: function () {
        if (this.options.mode === PJQ.constants.drawings.dashboardModes.VIEW && this.contextVersion.get('issuedOn') != null) {
            this.renderVersionSelector();
        }

        this.$('.selector-version-name,.context-version-name').text(this.contextVersion.get('name'));
        this.$('.context-version-issued').text(PJQ.helpers.dateHelpers.getDateString(new Date(this.contextVersion.get('issuedOn')), PJQ.helpers.dateHelpers.dateFormats.DATE, true));
        this.$('.context-version-drawing-count').text(_.size(this.contextVersion.drawings.models));
        this.updateTagChoices();
        let versionTmpl;
        if (this.options.view === 'list') {
            versionTmpl = this.options.subTemplates.versionList;
        } else {
            versionTmpl = this.options.subTemplates.versionGrid;
        }
        this.renderSubTemplate(false, versionTmpl, this.$('.version-drawings'), {
            mode: this.options.mode,
            versions: this.collection,
            canEdit: this.options.canEdit,
            drawings: this.getFilteredDrawings()
        }, _.bind(function () {
            PJQ.app.lazyLoad().update();
            this.renderSubTemplate(false, this.options.subTemplates.versionStats, this.$('.version-stats'), {
                versions: this.collection,
                contextVersion: this.contextVersion
            });
        }, this));
    },
    newBatch: function () {
        new PJQ.views.drawings.DrawingBatchModal({
            versions: this.collection,
            project: this.options.project
        });
    },
    drawingNameChanged: function (e) {
        let $target = $(e.currentTarget),
            $drawing = $target.closest('.version-drawing-outer'),
            cid = $drawing.data('cid'),
            drawing = this.contextVersion.drawings.get(cid),
            name = $target.val();
        drawing.set('name', name);
    },
    drawingTitleChanged: function (e) {
        let $target = $(e.currentTarget),
            cid = $target.closest('.version-drawing-outer').data('cid'),
            drawing = this.contextVersion.drawings.get(cid);
        drawing.set('title', $target.val());
    },
    drawingClicked: function (e) {
        let cid = $(e.currentTarget).data('cid'),
            drawing = this.contextVersion.drawings.get(cid);

        let initViewer = _.bind(function () {
            new PJQ.views.drawings.DrawingViewer({
                model: drawing,
                project: this.options.project,
                forShare: this.options.forShare,
                isEdit: this.options.mode === PJQ.constants.drawings.dashboardModes.EDIT,
                canEdit: this.options.canEdit,
                contextVersion: this.contextVersion,
                accessKey: this.options.accessKey,
                versions: this.collection,
                onClose: _.bind(function (changed) {
                    if (changed) {
                        this.refresh();
                    }
                }, this),
                onDelete: _.bind(function () {
                    this.refresh();
                }, this)
            });
        }, this);
        if (this.options.project != null) {
            this.options.project.checkDownloadRequirements(_.bind(function () {
                initViewer();
            }, this));
        } else {
            initViewer();
        }
    },
    versionSelected: function (e) {
        let cid = $(e.currentTarget).data('cid');
        if (cid != null) {
            this.contextVersion = this.collection.get(cid);
            this.renderContextVersion();
        }
    },
    renderVersionSelector: function () {
        let $versionSelect = this.$('.drawing-versions');
        this.renderSubTemplate(false, this.options.subTemplates.versionSelect, $versionSelect, {
            versions: _.filter(this.collection.models, function (ver) {
                return _.size(ver.drawings) > 0;
            }),
            hideIssuedOn: this.options.hideIssuedOn,
            contextVersion: this.contextVersion,
            currentSet: this.collection.get(-1)
        });
    },
    manageVersions: function () {
        new PJQ.views.drawings.ManageVersionsModal({
            collection: this.collection,
            project: this.options.project,
        });
    },
    viewUploadLog: function () {
        new PJQ.views.drawings.DrawingUploadLogModal({
            project: this.options.project,
            versions: this.collection
        });
    },
    shareDrawings: function () {
        new PJQ.views.drawings.DrawingShareModal({
            collection: this.collection,
            onSave: _.bind(function (versions) {
                let shareDrawings = new PJQ.collections.drawings.Drawings(),
                    versionIds = [];

                shareDrawings.options.allDrawings = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DRAWING_SHARE_PREVENT_EXPIRATION);

                _.each(versions, function (version) {
                    versionIds.push(version.versionId);
                    _.each(version.guids, function (guid) {
                        shareDrawings.add(new PJQ.models.drawings.Drawing({
                            guid: guid
                        }));
                    });
                });
                let sharingModal = new PJQ.views.sharing.SharingModal({
                    collection: shareDrawings,
                    project: this.options.project,
                    subject: 'Drawings have been shared with you',
                    onSave: _.bind(function (data) {
                        shareDrawings.share(versionIds, null, data, this.options.project, _.bind(function (share) {
                            PJQ.notifications.notify.successNotify({
                                message: 'Drawing share email sent'
                            });
                        }, this));
                    }, this)
                });
                shareDrawings.share(versionIds, null, null, this.options.project, function (share) {
                    let callback = _.bind(sharingModal.urlChanged, sharingModal);
                    callback(share.url);
                });
            }, this)
        });
    },
    downloadDrawings: function (drawings, options) {
        let download = _.bind(function () {
            PJQ.helpers.drawings.createDownload(this.options.project, [{
                versionId: this.contextVersion.id,
                guids: _.map(drawings, function (drawing) {
                    return drawing.get('guid');
                })
            }], options);
        }, this);
        if (this.options.project != null) {
            this.options.project.checkDownloadRequirements(_.bind(function () {
                download();
            }, this));
        } else {
            download();
        }
    },
    downloadContextVersionSplit: function () {
        if (this.options.isPaidDownload) {
            let entryIds = [];
            _.each(this.contextVersion.drawings.models, function (model) {
                entryIds.push(model.get('drawingId') * -1);
            });

            if (PJQ.app.session.project != null && PJQ.app.session.project.get('masterUserId') === PJQ.app.session.get('masterUserId') && (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.CAN_ORDER_ON_ACCOUNT) || PJQ.app.session.hasPermission('documents.onAccount'))) {
                new PJQ.views.drawings.OrderDownloadAdmin({
                    entryIds: entryIds,
                    orderSettings: this.options.orderSettings
                });
            } else {
                new PJQ.views.drawings.OrderPrintsModal({
                    mode: PJQ.constants.files.modes.DOWNLOAD,
                    entryIds: entryIds,
                    orderSettings: this.options.orderSettings
                });
            }
        } else {
            this.downloadDrawings(this.contextVersion.drawings.models);
        }
    },
    downloadContextVersionMerged: function () {
        this.downloadDrawings(this.contextVersion.drawings.models, {
            merge: true
        });
    },
    downloadFilteredSplit: function () {
        if (this.options.isPaidDownload) {
            let entryIds = [];
            _.each(this.getFilteredDrawings(), function (model) {
                entryIds.push(model.get('drawingId') * -1);
            });

            if (PJQ.app.session.project != null && PJQ.app.session.project.get('masterUserId') === PJQ.app.session.get('masterUserId') && (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.CAN_ORDER_ON_ACCOUNT) || PJQ.app.session.hasPermission('documents.onAccount'))) {
                new PJQ.views.drawings.OrderDownloadAdmin({
                    entryIds: entryIds,
                    orderSettings: this.options.orderSettings
                });
            } else {
                new PJQ.views.drawings.OrderPrintsModal({
                    mode: PJQ.constants.files.modes.DOWNLOAD,
                    entryIds: entryIds,
                    orderSettings: this.options.orderSettings
                });
            }
        } else {
            this.downloadDrawings(this.getFilteredDrawings());
        }

    },
    downloadFilteredMerged: function () {
        this.downloadDrawings(this.getFilteredDrawings(), {
            merge: true
        });
    },
    downloadAdvanced: function () {
        new PJQ.views.drawings.AdvancedDownloadModal({
            project: this.options.project,
            orderSettings: this.options.orderSettings,
            collection: this.collection,
            isPaidDownload: this.options.isPaidDownload
        });
    },
    exportDrawingListVersion: function(){
        this.exportDrawingList(this.contextVersion.id);
    },
    exportDrawingList: function (versionId = null) {
        let params = [];
        if(versionId != null) {
            params.push({
                parameter: 'versionId',
                value: versionId
            });
        }

        PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: PJQ.app.session.project.id
            },
            {
                endpoint: 'drawings'
            },
            {
                endpoint: 'export'
            }
        ], params));
    },
    orderContextVersion: function () {
        let entryIds = [];
        _.each(this.contextVersion.drawings.models, function (model) {
            entryIds.push(model.get('drawingId') * -1);
        });
        new PJQ.views.drawings.OrderPrintsModal({
            mode: PJQ.constants.files.modes.PRINT,
            entryIds: entryIds,
            orderSettings: this.options.orderSettings
        });

    },
    orderFiltered: function () {
        let entryIds = [];
        _.each(this.getFilteredDrawings(), function (model) {
            entryIds.push(model.get('drawingId') * -1);
        });
        if (_.size(entryIds) > 0) {
            new PJQ.views.drawings.OrderPrintsModal({
                mode: PJQ.constants.files.modes.PRINT,
                entryIds: entryIds,
                orderSettings: this.options.orderSettings
            });
        } else {
            PJQ.notifications.notify.errorNotify({
                message: 'No drawings in filter'
            });
        }

    },
    orderAdvanced: function () {
        new PJQ.views.drawings.AdvancedDownloadModal({
            project: this.options.project,
            orderSettings: this.options.orderSettings,
            collection: this.collection,
            isPaidDownload: false,
            isPrintOrder: true
        });
    }
});

PJQ.views.drawings.DrawingShareModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DRAWINGS, 'Modal-Drawing-Share'),
        onSave: null
    },
    defaultEvents: {
        'click .btn-cancel': 'removeModal',
        'click .btn-save': 'save'
    },
    beforeModalCreated: function () {
        this.selectedVersions = [];
    },
    afterRender: function () {
        new PJQ.views.drawings.DrawingSelectorTree({
            el: this.$('.drawings-tree'),
            collection: this.collection,
            onChange: _.bind(function (versions) {
                this.selectedVersions = versions;
            }, this)
        });
    },
    renderData: function () {
        return {
            collection: this.collection
        };
    },
    save: function () {
        this.removeModal();
        if (typeof this.options.onSave === 'function') {
            this.options.onSave(this.selectedVersions);
        }
    }
});

PJQ.views.drawings.DrawingSelectorTree = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DRAWINGS, 'Drawing-Selector-Tree'),
        flatten: false,
        onChange: null
    },
    events: {
        'click .version-expand': 'expandVersion',
        'change .cb-version': 'versionSelected',
        'change .cb-drawing': 'drawingSelected'
    },
    beforeFirstRender: function () {
        this.selectedVersions = [];
        this.selectedDrawings = [];
        this.drawings = this.collection.getUniqueDrawings();
    },
    renderData: function () {
        return {
            versions: this.collection.models,
            drawings: this.drawings,
            flatten: this.options.flatten
        };
    },
    flatten: function (flatten) {
        this.options.flatten = flatten;
        this.render();
    },
    expandVersion: function (e) {
        let $outer = $(e.currentTarget).closest('.version-outer'),
            $drawings = $outer.find('.version-drawings');
        $drawings.toggleClass('hidden');
    },
    versionSelected: function (e) {
        let $target = $(e.currentTarget),
            $outer = $target.closest('.version-outer'),
            isSelected = $target.prop('checked'),
            versionCid = $target.data('versionCid'),
            version = this.collection.get(versionCid);

        if (isSelected) {
            let selectedVersion = _.findWhere(this.selectedVersions, {versionId: version.id});
            if (selectedVersion == null) {
                selectedVersion = {
                    versionId: version.id,
                };
            }
            selectedVersion.guids = _.map(version.drawings.models, function (drawing) {
                return drawing.get('guid');
            });
            selectedVersion.ids = _.map(version.drawings.models, function (drawing) {
                return drawing.id;
            });

            if (_.size(selectedVersion.guids) > 0 || _.size(selectedVersion.ids) > 0) {
                this.selectedVersions.push(selectedVersion);
            }
        } else {
            this.selectedVersions = _.filter(this.selectedVersions, function (deleteVersion) {
                return deleteVersion.versionId !== version.id;
            });
        }
        $outer.find('.cb-drawing').prop('checked', isSelected);
        this.onChange();
    },
    drawingSelected: function (e) {
        let $target = $(e.currentTarget),
            isSelected = $target.prop('checked'),
            drawingCid = $target.data('drawingCid');

        if (this.options.flatten) {
            let drawing = _.find(this.drawings, function (drawing) {
                return drawing.cid === drawingCid;
            });
            if (isSelected && !_.contains(this.selectedDrawings, drawing.id)) {
                this.selectedDrawings.push(drawing.id);
            } else {
                this.selectedDrawings = _.without(this.selectedDrawings, drawing.id);
            }
        } else {
            let $outer = $target.closest('.version-outer'),
                $cbVersion = $outer.find('.cb-version'),
                versionCid = $target.data('versionCid'),
                version = this.collection.get(versionCid),
                drawing = _.find(version.drawings.models, function (drawing) {
                    return drawing.cid === drawingCid;
                }),
                selectedVersion = _.findWhere(this.selectedVersions, {versionId: version.id});
            if (isSelected) {
                if (selectedVersion == null) {
                    selectedVersion = {
                        versionId: version.id,
                        guids: [drawing.get('guid')],
                        ids: [drawing.id]
                    };
                    this.selectedVersions.push(selectedVersion);
                } else {
                    selectedVersion.guids.push(drawing.get('guid'));
                    selectedVersion.ids.push(drawing.id);
                }

                if (_.size($outer.find(".cb-drawing:not(:checked)")) === 0) {
                    $cbVersion.prop('checked', true);
                }
            } else if (selectedVersion != null) {
                selectedVersion.guids = _.without(selectedVersion.guids, drawing.get('guid'));
                selectedVersion.ids = _.without(selectedVersion.ids, drawing.id);
                if (_.size(selectedVersion.guids) === 0) {
                    this.selectedVersions = _.filter(this.selectedVersions, function (deleteVersion) {
                        return deleteVersion.versionId !== version.id;
                    });
                }

                $cbVersion.prop('checked', false);
            }
        }

        this.onChange();
    },
    onChange: function () {
        if (typeof this.options.onChange === 'function') {
            this.options.onChange(this.options.flatten ? this.selectedDrawings : this.selectedVersions);
        }
    }
});

PJQ.views.modals.DeleteVersionModal = PJQ.views.BaseModal.extend({
    defaults: {
        header: "Confirm Delete",
        body: "Where would you like to delete this drawing from?"
    },
    beforeModalCreated: function () {
        this.options = _.defaults({
            isShowOkButton: true,
            okButtonText: 'All Versions',
            okButtonColorClass: 'danger',
            onOk: _.bind(function () {
                if (typeof this.options.onDeleteInAll === 'function') {
                    this.options.onDeleteInAll();
                }
            }, this),
            isShowSecondaryButton: true,
            secondaryButtonColorClass: 'outline-danger',
            secondaryButtonText: 'This Version',
            onSecondary: _.bind(function () {
                if (typeof this.options.onDeleteInThis === 'function') {
                    this.options.onDeleteInThis();
                }
            }, this),
            isShowCancelButton: true,
            cancelButtonText: "Cancel",
            onClose: _.bind(function () {
                if (typeof this.options.onCancel === 'function') {
                    this.options.onCancel();
                }
            }, this)
        }, this.options);
    }
});

PJQ.views.drawings.BulkTagModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DRAWINGS, 'Modal-Bulk-Tag'),
        subTemplates: {
            drawingTags: new PJQ.templating.Template(PJQ.constants.modules.DRAWINGS, 'Drawing-Tags'),
        },
        onClose: null
    },
    defaultEvents: {
        'change .cb-specify-version': 'renderDrawingSelector',
        'click .btn-add-tag': 'addTag',
        'click .btn-delete-tag': 'deleteTag',
        'keyup .input-tag': 'tagChanged',
        'click .btn-close': 'close'
    },
    afterRender: function () {
        this.renderDrawingSelector();
        this.renderExistingTags();
    },
    renderDrawingSelector: function () {
        this.selectedVersions = [];
        this.selectedDrawings = [];
        let flatten = !this.$('.cb-specify-version').prop('checked');
        if (this.drawingSelector == null) {
            this.drawingSelector = new PJQ.views.drawings.DrawingSelectorTree({
                el: this.$('.drawings-tree'),
                flatten: !this.$('.cb-specify-version').prop('checked'),
                collection: this.collection,
                onChange: _.bind(function (data) {
                    if (!this.$('.cb-specify-version').prop('checked')) {
                        this.selectedDrawings = data;
                    } else {
                        this.selectedVersions = data;
                    }
                    this.renderExistingTags();
                    this.validateTag();
                }, this)
            });
        } else {
            this.drawingSelector.flatten(flatten);
        }
    },
    tagChanged: function (e) {
        if (e.keyCode === 13) {
            this.addTag();
            return;
        }

        this.validateTag();
    },
    validateTag: function () {
        let tag = this.$('.input-tag').val();
        this.$('.btn-add-tag').prop('disabled', _.size(this.getSelectedDrawingIds()) === 0 || _.size(tag) === 0);
    },
    getInputTags: function () {
        let tagString = $('.input-tag').val(),
            tags = [];
        if (_.size(tagString) > 0) {
            _.each(tagString.split(','), function (tag) {
                let tagTrim = tag.trim();
                if (_.size(tagTrim) > 0) {
                    tags.push(tagTrim);
                }
            });
        }
        return tags;
    },
    getSelectedDrawingIds: function () {
        let drawingIds = [];
        _.each(this.selectedVersions, function (version) {
            drawingIds.push(...version.ids);
        });
        drawingIds.push(...this.selectedDrawings);
        return drawingIds;
    },
    endpoint: function (allVersions = false, isDelete = false) {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: PJQ.app.session.project.id
            },
            {
                endpoint: 'drawings'
            },
            {
                endpoint: 'tags'
            }
        ], [
            {
                parameter: 'delete',
                value: isDelete
            },
            {
                parameter: 'allVersions',
                value: allVersions
            }
        ]);
    },
    renderExistingTags: function () {
        let tags = [];
        if (_.size(this.selectedVersions) > 0) {
            _.each(this.selectedVersions, _.bind(function (version) {
                let mVer = this.collection.get(version.versionId);
                _.each(version.ids, function (drawingId) {
                    let mDr = mVer.drawings.get(drawingId);
                    _.each(mDr.get('tags'), function (tag) {
                        if (!_.contains(tags, tag)) {
                            tags.push(tag);
                        }
                    });
                });
            }, this));
        }

        if (_.size(this.selectedDrawings) > 0) {
            _.each(this.selectedDrawings, _.bind(function (drawingId) {
                _.each(this.collection.models, function (version) {
                    let mDr = version.drawings.get(drawingId);
                    if (mDr != null) {
                        _.each(mDr.get('tags'), function (tag) {
                            if (!_.contains(tags, tag)) {
                                tags.push(tag);
                            }
                        });
                    }
                });
            }, this));
        }
        this.renderSubTemplate(false, this.options.subTemplates.drawingTags, this.$('.drawing-tags'), {
            tags: tags
        });
    },
    addTag: function () {
        let allVersions = !this.$('.cb-specify-version').prop('checked'),
            tags = this.getInputTags();
        new PJQ.ajax.Request({
            endpoint: this.endpoint(allVersions),
            data: {
                drawingIds: this.getSelectedDrawingIds(),
                tags: tags
            }
        }).post().done(_.bind(function () {
            this.clearTagInput();
            this.alterTags(tags);
            this.renderExistingTags();
        }, this)).fail(function () {
            this.error();
        });
    },
    deleteTag: function (e) {
        let allVersions = !this.$('.cb-specify-version').prop('checked'),
            tag = $(e.currentTarget).closest('.drawing-tag').data('name');
        new PJQ.ajax.Request({
            endpoint: this.endpoint(allVersions, true),
            data: {
                drawingIds: this.getSelectedDrawingIds(),
                tags: [tag]
            }
        }).post().done(_.bind(function (data) {
            this.clearTagInput();
            this.alterTags(tag, true);
            this.renderExistingTags();
        }, this)).fail(function () {
            this.error()
        });
    },
    alterTags: function (tags, isDelete = false) {
        if (_.size(this.selectedVersions) > 0) {
            _.each(this.selectedVersions, _.bind(function (version) {
                let mVer = this.collection.get(version.versionId);
                _.each(version.ids, function (drawingId) {
                    let mDr = mVer.drawings.get(drawingId);
                    if (isDelete) {
                        mDr.deleteTag(tags, {
                            save: false
                        });
                    } else {
                        mDr.addTags(tags, {
                            save: false
                        });
                    }
                });
            }, this));
        }

        if (_.size(this.selectedDrawings) > 0) {
            _.each(this.selectedDrawings, _.bind(function (drawingId) {
                _.each(this.collection.models, function (version) {
                    let mDr = version.drawings.get(drawingId);
                    if (mDr != null) {
                        if (isDelete) {
                            mDr.deleteTag(tags, {
                                save: false
                            });
                        } else {
                            mDr.addTags(tags, {
                                save: false
                            });
                        }
                    }
                });
            }, this));
        }
    },
    clearTagInput: function () {
        this.$('.input-tag').val('');
        this.validateTag();
    },
    error: function () {

    },
    close: function () {
        this.removeModal();
        if (typeof this.options.onClose === 'function') {
            this.options.onClose();
        }
    }
});

PJQ.views.drawings.DrawingViewer = PJQ.views.photos.PhotoViewer.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DRAWINGS, 'drawing-viewer'),
        elementId: 'dv-outer',
        subTemplates: {
            versionSelect: new PJQ.templating.Template(PJQ.constants.modules.DRAWINGS, 'drawing-viewer-version-selector'),
            drawingDetails: new PJQ.templating.Template(PJQ.constants.modules.DRAWINGS, 'drawing-viewer-details')
        },
        annotationMenu: {
            type: PJQ.constants.drawings.annotationTypes.INSPECT
        },
        batch: null,
        isAnnotationsEnabled: false,
        onAnnotationChange: null,
        mergeAnnotations: null,
        canEdit: true,
        canAddAnnotations: true,
        shouldCreateCanvas: true,
        noNavigation: false,
        zoomValue: 100,
        snapView: true,
        isEdit: false,
        context: null,
        maxZoom: 500,
        refreshOnResize: true,
        zoomOnMouseWheel: true,
        triggerRoute: false,
        isDisableDownload: false,
        onSortChange: null,
        showSortableViewLink: true,
        keyListeners: [
            {
                which: 27,
                keys: ['Escape', 'Esc'],
                callback: function () {
                    this.destroy();
                }
            },
            {
                which: 37,
                callback: function () {
                    this.prevDrawing();
                }
            },
            {
                which: 13,
                callback: function () {
                    this.nextDrawing();
                }
            },
            {
                which: 66,
                shiftKey: true,
                callback: function () {
                    this.prevDrawing();
                }
            },
            {
                which: 39,
                callback: function () {
                    this.nextDrawing();
                }
            },
            {
                which: 78,
                shiftKey: true,
                callback: function () {
                    this.nextDrawing();
                }
            },
            {
                which: 68,
                shiftKey: true,
                callback: function () {
                    this.downloadFile();
                    $(window).focus();
                }
            },
            {
                which: 73,
                shiftKey: true,
                callback: function () {
                    this.viewDrawingDetails();
                }
            }
        ]
    },
    defaultEvents: {
        'click .iv-canvas,.iv-active-canvas': 'canvasClicked',
        'click .version-select': 'versionSelected',
        'click .btn-prev-drawing': 'prevDrawing',
        'click .btn-next-drawing': 'nextDrawing',
        'click .btn-drawing-details': 'viewDrawingDetails',
        'keyup .input-drawing-name': 'nameChanged',
        'keyup .input-drawing-title': 'titleChanged',
        'keyup .input-tag': 'drawingTagInputChanged',
        'click .btn-add-tag': 'addTag',
        'click .btn-delete-tag': 'deleteTag',
        'click .btn-add-to-current': 'addToCurrentSet',
        'click .btn-remove-from-current': 'removeFromCurrentSet',
        'click .btn-delete-pub-drawing': 'deletePublishedDrawing',
        'mouseup .iv-image-view': 'canvasMouseUp',
        'mousemove .iv-active-canvas': 'canvasMouseMove',
        'mouseleave .iv-active-canvas': 'canvasMouseLeave'
    },
    beforeRender: function () {
        this.options.project = PJQ.app.session.project;
        if (this.options.project != null) {
            this.options.isAnnotationsEnabled = this.options.batch == null;
            if (this.options.project.orderSettings) {
                this.options.isDisableDownload = this.options.project.orderSettings.get('downloadPerFileFee') > 0 && (PJQ.app.session.get('masterUserId') !== this.options.project.get('masterUserId') || this.options.project.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_ADMIN_PAID_DOWNLOADS));
            } else {
                this.options.isDisableDownload = true;
            }

            if (this.options.versions == null && !this.options.noNavigation) {
                this.options.project.fetchVersions((versions) => {
                    this.options.versions = versions;
                });
            }
        } else {
            this.options.isAnnotationsEnabled = this.options.batch == null;
        }
    },
    renderData: function () {
        return {
            options: this.options,
            showNavigationControls: this.options.versions != null
        };
    },
    initViewer: function () {
        // tracking mechanism for if any model was changed in this viewer session
        this.changed = false;
        this.options.canEditDrawing = this.options.canEdit && (!PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_DOCUMENT_CLERK_COMPANY) ||
            PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_DOCUMENT_CLERK));

        if (this.options.batch != null) {
            this.options.contextVersion = this.options.batch.version;
        }

        this.renderDrawingSelector();
        this.renderDrawingSort();
        this.setDrawing(this.model, this.options.contextVersion);
    },
    renderDrawingSort: function () {
        if (this.options.batch != null) {
            let $sort = this.$('.sort-container');
            new PJQ.views.drawings.SortDrawings({
                el: $sort,
                batch: this.options.batch,
                contextDrawing: this.model,
                showViewLink: this.options.showSortableViewLink,
                versions: this.options.versions,
                onChange: _.bind(function () {
                    this.changed = true;
                    if (typeof this.options.onSortChange === 'function') {
                        this.options.onSortChange();
                    }
                }, this)
            });
            $sort.removeClass('hidden');
        }
    },
    viewDrawingDetails: function () {
        let $drawingDetails = this.$('.drawing-details'),
            $btnDetails = this.$('.btn-drawing-details');
        if ($drawingDetails.hasClass('hidden')) {
            $btnDetails.addClass('text-primary');
            $drawingDetails.animateCSS('fadeInRight', _.bind(function () {
                this.refresh();
            }, this));
        } else {
            $btnDetails.removeClass('text-primary');
            $drawingDetails.animateCSS('fadeOutRight', _.bind(function () {
                this.refresh();
            }, this));
        }
    },
    addToCurrentSet: function () {
        new PJQ.views.modals.YesNo({
            header: "Add to Current Set",
            body: "Are you sure you want to add this drawing to the current set?  If this sheet number already exists in the current set, it will be replaced by this version.",
            onYes: _.bind(function () {
                this.model.patch(null, {
                    urlOptions: {
                        currentSet: true
                    },
                    success: _.bind(function () {
                        this.options.versions.fetch({
                            success: _.bind(function () {
                                let currentSet = this.options.versions.get(-1);
                                if (currentSet != null) {
                                    let existing = _.findWhere(currentSet.drawings.models, {title: this.model.get('title')});
                                    // remove any drawings that match this drawings title from the current set
                                    currentSet.drawings.remove(existing);
                                    // add this drawing to the current set
                                    currentSet.drawings.add(this.model);
                                }
                                this.renderVersionSelector();
                                this.renderDrawingDetails();
                            }, this)
                        });
                    }, this)
                });
            }, this)
        });
    },
    removeFromCurrentSet: function () {
        new PJQ.views.modals.YesNo({
            header: "Add to Current Set",
            body: "Are you sure you want to remove this drawing from the current set?",
            onYes: _.bind(function () {
                this.model.patch(null, {
                    urlOptions: {
                        currentSet: false
                    },
                    success: _.bind(function () {
                        this.options.versions.fetch({
                            success: _.bind(function () {
                                let currentSet = this.options.versions.get(-1);
                                if (currentSet != null) {
                                    currentSet.drawings.remove(this.model);
                                }
                                this.renderVersionSelector();
                                this.renderDrawingDetails();
                            }, this)
                        });
                    }, this)
                });
            }, this)
        });
    },
    deletePublishedDrawing: function () {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'drawings',
                    value: this.model.get('guid')
                },
                {
                    endpoint: 'checkattached'
                }
            ])
        }).get().done(_.bind(function (response) {
            new PJQ.views.modals.YesNo({
                header: "Delete Drawing",
                body: response.attached ? "<b>This drawing is currently attached to at least 1 item on this project.</b> Deleting the drawing will unlink it from all items. Are you sure you want to delete this drawing?" : "Are you sure you want to delete this drawing?",
                onYes: _.bind(function (model, data) {
                    this.model.destroy({
                        success: _.bind(function () {
                            let newCurSetDrawing = null;
                            _.each(this.options.versions.models, function (version) {
                                if (data && data.replacement > 0) {
                                    _.each(version.drawings.models, function (drawing) {
                                        if (drawing.id === data.replacement) {
                                            newCurSetDrawing = drawing;
                                            drawing.set('isCurrentSet', true);
                                        }
                                    }, this);
                                }
                                version.drawings.remove(this.model);
                            }, this);

                            this.renderDrawingSelector();

                            if (newCurSetDrawing != null) {
                                this.setDrawing(newCurSetDrawing);
                            }
                            // then try to go to the next drawing
                            else if (!this.nextDrawing()) {
                                // then try to go to the previous drawing
                                if (!this.prevDrawing()) {
                                    // next try to go to a different drawing in a different version
                                    let newDrawing = _.find(this.options.versions.models, function (version) {
                                        if (_.size(version.drawings.models) > 0) {
                                            return version.drawings.models[0];
                                        }
                                    }, this);
                                    if (newDrawing != null) {
                                        this.setDrawing(newDrawing);
                                    } else {
                                        // we couldnt find any other drawings to go to
                                        // close the viewer
                                        this.destroy();
                                    }
                                }
                            }

                            if (typeof this.options.onDelete === 'function') {
                                this.options.onDelete();
                            }

                            PJQ.notifications.notify.successNotify({
                                message: 'Drawing deleted'
                            });
                        }, this)
                    });
                }, this)
            });
        }, this));
    },
    prevDrawing: function () {
        let item = this.currentImg,
            canvas = this.canvas;
        this.prevItemInfo = {
            position: item.position(),
            size: this.imageDim,
            canvas: canvas
        };
        let contextDrawing = _.find(_.sortBy(this.fullSet, function (drawing) {
            return -drawing.get('sortOrder');
        }), _.bind(function (drawing) {
            return drawing.get('sortOrder') < this.model.get('sortOrder');
        }, this));
        if (contextDrawing != null) {
            this.setDrawing(contextDrawing);
            return true;
        }
        return false;
    },
    nextDrawing: function () {
        let item = this.currentImg,
            canvas = this.canvas;
        this.prevItemInfo = {
            position: item.position(),
            size: this.imageDim,
            canvas: canvas
        };
        let contextDrawing = _.find(_.sortBy(this.fullSet, function (drawing) {
            return drawing.get('sortOrder');
        }), _.bind(function (drawing) {
            return drawing.get('sortOrder') === this.model.get('sortOrder') + 1;
        }, this));

        if (contextDrawing == null) {
            contextDrawing = _.find(_.sortBy(this.fullSet, function (drawing) {
                return drawing.get('sortOrder');
            }), _.bind(function (drawing) {
                return drawing.get('sortOrder') > this.model.get('sortOrder');
            }, this));
        }

        if (contextDrawing != null) {
            this.setDrawing(contextDrawing);
            return true;
        }
        return false;
    },
    renderPagingState: function () {
        let hasPrevious = _.find(_.sortBy(this.fullSet, function (drawing) {
                return -drawing.get('sortOrder');
            }), _.bind(function (drawing) {
                return drawing.get('sortOrder') < this.model.get('sortOrder');
            }, this)) != null,
            hasNext = _.find(_.sortBy(this.fullSet, function (drawing) {
                return drawing.get('sortOrder');
            }), _.bind(function (drawing) {
                return drawing.get('sortOrder') > this.model.get('sortOrder');
            }, this)) != null;
        this.$('.btn-prev-drawing').prop('disabled', !hasPrevious);
        this.$('.btn-next-drawing').prop('disabled', !hasNext);
    },
    versionSelected: function (e) {
        let cid = $(e.currentTarget).data('cid');
        if (cid != null) {
            let ver = this.options.versions.get(cid),
                drawing = ver.drawings.findWhere({name: this.model.get('name')});
            this.setDrawing(drawing, ver);
        }
    },
    setContextVersion: function (version) {
        this.contextVersion = version;
        if (this.options.batch != null) {
            this.fullSet = _.filter(this.options.batch.drawings.models, function (drawing) {
                return !drawing.get('isPublished');
            });
        } else if (this.options.isEdit || this.contextVersion != null) {
            this.fullSet = this.contextVersion.drawings.models;
        } else {
            this.fullSet = this.options.versions.getUniqueDrawings();
        }

        this.renderDrawingSelector();
        this.renderDrawingSort();
    },
    setDrawing: function (drawing, version) {
        this.contextAnnotation = null;
        this.calibration = null;
        this.clearAnnotations();

        if (version != null) {
            this.setContextVersion(version);
        }

        if (this.options.versions != null && this.options.batch == null) {
            if (this.contextVersion == null) {
                // no version was provided, and we dont already have a context version
                // use the current set (if exists), else use the most recent version by issued on
                this.contextVersion = this.options.versions.get(-1);
                if (this.contextVersion == null) {
                    this.contextVersion = _.sortBy(this.options.versions.models, function (version) {
                        return -(new Date(version.get('issuedOn'))).getTime();
                    })[0];
                }
            }

            let fnFindByName = function (ver) {
                return _.find(ver.drawings.models, _.bind(function (verDrawing) {
                    return drawing.get('name') === verDrawing.get('name');
                }, this));
            }

            let contextVerDrawing = fnFindByName(this.contextVersion);
            if (contextVerDrawing != null) {
                this.model = contextVerDrawing;
                this.activeVersion = this.contextVersion;
            } else {
                // we weren't able to find the drawing in the context version
                // find the newest version that was published BEFORE the context version which does contain this drawing
                let contextVerIssued = (new Date(this.contextVersion.get('issuedOn'))).getTime(),
                    prevVersions = _.sortBy(_.filter(this.options.versions.models, _.bind(function (ver) {
                        return ver.id !== -1 && ver.id !== this.contextVersion.id && contextVerIssued >= (new Date(ver.get('issuedOn'))).getTime() && fnFindByName(ver) != null;
                    }, this)), function (version) {
                        return -(new Date(version.get('issuedOn'))).getTime();
                    });
                if (_.size(prevVersions) > 0) {
                    this.activeVersion = prevVersions[0];
                } else {
                    // we werent able to find this drawing in a version older than the context version
                    // find the oldest version we have of this drawing that is not the current set
                    this.activeVersion = _.sortBy(_.filter(this.options.versions.models, function (ver) {
                        return ver.id !== -1 && fnFindByName(ver) != null;
                    }), function (version) {
                        return (new Date(version.get('issuedOn'))).getTime();
                    })[0];
                }
                this.model = fnFindByName(this.activeVersion);
            }
        } else {
            if (version != null) {
                this.contextVersion = version;
                this.activeVersion = version;
            }
            this.model = drawing;
        }
        this.renderDrawing();
        this.renderPagingState();
        return {
            drawing: this.model,
            version: this.activeVersion
        };
    },
    renderDrawing: function () {
        if (this.drawingSelector != null) {
            this.drawingSelector.setValue(this.model.get('name'));
        }

        this.renderDrawingDetails();
        this.renderVersionSelector();
        this.show(this.model.renderUrl(), {
            persistZoom: true
        });

        if (this.options.project != null) {
            this.options.canViewAnnotations = this.options.project.permissions.hasPermission('drawings.canViewAnnotations');
            this.options.isAnnotationsAdmin = this.options.project.permissions.hasPermission('drawings.isAnnotationsAdmin');
        } else if (this.options.forShare) {
            this.options.canViewAnnotations = true;
            this.options.canAddAnnotations = false;
            this.options.isAnnotationsAdmin = false;
        } else {
            this.options.canViewAnnotations = PJQ.app.session.systemPermissions.hasPermission('drawings.canViewAnnotations');
            this.options.isAnnotationsAdmin = PJQ.app.session.systemPermissions.hasPermission('drawings.isAnnotationsAdmin');
        }

        if (this.options.isAnnotationsEnabled && this.options.canViewAnnotations) {
            this.model.fetchAnnotations({
                context: this.options.context,
                contextId: this.options.contextId,
                accessKey: this.options.accessKey
            }, _.bind(function (ann) {
                this.annotations = ann;

                if (this.options.mergeAnnotations != null) {
                    this.annotations.merge(this.options.mergeAnnotations, this.options.contextId);
                }
                this.renderAnnotations();
            }, this));
        } else {
            this.renderAnnotations();
        }
    },
    renderDrawingSelector: function () {
        let $controls = this.$('.drawing-nav-controls');
        if (this.options.noNavigation) {
            $controls.hide();
            return;
        }

        let choices = _.map(_.sortBy(this.fullSet, function (drawing) {
            return drawing.get('sortOrder');
        }), function (drawing) {
            return {
                id: drawing.get('name'),
                name: drawing.get('name')
            }
        });

        if (_.size(choices) === 0) {
            $controls.hide();
        } else if (this.drawingSelector != null) {
            this.drawingSelector.updateChoices(choices);
            this.drawingSelector.setValue(this.model.get('name'));
        } else {
            $controls.show();
            this.drawingSelector = new PJQ.inputs.Selectpicker({
                el: this.$('.select-drawing'),
                hideDisabled: true,
                defaultValue: this.model.get('name'),
                choices: choices,
                onChange: _.bind(function (value) {
                    let selectedDrawing;
                    if (this.contextVersion != null) {
                        selectedDrawing = this.contextVersion.drawings.findWhere({name: value});
                    }
                    if (selectedDrawing == null) {
                        selectedDrawing = _.find(this.fullSet, function (drawing) {
                            return drawing.get('name') === value;
                        });
                    }
                    this.setDrawing(selectedDrawing)
                }, this)
            });
        }
    },
    renderVersionSelector: function () {
        let $versionSelect = this.$('.drawing-versions');
        if (this.options.versions == null || this.options.noNavigation) {
            $versionSelect.empty();
            return;
        }

        if (this.options.batch == null && !this.options.isEdit) {
            let hideIssuedOn;
            if (this.options.project != null) {
                hideIssuedOn = this.options.project.preferences.hasPref(PJQ.constants.preferenceTypes.HIDE_VERSION_SELECTOR_ISSUED_ON);
            } else {
                hideIssuedOn = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.HIDE_VERSION_SELECTOR_ISSUED_ON);
            }
            this.renderSubTemplate(false, this.options.subTemplates.versionSelect, $versionSelect, {
                versions: this.options.versions.findVersionsForDrawing(this.model, true),
                contextVersion: this.activeVersion,
                showCurrentSetLabel: true,
                hideIssuedOn: hideIssuedOn,
                currentSet: this.options.versions && this.options.versions.get(-1)
            });
        }
    },
    renderDrawingDetails: function (callback) {
        if (this.options.versions == null) {
            this.$('.btn-drawing-details').addClass('hidden');
            return;
        }

        this.$('.btn-drawing-details').removeClass('hidden');

        let canEditTags = this.options.project != null
            && this.options.project.hasPermission('drawings.isAdmin')
            && (this.options.project.get('masterUserId') === PJQ.app.session.get('masterUserId'));
        this.renderSubTemplate(false, this.options.subTemplates.drawingDetails, this.$('.drawing-details'), {
            model: this.model,
            version: this.activeVersion,
            isEdit: this.options.isEdit,
            currentSet: this.options.versions.get(-1),
            canEditTags: canEditTags,
            canEditDrawing: this.options.canEditDrawing,
            canRemoveCurrentSet: this.options.canEdit
        }, _.bind(function ($details) {
            $details.find('.input-drawing-name,.input-drawing-title').on('keydown', _.bind(function (e) {
                if (e.which === 13) {
                    if (e.shiftKey) {
                        if (this.prevDrawing()) {
                            this.$('.input-drawing-name').focus().select();
                        }
                    } else {
                        if (this.nextDrawing()) {
                            this.$('.input-drawing-name').focus().select();
                        }
                    }
                }
            }, this));
            let tags = [],
                drawingTags = this.model.get('tags');
            _.each(this.options.versions.getDrawingTags(), _.bind(function (tag) {
                if (drawingTags != null && drawingTags.indexOf(tag) === -1 && tags.indexOf(tag) === -1) {
                    tags.push(tag);
                }
            }, this));
            if (_.size(tags) > 0 && canEditTags) {
                new PJQ.inputs.AutocompleteInput({
                    el: $details.find('.input-tag'),
                    source: tags
                });
            }
            if (typeof callback === 'function') {
                callback();
            }
        }, this));
    },
    download: function (e) {
        this.model.download($(e.currentTarget).data('annotations') === true, this.options.context, this.options.contextId);
    },
    nameChanged: function (e) {
        let name = $(e.currentTarget).val();
        this.model.set('name', name);
        this.renderDrawingSelector();
        this.changed = true;
    },
    titleChanged: function (e) {
        let title = $(e.currentTarget).val();
        this.model.set('title', title);
        this.changed = true;
    },
    drawingTagInputChanged: function (e) {
        let tagNameLen = _.size($(e.currentTarget).val().trim());
        if (e.keyCode === 13 && tagNameLen > 0) {
            this.addTag();
            return;
        }

        this.$('.btn-add-tag').prop('disabled', tagNameLen === 0);
        this.changed = true;
    },
    addTag: function () {
        let tagString = this.$('.input-tag').val(),
            tags = [];
        if (_.size(tagString) > 0) {
            _.each(tagString.split(','), function (tag) {
                let tagTrim = tag.trim();
                if (_.size(tagTrim) > 0) {
                    tags.push(tagTrim);
                }
            });
        }
        this.model.addTags(tags, null, _.bind(function () {
            this.renderDrawingDetails(_.bind(function () {
                this.$('.input-tag').focus();
            }, this));
        }, this));
        this.changed = true;
    },
    deleteTag: function (e) {
        let tagName = $(e.currentTarget).closest('.drawing-tag').data('name');
        this.model.deleteTag(tagName, null, _.bind(function () {
            this.renderDrawingDetails();
        }, this));
        this.changed = true;
    },
    deleteDrawing: function () {
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this drawing?",
            onDelete: _.bind(function () {
                this.model.destroy({
                    success: _.bind(function () {
                        this.changed = true;
                        this.options.versions.fetch({
                            success: _.bind(function () {
                                this.destroy();
                            }, this)
                        });
                    }, this)
                });
            }, this)
        });
    },
    scale: 1,
    mouse: {
        isClicked: false,
        isDrawing: false,
        isDragging: false,
        dragPoint: null,
        isMoving: false,
        moveContext: null,
        start: null,
        current: null,
        isCalibrating: false
    },
    relativeMouse: function (e) {
        let toCanvasX = (e.clientX - this.canvas.x),
            toCanvasY = (e.clientY - this.canvas.y);
        return {
            toCanvas: {
                x: toCanvasX,
                y: toCanvasY
            },
            x: toCanvasX * this.scale,
            y: toCanvasY * this.scale
        };
    },
    setMouseStart: function (e) {
        if (!e) {
            this.mouse.start = null;
            return;
        }
        this.mouse.start = this.relativeMouse(e);
        return this.mouse.start;
    },
    getMouse: function (e) {
        return {
            start: this.mouse.start,
            current: this.relativeMouse(e),
            dragPoint: this.mouse.dragPoint,
            moveContext: this.mouse.moveContext
        };
    },
    isClicked: function () {
        return this.mouse.isClicked === true;
    },
    isDrawing: function () {
        return this.mouse.isDrawing === true;
    },
    canDraw: function () {
        if (this.annotationMenu == null) {
            return false;
        }

        let type = this.annotationMenu.getType();
        return type !== PJQ.constants.drawings.annotationTypes.INSPECT;
    },
    isDragging: function () {
        return this.mouse.isDragging === true;
    },
    isMoving: function () {
        return this.mouse.isMoving === true;
    },
    isCalibrating: function () {
        return this.mouse.isCalibrating === true;
    },
    canEditAnnotations: function () {
        return !this.isDrawing() && this.annotationMenu != null && this.annotationMenu.getType() === PJQ.constants.drawings.annotationTypes.INSPECT;
    },
    startDraw: function (e) {
        this.setMouseStart(e);
        this.mouse.isDrawing = true;
        return this.getMouse(e);
    },
    stopDraw: function () {
        this.mouse.isDrawing = false;
        this.setMouseStart();
    },
    startMove: function (e) {
        this.setMouseStart(e);
        this.mouse.moveContext = {
            start: _.clone(this.contextAnnotation.attributes.start),
            end: _.clone(this.contextAnnotation.attributes.end),
            path: this.contextAnnotation.decodePath()
        }
        this.mouse.isMoving = true;
    },
    stopMove: function () {
        this.mouse.isMoving = false;
        this.moveContext = null;
        this.setMouseStart();
    },
    startDrag: function (dragPoint) {
        this.mouse.isDragging = true;
        this.mouse.dragPoint = dragPoint;
    },
    stopDrag: function () {
        this.mouse.isDragging = false;
        this.mouse.dragPoint = null;
    },
    startCalibrating: function (e) {
        let start = this.setMouseStart(e);
        this.calibration = {
            start: {
                x: start.x,
                y: start.y
            }
        };
        this.mouse.isCalibrating = true;
    },
    stopCalibrating: function () {
        this.mouse.isCalibrating = false;
        this.setMouseStart();
        this.startCalibrationStep(2);
    },
    drawCalibration: function () {
        if (this.activeCtx != null && this.calibration != null && this.calibration.end != null) {
            this.clearCanvas(this.activeCtx);
            let start = {
                    x: this.calibration.start.x / this.scale,
                    y: this.calibration.start.y / this.scale
                },
                end = {
                    x: this.calibration.end.x / this.scale,
                    y: this.calibration.end.y / this.scale
                },
                terminatorHeight = 40 / this.scale,
                terminatorHalf = terminatorHeight / 2;
            this.activeCtx.beginPath();
            this.activeCtx.moveTo(start.x, start.y);
            this.activeCtx.lineTo(end.x, end.y);
            this.activeCtx.moveTo(start.x, start.y - terminatorHalf);
            this.activeCtx.lineTo(start.x, start.y + terminatorHalf);
            this.activeCtx.moveTo(end.x, end.y - terminatorHalf);
            this.activeCtx.lineTo(end.x, end.y + terminatorHalf);
            this.activeCtx.lineWidth = 4 / this.scale;
            this.activeCtx.setLineDash([0]);
            this.activeCtx.strokeStyle = PJQ.constants.colors.RED;
            this.activeCtx.stroke();
        }
    },
    closeCalibration: function () {
        this.$('.calibration-outer').remove();
        this.calibration = null;
        this.drawAnnotations();
    },
    startCalibrationStep: function (step) {
        let stepContent,
            fnAfterRender = null;
        switch (step) {
            case 1:
                stepContent = '<div class="fs-28">Start the calibration by drawing a line on a known length</div>';
                break;
            case 2:
                stepContent = `<div class="fs-24 mb-1">Enter the length of the drawn line</div>
								<div class="input-group">
									<div class="calibration-type mr-3"></div>
									<input class="form-control calibration-imperial calibration-length-feet wd-80p">
									<span class="calibration-imperial ml-1 mr-2 fs-18 d-flex align-items-center">feet</span>
									<input class="form-control calibration-imperial calibration-length-inches wd-80p">
									<span class="calibration-imperial ml-1 fs-18 d-flex align-items-center">inches</span>
									<input class="form-control calibration-metric wd-100p hidden" placeholder="i.e. 10cm, 10m, 10km">
								</div>
								<div class="mt-2">
									<button class="btn btn-primary btn-save-calibration">Save Calibration</button>
									<button class="btn btn-secondary btn-cancel-calibration">Cancel</button>
								</div>`;
                fnAfterRender = _.bind(function () {
                    let calibrationTypeBtn = new PJQ.inputs.ButtonGroup({
                        el: this.$('.calibration-type'),
                        colorInactiveButtons: true,
                        buttons: [{
                            colorClass: 'info',
                            label: 'Imperial',
                            value: PJQ.constants.drawings.scaleTypes.IMPERIAL
                        }, {
                            colorClass: 'info',
                            label: 'Metric',
                            value: PJQ.constants.drawings.scaleTypes.METRIC
                        }],
                        buttonClasses: 'wd-80p',
                        fitHeight: true,
                        defaultValue: PJQ.constants.drawings.scaleTypes.IMPERIAL,
                        onChange: _.bind(function (value) {
                            let $metric = this.$('.calibration-metric'),
                                $imperial = this.$('.calibration-imperial');
                            if (value === PJQ.constants.drawings.scaleTypes.METRIC) {
                                $imperial.addClass('hidden');
                                $metric.removeClass('hidden');
                            } else {
                                $metric.addClass('hidden');
                                $imperial.removeClass('hidden');
                            }
                        }, this)
                    });

                    this.$('.btn-save-calibration').on('click', _.bind(function () {
                        let dx = this.calibration.end.x - this.calibration.start.x,
                            dy = this.calibration.end.y - this.calibration.start.y,
                            d = Math.sqrt(dx * dx + dy * dy),
                            calibrationType = calibrationTypeBtn.getValue(),
                            scale = null;
                        if (calibrationType.toUpperCase() === PJQ.constants.drawings.scaleTypes.IMPERIAL) {
                            let $feet = this.$('.calibration-length-feet'),
                                $inches = this.$('.calibration-length-inches'),
                                feet = parseInt($feet.val()),
                                inches = parseInt($inches.val());
                            if (isNaN(feet)) {
                                feet = 0;
                            }
                            if (isNaN(inches)) {
                                inches = 0;
                            }
                            scale = d / ((feet * 12) + inches);
                        } else {

                        }

                        if (scale > 0) {
                            this.model.updateScale(Math.round(scale), calibrationType, _.bind(function () {
                                PJQ.notifications.notify.successNotify({
                                    message: 'Calibration saved'
                                });
                                this.closeCalibration();
                                if (this.annotationMenu != null) {
                                    let nextType;
                                    if (this.afterCalibrateType != null) {
                                        nextType = this.afterCalibrateType;
                                    } else {
                                        nextType = PJQ.constants.drawings.annotationTypes.INSPECT;
                                    }
                                    this.annotationMenu.setType(nextType);
                                }
                                this.afterCalibrateType = null;
                            }, this));
                        }
                    }, this));
                    this.$('.btn-cancel-calibration').on('click', _.bind(function () {
                        this.closeCalibration();
                    }, this));
                }, this);
                break;
        }
        this.$('.calibration-outer').remove();
        this.imageView.append('<div class="calibration-outer"><div class="calibration-inner">' + stepContent + '</div></div>');

        if (typeof fnAfterRender === 'function') {
            fnAfterRender();
        }
    },
    onMouseDown: function (e) {
        if (this.annotations == null) {
            return;
        }

        this.mouse.isClicked = true;

        let mouse = this.getMouse(e);
        if (this.contextAnnotation != null && !this.isDrawing()) {
            let collidingDragPoint = this.contextAnnotation.getCollidingDragPoint(mouse.current.toCanvas.x, mouse.current.toCanvas.y);
            if (collidingDragPoint != null) {
                this.startDrag(collidingDragPoint);
                return false;
            }
        }

        let fnFindColliding = () => {
            if (this.isMoving() || this.isDrawing() || this.isDragging()) {
                return false;
            }

            let colliding = this.annotations.find((a) => {
                return a.cid !== this.contextAnnotation?.cid && a.collides(mouse.current.x, mouse.current.y);
            });
            if (colliding != null) {
                this.editAnnotation(colliding);
                return true;
            }
            return false;
        }

        if (!this.options.canAddAnnotations) {
            fnFindColliding();
            return false;
        }

        let canEdit = this.canEditAnnotations(),
            annotationType = this.annotationMenu?.getType();
        if (this.annotationMenu != null && annotationType === PJQ.constants.drawings.annotationTypes.CALIBRATION) {
            this.setContextAnnotation(null);
            this.startCalibrating(e);
            return false;
        } else if ((canEdit || this.annotationMenu == null) && annotationType === PJQ.constants.drawings.annotationTypes.INSPECT) {
            if (this.contextAnnotation != null && this.contextAnnotation.canEdit()) {
                if (this.contextAnnotation.collides(mouse.current.x, mouse.current.y)) {
                    //this currently selected annotation collides
                    // loop through colliding items and find the next one
                    setTimeout(() => {
                        if (this.isClicked()) {
                            this.startMove(e);
                            return;
                        }

                        fnFindColliding();
                    }, 100);
                    return !canEdit;
                }
            }

            if (fnFindColliding()) {
                return true;
            }

            if (!this.isMoving() && !this.isDrawing() && !this.isDragging()) {
                setTimeout(_.bind(function () {
                    //if its still clicked, then its moving/dragging/drawing
                    if (!this.isClicked()) {
                        this.cancelEditAnnotation();
                    }
                }, this), 100);
            }
        } else {
            if (this.contextAnnotation != null) {
                this.setContextAnnotation(null);
            }
            if (annotationType !== PJQ.constants.drawings.annotationTypes.INSPECT) {
                this.startDraw(e);
            }
            return false;
        }
    },
    canvasMouseMove: function (e) {
        if (this.isCalibrating()) {
            let mouse = this.getMouse(e);
            this.calibration.end = {
                x: mouse.current.x,
                y: mouse.current.y
            };
            this.drawCalibration(e);
        } else if (this.isDrawing()) {
            let mouse = this.getMouse(e);
            if (this.contextAnnotation == null) {
                let newAnnotation = this.annotations.model({
                    drawingId: this.model.id,
                    type: this.annotationMenu.getType(),
                    color: this.annotationMenu.getColor(),
                    context: this.options.context,
                    contextId: this.options.contextId
                });
                this.setContextAnnotation(newAnnotation);
            }
            this.contextAnnotation.start(mouse.start.x, mouse.start.y);
            this.contextAnnotation.end(mouse.current.x, mouse.current.y);
            this.drawContextAnnotation();
        } else if (this.isDragging()) {
            let mouse = this.getMouse(e);
            this.contextAnnotation.moveDragPoint(mouse.dragPoint, mouse.current.x, mouse.current.y);
            this.drawContextAnnotation();
        } else if (this.isMoving()) {
            let mouse = this.getMouse(e),
                xDiff = mouse.current.x - mouse.start.x,
                yDiff = mouse.current.y - mouse.start.y;
            if (_.size(mouse.moveContext.path) > 0) {
                let newStartX = mouse.moveContext.path[0][0] + xDiff,
                    newStartY = mouse.moveContext.path[0][1] + yDiff;
                this.contextAnnotation.start(newStartX, newStartY);
                this.drawContextAnnotation();
            } else if (mouse.moveContext.start != null && mouse.moveContext.end != null) {
                let newStartX = mouse.moveContext.start.x + xDiff,
                    newStartY = mouse.moveContext.start.y + yDiff,
                    newEndX = mouse.moveContext.end.x + xDiff,
                    newEndY = mouse.moveContext.end.y + yDiff,
                    maxX = this.model.attributes.pixelsX,
                    maxY = this.model.attributes.pixelsY;

                if (newStartX < 0) {
                    newEndX -= newStartX;
                    newStartX = 0;
                } else if (newEndX >= maxX) {
                    newStartX -= newEndX - maxX;
                    newEndX = maxX;
                }

                if (newStartY < 0) {
                    newEndY -= newStartY;
                    newStartY = 0;
                } else if (newEndY >= maxY) {
                    newStartY -= newEndY - maxY;
                    newEndY = maxY;
                }

                this.contextAnnotation.start(newStartX, newStartY);
                this.contextAnnotation.end(newEndX, newEndY);
                this.drawContextAnnotation();
            }
        }
    },
    saveAnnotation: function (annotation) {
        if (typeof this.options.onAnnotationChange === 'function') {
            this.options.onAnnotationChange(annotation);
        } else {
            this.contextAnnotation.beforeSave();
            this.contextAnnotation.isNew() ? this.contextAnnotation.queueSave() : this.contextAnnotation.queuePatch();
        }
    },
    canvasMouseUp: function (e) {
        this.mouse.isClicked = false;
        if (this.isCalibrating()) {
            this.stopCalibrating();
        } else if (this.isDrawing() || this.isDragging() || this.isMoving()) {
            let fnSave = _.bind(function () {
                if (this.contextAnnotation.hasChanged()) {
                    this.saveAnnotation(this.contextAnnotation);
                }
            }, this);
            if (this.isDrawing()) {
                this.stopDraw();
                this.contextAnnotation.normalizeCoords(true);
                this.annotations.add(this.contextAnnotation);
                fnSave();
                this.editAnnotation(this.contextAnnotation);

                if (!this.annotationMenu.enableConsecutive) {
                    this.annotationMenu.setType(PJQ.constants.drawings.annotationTypes.INSPECT);
                }
            } else if (this.isDragging()) {
                this.stopDrag();
                this.contextAnnotation.normalizeCoords();
                fnSave();
            } else if (this.isMoving()) {
                this.stopMove();
                fnSave();
            }
        }
    },
    canvasMouseLeave: function () {
        this.mouse.isClicked = false;
        if (this.isDrawing()) {
            // this.stopDraw();
        }
        if (this.isDragging()) {
            this.stopDrag();
        }
        if (this.isMoving()) {
            this.stopMove();
        }
    },
    updateScale: function () {
        this.scale = this.model.attributes.pixelsX / this.canvas.width;
    },
    afterDimensionChange: function () {
        this.updateScale();
        this.renderAnnotations();
    },
    afterLoad: function () {
        this.renderAnnotations();
    },
    renderAnnotations: function () {
        if (this.options.isAnnotationsEnabled && this.loaded && this.annotations && this.annotations.isFetched) {
            this.clearAnnotations();
            this.renderAnnotationMenu();
            this.drawAnnotations();
        }
    },
    clearCanvas: function (ct) {
        if (ct != null) {
            // ct.clearRect(0, 0, this.canvas.width, this.canvas.height);
            ct.reset();
        }
    },
    clearAnnotations: function () {
        this.clearCanvas(this.ctx);
        this.clearCanvas(this.activeCtx);
    },
    drawAnnotations: function () {
        this.drawContextAnnotation();
        if (this.calibration != null) {
            this.drawCalibration();
        }

        this.clearCanvas(this.ctx);
        _.each(_.filter(this.annotations.models, (annotation) => {
            return !annotation.get('delete') && (this.options.contextId == null || annotation.get('contextId') == null || (annotation.get('contextId') === this.options.contextId && annotation.get('context') === this.options.context));
        }), function (annotation) {
            if (this.contextAnnotation != null && this.contextAnnotation.cid === annotation.cid) {
                return;
            }
            annotation.draw(this.ctx, this.scale, {
                isDrawing: false,
                drawing: this.model
            });
        }, this);
    },
    drawContextAnnotation: function () {
        this.clearCanvas(this.activeCtx);
        if (this.contextAnnotation != null) {
            this.contextAnnotation.draw(this.activeCtx, this.scale, {
                isDrawing: this.isDrawing(),
                drawing: this.model
            });
            if (!this.isDrawing() && (this.options.isAnnotationsAdmin || !this.contextAnnotation.get('isPublished'))) {
                this.contextAnnotation.drawDragPoints(this.activeCtx, this.scale);
            }
        }
    },
    editAnnotation: function (annotation) {
        this.setContextAnnotation(annotation, true);
        this.removeEditView();

        let $iv = this.$('.iv-content'),
            $editOuter = this.$('.annotation-edit-outer');
        if ($editOuter.length === 0) {
            $editOuter = $('<div>', {
                class: 'annotation-edit-outer ht-100 wd-350p position-absolute right-0 top-0 elevation-3'
            });
            $iv.append($editOuter);
        }
        $iv.addClass('annotating');

        this.editAnnotationView = new PJQ.views.drawings.EditAnnotation({
            el: $editOuter,
            model: annotation,
            project: this.options.project,
            context: this.options.context,
            versions: this.options.versions,
            canEdit: this.options.isAnnotationsAdmin || annotation.canEdit(),
            isAdmin: this.options.isAnnotationsAdmin,
            focusText: annotation.isNew() && annotation.get('type') === PJQ.constants.drawings.annotationTypes.TEXT,
            onAttachmentChange: () => {
                this.saveAnnotation(annotation);
            },
            onAnnotationDataChange: () => {
                this.drawContextAnnotation();
                this.saveAnnotation(annotation);
            },
            onShapeChange: () => {
                this.drawContextAnnotation();
                this.saveAnnotation(annotation);
            },
            onPublish: (annotation) => {
                this.publishAnnotation(annotation);
            },
            onDelete: (annotation) => {
                this.deleteAnnotation(annotation);
            },
            onClose: () => {
                this.cancelEditAnnotation();
            },
            onDrawingSelected: (drawing) => {
                this.cancelEditAnnotation();
                this.setDrawing(drawing);
            }
        });
    },
    cancelEditAnnotation() {
        this.setContextAnnotation(null, true);
        this.removeEditView();
    },
    removeEditView: function () {
        if (this.editAnnotationView != null) {
            this.editAnnotationView.remove();
            this.editAnnotationView = null;
            this.$('.iv-content').removeClass('annotating');
        }
    },
    publishAnnotation: function (annotation) {
        if (annotation != null) {
            annotation.set('isPublished', !annotation.get('isPublished'));
            if (typeof this.options.onAnnotationChange === 'function') {
                this.options.onAnnotationChange(annotation);
            } else {
                annotation.publish();
            }
        }
    },
    deleteAnnotation: function (annotation) {
        if (annotation != null) {
            if (typeof this.options.onAnnotationChange === 'function') {
                annotation.set('delete', true);
                this.options.onAnnotationChange(annotation);
            } else {
                this.annotations.remove(annotation);
                annotation.destroy();
                this.cancelEditAnnotation();
            }
        }
    },
    setContextAnnotation: function (annotation = null, redraw = true) {
        let enablePicker = annotation == null || annotation.canEditColor();
        if (this.annotationMenu != null) {
            this.annotationMenu.enableColorPicker(enablePicker);
        }

        if (annotation) {
            this.contextAnnotation = annotation;
            if (this.annotationMenu != null && enablePicker) {
                this.annotationMenu.setColor(this.contextAnnotation.getStrokeColor());
            }
            if (this.$canvas) {
                this.$canvas.css('opacity', '0.5');
            }
        } else {
            this.contextAnnotation = null;
            if (this.$canvas) {
                this.$canvas.css('opacity', 'initial');
            }
        }

        if (redraw) {
            this.drawAnnotations();
        }
    },
    canvasClicked: function () {
        if (this.annotationMenu != null) {
            this.annotationMenu.collapseSubMenus();
        }
    },
    renderAnnotationMenu: function () {
        if (this.annotationMenu != null) {
            this.annotationMenu.remove();
        }

        if (this.options.canAddAnnotations === false) {
            return;
        }

        this.annotationMenu = new PJQ.views.drawings.AnnotationMenu({
            el: this.$('.annotation-menu-outer'),
            type: this.options.annotationMenu.type,
            color: this.options.annotationMenu.color,
            project: this.options.project,
            onColorChange: _.bind(function (color) {
                this.options.annotationMenu.color = color;
                if (this.contextAnnotation != null) {
                    this.contextAnnotation.set('color', color);
                    this.drawContextAnnotation();
                    this.contextAnnotation.isNew() ? this.contextAnnotation.queueSave() : this.contextAnnotation.queuePatch();
                }
            }, this),
            onTypeChange: _.bind(function (type) {
                if (type !== PJQ.constants.drawings.annotationTypes.INSPECT) {
                    this.setContextAnnotation(null, false);
                }

                this.options.annotationMenu.type = type;
                this.drawAnnotations();
                if (this.canDraw()) {
                    this.$activeCanvas.addClass('annotate');
                } else {
                    this.$activeCanvas.removeClass('annotate');
                }

                if (this.model.get('scale') == null && (type === PJQ.constants.drawings.annotationTypes.RULER || type === PJQ.constants.drawings.annotationTypes.AREA_RECT
                    || type === PJQ.constants.drawings.annotationTypes.RULER_FREE_FORM || type === PJQ.constants.drawings.annotationTypes.AREA_FREE_FORM)) {
                    this.afterCalibrateType = type;
                    type = PJQ.constants.drawings.annotationTypes.CALIBRATION;
                    this.annotationMenu.setType(type);
                }

                if (type === PJQ.constants.drawings.annotationTypes.CALIBRATION) {
                    this.startCalibrationStep(1);
                } else {
                    this.closeCalibration();
                }
            }, this)
        });
    },
    onClose: function () {
        if (typeof this.options.onClose === 'function') {
            this.options.onClose(this.changed === true);
        }
    },
});

PJQ.views.drawings.AnnotationMenu = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DRAWINGS, 'annotation-menu'),
        color: PJQ.constants.colors.BLUE,
        onTypeChange: null,
        onColorChange: null,
        enableConsecutive: false
    },
    events: {
        'click .sub-menu-item': 'subMenuItemClicked',
        'click .consecutive-item': 'consecutiveItemClicked',
        'click .color-picker-item': 'colorPickerMenuItemClicked',
        'click .menu-item': 'typeClicked',
        'click .iv-content': 'collapseAnnotationMenu',
    },
    beforeFirstRender: function () {
        this.enableConsecutive = 'true' === PJQ.helpers.cookieHelpers.getCookie(PJQ.constants.cookies.ENABLE_CONSECUTIVE_DRAWING_ANNOTATIONS);
        if (this.options.type == null) {
            this.options.type = PJQ.constants.drawings.annotationTypes.INSPECT;
        }
    },
    renderData: function () {
        return {
            enableConsecutive: this.enableConsecutive,
            type: this.getType(),
            color: this.getColor(),
            canViewPunchList: this.options.project.permissions.hasPermission('punchList.canView'),
            canViewActionItems: this.options.project.permissions.hasPermission('actionItems.canView'),
            enableRefs: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_DRAWING_ANNOTATION_REFS)
        };
    },
    afterRender: function () {
        this.renderColorPicker();
    },
    renderColorPicker: function () {
        this.colorPicker = new PJQ.colors.SimpleColorPicker(this.$('.color-menu-outer'), {
            color: this.options.color,
            onColorPicked: _.bind(function (color) {
                this.colorClicked(color);
            }, this)
        });
    },
    colorClicked: function (color) {
        this.options.color = color;
        this.$('.active-color').css('background', this.options.color);
        if (typeof this.options.onColorChange === 'function') {
            this.options.onColorChange(this.options.color);
        }
        this.render();
    },
    colorPickerMenuItemClicked: function () {
        if (this.colorPickerEnabled === false) {
            return;
        }

        this.collapseSubMenus();
        this.colorPicker.toggle();
    },
    hideColorPicker: function () {
        if (this.colorPicker != null) {
            this.colorPicker.hide();
        }
    },
    setColor: function (color) {
        this.options.color = color;
        if (this.colorPicker != null) {
            this.colorPicker.setColor(this.options.color);
            this.render();
        }
    },
    getColor: function () {
        return this.options.color;
    },
    typeClicked: function (e) {
        e.stopPropagation();
        let $target = $(e.currentTarget),
            selectedType = $target.data('type');
        if (selectedType != null && selectedType !== this.options.type) {
            this.setType(selectedType);
        } else {
            this.render();
        }
    },
    setType: function (type) {
        this.options.type = type;
        this.render();
        if (typeof this.options.onTypeChange === 'function') {
            this.options.onTypeChange(this.options.type);
        }

        this.enableColorPicker(PJQ.models.drawings.Annotation.prototype.canEditColor(this.options.type));
    },
    getType: function () {
        return this.options.type;
    },
    subMenuItemClicked: function (e) {
        let $target = $(e.currentTarget),
            isActive = $target.hasClass('active');
        this.collapseSubMenus();
        if (!isActive) {
            $target.addClass('active');
        }
    },
    consecutiveItemClicked: function () {
        this.enableConsecutive = !this.enableConsecutive;
        PJQ.helpers.cookieHelpers.setCookie(PJQ.constants.cookies.ENABLE_CONSECUTIVE_DRAWING_ANNOTATIONS, this.enableConsecutive.toString());
        this.render();
    },
    collapseSubMenus: function (hideColorPicker = false) {
        this.$('.sub-menu-item').removeClass('active');
        if (hideColorPicker) {
            this.hideColorPicker();
        }
    },
    enableColorPicker: function (enabled) {
        let $colorPicker = this.$('.color-picker-item');
        if (enabled) {
            $colorPicker.removeClass('op-3');
        } else {
            $colorPicker.addClass('op-3');
        }
        this.colorPickerEnabled = enabled;
    }
});

PJQ.views.drawings.DrawingAreaHighlight = PJQ.views.drawings.DrawingViewer.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.DRAWINGS, 'Drawing-Area-Highlight'),
		canEdit: true,
		shouldCreateCanvas: true,
		zoomValue: 100,
		snapView: true,
		isEdit: false,
		context: null,
		maxZoom: 500,
		refreshOnResize: true,
		zoomOnMouseWheel: true,
		isHighlighting: false,
		keyListeners: []
	},
	events: {
		'click .btn-select-name': 'selectName',
		'click .btn-select-title': 'selectTitle',
		'mousedown .iv-image-view': 'canvasMouseDown',
		'mouseup .iv-image-view': 'canvasMouseUp',
		'mousemove .iv-image-view': 'canvasMouseMove',
		'click .btn-save': 'save'
	},
	canvasX: 0,
	canvasY: 0,
	mouse: {
		startX: 0,
		startY: 0
	},
	getMouse: function (e) {
		return {
			x: parseInt((e.clientX - this.canvasX) * this.scale),
			y: parseInt((e.clientY - this.canvasY) * this.scale),
			startX: this.mouse.startX,
			startY: this.mouse.startY
		};
	},
	renderDrawingDetails: function () {
		// override from base view - we never want this to do anything in the area picker
	},
	startMouse: function (e) {
		this.canvasX = this.$canvas.offset().left;
		this.canvasY = this.$canvas.offset().top;
		this.mouse.startX = parseInt((e.clientX - this.canvasX) * this.scale);
		this.mouse.startY = parseInt((e.clientY - this.canvasY) * this.scale);
	},
	canvasMouseDown: function (e) {
		if (!this.options.isHighlighting) {
			return false;
		}
		this.startMouse(e);
		this.mousedown = true;

		let curMouse = this.getMouse(e);
		this.contextLayer.set({
			x: curMouse.startX,
			y: curMouse.startY
		});
	},
	canvasMouseUp: function () {
		this.mousedown = false;
		if (this.contextLayer != null) {
			if (this.contextLayer.get('width') < 0) {
				let wd = this.contextLayer.get('width');
				this.contextLayer.set({
					width: -wd,
					x: this.contextLayer.get('x') + wd
				});
			}

			if (this.contextLayer.get('height') < 0) {
				let ht = this.contextLayer.get('height');
				this.contextLayer.set({
					height: -ht,
					y: this.contextLayer.get('y') + ht
				});
			}

			if (this.contextLayer.get('width') + this.contextLayer.get('x') > this.model.get('pixelsX')) {
				this.contextLayer.set('width', this.model.get('pixelsX') - this.contextLayer.get('x'));
			}

			if (this.contextLayer.get('height') + this.contextLayer.get('y') > this.model.get('pixelsY')) {
				this.contextLayer.set('height', this.model.get('pixelsY') - this.contextLayer.get('y'));
			}

			this.contextLayer = null;
			this.options.isHighlighting = false;
			this.$activeCanvas.removeClass('annotate');
			this.renderSelectionActions();
		}
	},
	canvasMouseMove: function (e) {
		if (!this.options.isHighlighting || !this.mousedown) {
			return;
		}

		let curMouse = this.getMouse(e);
		this.contextLayer.set({
			width: curMouse.x - curMouse.startX,
			height: curMouse.y - curMouse.startY,
		});
		this.renderAnnotations();
	},
	renderAnnotations: function () {
		if (this.loaded) {
			this.clearCanvas(this.activeCtx);
			if (this.nameLayer != null) {
				this.drawRectangle(this.nameLayer);
			}
			if (this.titleLayer != null) {
				this.drawRectangle(this.titleLayer);
			}
		}
	},
	drawRectangle: function (rect) {
		this.activeCtx.beginPath();
		this.activeCtx.rect(rect.get('x') / this.scale, rect.get('y') / this.scale, rect.get('width') / this.scale, rect.get('height') / this.scale);
		this.activeCtx.fillStyle = rect.get('color');
		this.activeCtx.fill();
	},
	selectName: function () {
		if (this.options.isHighlighting) {
			this.contextLayer = null;
			this.options.isHighlighting = false
			this.$activeCanvas.removeClass('annotate');
		}
		else {
			this.options.isHighlighting = true;
			this.$activeCanvas.addClass('annotate');
			this.nameLayer = null;
			this.renderAnnotations();
			this.nameLayer = new PJQ.models.BaseModel({
				layerId: 'name',
				type: 'rect',
				color: '#4caf5075'
			});
			this.contextLayer = this.nameLayer;
		}
		this.renderSelectionActions();
	},
	selectTitle: function () {
		if (this.options.isHighlighting) {
			this.contextLayer = null;
			this.options.isHighlighting = false;
			this.$activeCanvas.removeClass('annotate');
		}
		else {
			this.options.isHighlighting = true;
			this.$activeCanvas.addClass('annotate');
			this.titleLayer = null;
			this.renderAnnotations();
			this.titleLayer = new PJQ.models.BaseModel({
				layerId: 'title',
				type: 'rect',
				color: '#ef6c0075'
			});
			this.contextLayer = this.titleLayer;
		}
		this.renderSelectionActions();
	},
	renderSelectionActions: function () {
		if (this.contextLayer != null) {
			if (this.contextLayer.get('layerId') === 'title') {
				this.$('.btn-select-name').prop('disabled', true);
				this.$('.btn-select-title').text('Stop Selecting Title').prop('disabled', false);
			}
			else if (this.contextLayer.get('layerId') === 'name') {
				this.$('.btn-select-title').prop('disabled', true);
				this.$('.btn-select-name').text('Stop Selecting Name').prop('disabled', false);
			}
		}
		else {
			this.$('.btn-select-name').text(this.nameLayer != null ? 'Change Name Area' : 'Select Name Area').prop('disabled', false);
			this.$('.btn-select-title').text(this.titleLayer != null ? 'Change Title Area' : 'Select Title Area').prop('disabled', false);
		}

	},
	canDrag: function () {
		return !this.options.isHighlighting;
	},
	save: function () {
		if (typeof this.options.onSave === 'function') {
			this.options.onSave({
				layers: {
					name: this.nameLayer,
					title: this.titleLayer
				}
			});
			this.destroy();
		}
	}
});
PJQ.helpers.drawings = {
	createDownload: function (project, versions, options) {
		let params = [];
		if (options) {
			if (options.raster) {
				params.push({
					parameter: 'raster',
					value: options.raster
				});
			}
			if (options.merge) {
				params.push({
					parameter: 'merge',
					value: options.merge
				});
			}

			if (options.includeAttachments) {
				params.push({
					parameter: 'attachments',
					value: options.includeAttachments
				});
			}

			if (options.includeMyAnnotations || options.includePublishedAnnotations) {
				let annotationMode = 0;
				if (options.includeMyAnnotations && options.includePublishedAnnotations) {
					annotationMode = 3;
				}
				else if (options.includeMyAnnotations) {
					annotationMode = 1;
				}
				else if (options.includePublishedAnnotations) {
					annotationMode = 2;
				}
				params.push({
					parameter: 'annotationMode',
					value: annotationMode
				});
			}
		}

		if (_.size(PJQ.app.session.get('accessKey')) > 0) {
			params.push({
				parameter: 'accessKey',
				value: PJQ.app.session.get('accessKey')
			});
		}

		let versionsObj = {},
			arr = [];

		if (project != null) {
			arr.push({
				endpoint: 'projects',
				value: project.id
			});
		}
		arr.push({
			endpoint: 'drawings'
		});
		arr.push({
			endpoint: 'downloads'
		});

		_.each(versions, function (version) {
			versionsObj[version.versionId] = version.guids;
		});
		let endpoint = PJQ.helpers.urlHelpers.generateEndpoint(arr, params),
			data = {
				versions: versionsObj
			};
		PJQ.files.queueDownload(endpoint, data);
	},
	getUnPublishedBatchesCount: function (projectId, callback) {
		new PJQ.ajax.Request({
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'projects',
					value: projectId
				},
				{
					endpoint: 'drawings'
				},
				{
					endpoint: 'batches'
				},
				{
					endpoint: 'unpublished'
				}
			])
		}).get().done(function (data) {
			callback(data.count);
		}).fail(function () {
			callback(null);
		});
	}
};
PJQ.models.drawings.Version = PJQ.models.BaseModel.extend({
    idAttribute: 'versionId',
    notifyName: 'Version',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.get('projectId')
            },
            {
                endpoint: 'versions',
                value: this.id
            }
        ]);
    },
    parse: function (model) {
        this.drawings = new PJQ.collections.drawings.Drawings(model.drawings);
        this.listenTo(this.drawings, 'change', _.bind(function () {
            this.trigger('change');
        }, this));
        return model;
    },
    beforeSave: function () {
        this.set('drawings', this.drawings.getChangedModels());
    },
    download: function () {
        PJQ.files.queueDownload(this.endpoint() + '/download');
    },
    getDrawingTags: function () {
        let tags = [];
        _.each(this.drawings.models, function (drawing) {
            let drawingTags = drawing.get('tags');
            if (_.size(drawingTags) > 0) {
                tags.push(...drawingTags);
            }
        });
        return _.uniq(tags);
    }
});

PJQ.models.drawings.DrawingBatch = PJQ.models.BaseModel.extend({
    idAttribute: 'batchId',
    notifyName: 'Batch',
    defaults: {
        isFileAPI: true
    },
    endpoint: function (urlOpts) {
        if (this.id > 0) {
            let params = null;
            if (urlOpts && urlOpts.publish) {
                params = [
                    {
                        parameter: 'publish',
                        value: true
                    }
                ];

                if (urlOpts.billRawFileUploadId) {
                    params.push({
                        parameter: 'billRawFileUploadId',
                        value: urlOpts.billRawFileUploadId
                    });
                }
                if (urlOpts.billDeerfieldTicketId) {
                    params.push({
                        parameter: 'billDeerfieldTicketId',
                        value: urlOpts.billDeerfieldTicketId
                    });
                }

            } else if (urlOpts && urlOpts.revert) {
                params = [
                    {
                        parameter: 'revert',
                        value: true
                    }
                ];
            }

            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'drawings'
                },
                {
                    endpoint: 'batches',
                    value: this.id
                }
            ], params);
        } else if (_.size(this.files.models) > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.get('projectId')
                },
                {
                    endpoint: 'drawings'
                },
                {
                    endpoint: 'versions',
                    value: this.version.id
                },
                {
                    endpoint: 'filebatch'
                },
            ], [
                {
                    parameter: 'entryList',
                    value: _.map(this.files.models, function (file) {
                        return file.get('entryId');
                    }).join(',')
                }
            ]);
        }
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.get('projectId')
            },
            {
                endpoint: 'drawings'
            },
            {
                endpoint: 'batches',
                value: this.id
            }
        ]);
    },
    parse: function (model) {
        if (model != null) {
            if (model.createdBy != null) {
                this.createdBy = new PJQ.models.users.User(model.createdBy);
            }

            if (model.version != null) {
                this.version = new PJQ.models.drawings.Version(model.version);
            }
        }

        this.files = new PJQ.collections.files.Files(model.files);
        this.uploads = new PJQ.collections.drawings.Drawings(model.uploads);
        this.drawings = new PJQ.collections.drawings.Drawings(model.drawings);
        return model;
    },
    fetchStatus: function (callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'drawings'
                },
                {
                    endpoint: 'batches',
                    value: this.get('guid')
                },
                {
                    endpoint: 'status'
                }
            ])
        }).get().done(_.bind(function (data) {
            this.set('status', data.status);
            callback(data.status);
        }, this));
    },
    beforeSave: function () {
        if (this.version != null) {
            this.set('versionId', this.version.id);
        }

        this.set('files', this.files.getChangedModels());
        this.set('uploads', this.uploads.getChangedModels());
        this.set('drawings', this.drawings);
    }
});

PJQ.models.drawings.DrawingBatchNotification = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'drawings'
            },
            {
                endpoint: 'batches',
                value: this.get('batchId')
            },
            {
                endpoint: 'notify',
                value: this.id
            }
        ]);
    },
    beforeSave: function () {

    }
});

PJQ.models.drawings.Drawing = PJQ.models.files.File.extend({
    idAttribute: 'drawingId',
    endpoint: function (urlOpts) {
        let params = [];
        if (urlOpts && urlOpts.currentSet != null) {
            params = [
                {
                    parameter: 'currentSet',
                    value: urlOpts.currentSet
                }
            ];
        }
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'drawings',
                value: _.size(this.get('guid')) > 0 ? this.get('guid') : this.id
            }
        ], params);
    },
    download: function (withAnnotations = false, context = null, contextId = null) {
        let downloadUrl = this.endpoint() + '/download';
        if (PJQ.app.session.project != null) {
            downloadUrl = "/projects/" + PJQ.app.session.project.id.toString() + "/" + downloadUrl
        }

        if (withAnnotations) {
            downloadUrl += "?annotations=true&_=" + PJQ.helpers.guid();

            if (_.size(context) > 0 && contextId > 0) {
                downloadUrl = downloadUrl + (downloadUrl.indexOf("?") === -1 ? "?" : "&") + "context=" + context + "&contextId=" + contextId.toString();
            }
        }

        PJQ.files.downloadFile(downloadUrl, {
            isApi2: true,
            includeAccessKey: true
        });
    },
    thumbUrl: function () {
        return this.url({
            isFileAPI: true
        }) + "/thumbnail?r=" + this.get('rotation').toString();
    },
    cropUrl: function () {
        return this.url({
            isFileAPI: true
        }) + "/crop?r=" + this.get('rotation').toString() + '&g=' + PJQ.helpers.guid();
    },
    cropNameUrl: function () {
        return this.url({
            isFileAPI: true
        }) + "/cropname?r=" + this.get('rotation').toString() + '&g=' + PJQ.helpers.guid();
    },
    cropTitleUrl: function () {
        return this.url({
            isFileAPI: true
        }) + "/croptitle?r=" + this.get('rotation').toString() + '&g=' + PJQ.helpers.guid();
    },
    renderUrl: function () {
        return this.url({
            isFileAPI: true
        }) + "/render?r=" + this.get('rotation').toString();
    },
    rotate: function (degrees, callback) {
        let curRotation = this.get('rotation'),
            newRotation = (curRotation ? curRotation : 0) + degrees;
        if (newRotation >= 360) {
            newRotation = newRotation -= 360;
        } else if (newRotation < 0) {
            newRotation = newRotation += 360;
        }

        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'drawings',
                    value: this.get('guid')
                },
                {
                    endpoint: 'rotate'
                }
            ], [
                {
                    parameter: 'degrees',
                    value: degrees
                }
            ]),
            isApi2: true
        }).post().done(_.bind(function (data) {
            this.set({
                rotation: newRotation
            });
            if (typeof callback === 'function') {
                callback(true);
            }
        }, this)).fail(function () {
            if (typeof callback === 'function') {
                callback(false);
            }
        });
    },
    addTags: function (tags, options, callback) {
        let newTags = _.difference(tags, this.get('tags')),
            fnAdd = _.bind(function () {
                this.get('tags').push(...newTags);
                this.trigger("change");
                if (typeof callback === 'function') {
                    callback(newTags);
                }
            }, this);
        if (options == null || options.save !== false) {
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'drawings',
                        value: this.id
                    },
                    {
                        endpoint: 'tags'
                    }
                ], [
                    {
                        parameter: 'tags',
                        value: newTags.join(',')
                    }
                ])
            }).post().done(_.bind(function () {
                fnAdd();
            }, this)).fail(function () {
                if (typeof callback === 'function') {
                    callback(null);
                }
            });
        } else {
            fnAdd();
        }
    },
    deleteTag: function (name, options, callback) {
        let fnDelete = _.bind(function () {
            this.set('tags', _.without(this.get('tags'), name));
            this.trigger("change");
            if (typeof callback === 'function') {
                callback(true);
            }
        }, this);

        if (options == null || options.save !== false) {
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'drawings',
                        value: this.id
                    },
                    {
                        endpoint: 'tags'
                    }
                ], [
                    {
                        parameter: 'name',
                        value: name
                    }
                ])
            }).delete().done(_.bind(function () {
                fnDelete();
            }, this)).fail(function () {
                callback(false);
            });
        } else {
            fnDelete();
        }
    },
    fetchAnnotations: function (options, callback) {
        if (this.annotations != null && options.context == this.annotations.options.context && options.contextId == this.annotations.options.contextId) {
            callback(this.annotations);
            return;
        }

        this.annotations = new PJQ.collections.drawings.Annotations(null, {
            drawingId: this.id,
            context: options != null ? options.context : null,
            contextId: options != null ? options.contextId : null,
            accessKey: options != null ? options.accessKey : null
        });
        this.annotations.fetch({
            success: _.bind(function () {
                callback(this.annotations);
            }, this)
        });
    },
    updateScale: function (scale, scaleType, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'drawings',
                    value: this.id
                }
            ], [
                {
                    parameter: 'scale',
                    value: scale
                },
                {
                    parameter: 'scaleType',
                    value: scaleType
                }
            ])
        }).put().done(_.bind(function () {
            this.set({
                scale: scale,
                scaleType: scaleType
            });
            callback(true);
        }, this)).fail(function () {
            callback(false);
        });
    }
});

PJQ.collections.drawings.Versions = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.drawings.Version,
    endpoint: function () {
        if (_.size(this.options.accessKey) > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'drawings'
                },
                {
                    endpoint: 'share',
                    value: this.options.accessKey
                }
            ]);
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.project.id
            },
            {
                endpoint: 'versions'
            }
        ]);
    },
    getDrawing: function (drawingId) {
        let result = null;
        _.each(this.models, function (version) {
            let drawing = _.find(version.drawings.models, function (drawing) {
                return drawing.id === drawingId;
            });
            if (drawing != null) {
                result = drawing
            }
        });
        return result;
    },
    getDrawingCount: function () {
        let result = 0;
        _.each(this.models, function (version) {
            result += _.size(version.drawings.models);
        });
        return result;
    },
    getVersionStatsForDrawing: function (drawing) {
        // total starts at 1 because the code below will not match on "own version"
        // drawings have to belong to at least 1 version, so it starts at 1
        let result = {
                older: 0,
                newer: 0,
                total: 1,
                same: false,
                hide: false
            },
            ownVersion = this.get(drawing.get('versionId'))
        if (ownVersion == null) {
            result.hide = true;
        } else {
            let ownIssued = new Date(ownVersion.get('issuedOn')),
                ownCreated = new Date(ownVersion.get('createdOn'));
            _.each(this.models, function (version) {
                if (version.id > 0 && version.drawings.find(function (verDrawing) {
                    return drawing.get('name') === verDrawing.get('name') && verDrawing.id !== drawing.id;
                }) != null) {
                    result.total++;
                    if (version.id === ownVersion.id) {
                        result.same = true;
                    } else {
                        let thisIssued = new Date(version.get('issuedOn'));
                        if (thisIssued > ownIssued) {
                            result.newer++;
                        } else if (thisIssued < ownIssued) {
                            result.older++;
                        } else {
                            let thisCreated = new Date(version.get('createdOn'));
                            if (thisCreated > ownCreated) {
                                result.newer++;
                            } else if (thisCreated < ownCreated) {
                                result.older++;
                            }
                        }
                    }
                }
            });
        }
        return result;
    },
    findVersionsForDrawing: function (drawing, includeOwnVersion = true) {
        return _.filter(this.models, function (version) {
            return (includeOwnVersion || (!includeOwnVersion && version.id !== drawing.get('versionId'))) && version.drawings.findWhere({name: drawing.get('name')}) != null;
        }, this);
    },
    getDrawingTags: function () {
        let result = [];
        _.each(this.models, function (version) {
            result.push(...version.getDrawingTags());
        });
        return result;
    },
    getUniqueDrawings: function (excludeVersion) {
        let foundNames = [],
            fullSet = [];
        _.each(this.models, _.bind(function (version) {
            if (excludeVersion != null && version.id === excludeVersion.id) {
                return;
            }

            _.each(version.drawings.models, _.bind(function (drawing) {
                let drawingName = drawing.get('name');
                if (foundNames.indexOf(drawingName) === -1) {
                    foundNames.push(drawingName);
                    fullSet.push(drawing);
                }
            }, this));
        }, this));
        return fullSet;
    },
    createPsuedoFolders: function (attachments) {
        let hasDrawings = false,
            drawingsFolderId = -parseInt(_.uniqueId()),
            drawingAttachments = [],
            tryHideCurrentSet = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.HIDE_CURRENT_SET_WHEN_POSSIBLE),
            isHideCurrentSet = false;
        if (tryHideCurrentSet) {
            let versionsWithDrawings = _.filter(this.models, (version) => {
                return version.drawings.models.length > 0;
            });
            if (versionsWithDrawings.length <= 2) {
                let getDrawingNames = (version) => {
                        let drawingNames = [];
                        _.each(version.drawings.models, (drawing) => {
                            drawingNames.push(drawing.get('name'));
                        });
                        return drawingNames;
                    },
                    currentSet = this.get(-1);
                if (currentSet != null) {
                    let currentSetDrawingNames = getDrawingNames(currentSet);
                    isHideCurrentSet = null == _.find(versionsWithDrawings, (version) => {
                        if (version.id === -1) {
                            return false;
                        }
                        return version.id !== -1 && !_.isEqual(currentSetDrawingNames, getDrawingNames(version));
                    });
                }
            }
        }
        _.each(_.sortBy(this.models, function (version) {
            return new Date(version.get('issuedOn'));
        }), _.bind(function (version, index) {
            if (isHideCurrentSet && version.id === -1) {
                return;
            }

            if (_.size(version.drawings.models) > 0) {
                hasDrawings = true;

                let versionFolderId = -parseInt(_.uniqueId());
                drawingAttachments.push(new PJQ.models.projects.ProjectAttachment({
                    entryId: versionFolderId,
                    name: version.get('name'),
                    folderId: drawingsFolderId,
                    sortOrder: version.id === -1 ? -1 : index,
                    isFolder: true,
                    isDrawing: true,
                    versionId: version.id,
                    modifiedOn: version.get('createdOn')
                }));
                _.each(version.drawings.models, _.bind(function (drawing) {
                    drawingAttachments.push(new PJQ.models.projects.ProjectAttachment({
                        entryId: -parseInt(_.uniqueId()),
                        name: drawing.get('fileName'),
                        guid: drawing.get('guid'),
                        folderId: versionFolderId,
                        size: drawing.get('fileSize'),
                        url: drawing.get('url'),
                        drawingId: drawing.id,
                        isFolder: false,
                        isDrawing: true,
                        versionId: version.id,
                        sortOrder: drawing.get('sortOrder'),
                        modifiedOn: version.get('createdOn')
                    }));
                }, this));
            }
        }, this));
        if (_.size(drawingAttachments) > 0) {
            attachments.add(new PJQ.models.projects.ProjectAttachment({
                entryId: drawingsFolderId,
                name: "Drawings",
                folderId: 0,
                isFolder: true,
                isDrawing: true,
                modifiedOn: _.max(this.models, function (ver) {
                    return ver.id;
                }).get('createdOn'),
                sortOrder: -2
            }));
            attachments.add(drawingAttachments);
        }
        return attachments;
    },
    download: function () {

    },
    merge: function () {

    }
});

PJQ.collections.drawings.DrawingBatches = PJQ.collections.files.Files.extend({
    model: PJQ.models.drawings.DrawingBatch,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.project.id
            },
            {
                endpoint: 'drawings'
            },
            {
                endpoint: 'batches'
            }
        ]);
    }
});

PJQ.collections.drawings.Drawings = PJQ.collections.files.Files.extend({
    model: PJQ.models.drawings.Drawing,
    endpoint: function (urlOptions) {
        let params = [];
        if (urlOptions.byName) {
            params.push({
                parameter: 'byName',
                value: true
            });
        }
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.project.id
            },
            {
                endpoint: 'drawings'
            }
        ], params);
    },
    share: function (versionIds, fileGuids, data, project, callback) {
        this.options.versionIds = versionIds;
        this.options.fileGuids = fileGuids;
        this.options.data = data;
        this.options.projectId = project ? project.id : null;

        let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'drawings'
            },
            {
                endpoint: 'share'
            }
        ], [
            {
                parameter: 'allDrawings',
                value: this.options.allDrawings === true ? true : null
            }
        ]);
        new PJQ.ajax.Request({
            endpoint: endpoint,
            data: {
                projectId: this.options.projectId,
                subject: data != null ? data.subject : null,
                emails: data != null ? data.emails : null,
                versionIds: this.options.versionIds,
                drawingGuids: _.map(this.models, function (model) {
                    return model.get('guid');
                }),
                guids: this.options.fileGuids
            }
        }).post().done(_.bind(function (data) {
            this.options.url = data.url;
            this.options.accessKey = data.accessKey;
            if (typeof callback === 'function') {
                callback(data);
            }
        }, this)).fail(function () {
            callback();
        });
    },
    update: function (callback) {
        let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'drawings'
            },
            {
                endpoint: 'share',
                value: this.options.accessKey
            }
        ], [
            {
                parameter: 'allDrawings',
                value: this.options.allDrawings === true ? true : null
            }
        ]);

        let data = this.options.data;
        new PJQ.ajax.Request({
            endpoint: endpoint,
            data: {
                projectId: this.options.projectId,
                subject: data != null ? data.subject : null,
                emails: data != null ? data.emails : null,
                versionIds: this.options.versionIds,
                drawingGuids: _.map(this.models, function (model) {
                    return model.get('guid');
                }),
                guids: this.options.fileGuids
            }
        }).put().done(function (data) {
            if (typeof callback === 'function') {
                callback(data);
            }
        }).fail(function () {
            callback();
        });
    }
});

PJQ.models.drawings.DrawingDownload = PJQ.models.files.File.extend({
    endpointArr: function () {
        return [
            {
                endpoint: 'drawings'
            },
            {
                endpoint: 'downloads',
                value: this.get('guid')
            }
        ];
    },
    cancel: function () {

    }
});

PJQ.collections.drawings.DrawingsShare = PJQ.collections.files.Files.extend({
    model: PJQ.models.drawings.Drawing,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'drawings'
            },
            {
                endpoint: 'share',
                value: this.options.accessKey
            }
        ]);
    }
});
PJQ.views.drawings.OrderDownloadAdmin = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DRAWINGS, 'modal-order-download-admin'),
        minWidth: '200px',
        onOrderPlaced: null
    },
    events: {
        'click .btn-save': 'placeOrder'
    },
    beforeModalCreated: function () {

        let fnContinue = _.bind(function() {
            this.createOrder();

            this.model.beforeSave();
            let endpoint = this.model.project != null ? [
                {
                    endpoint: 'projects',
                    value: this.model.project.get('projectId')
                },
                {
                    endpoint: 'orders'
                },
                {
                    endpoint: 'calculate'
                }
            ] : [
                {
                    endpoint: 'orders'
                },
                {
                    endpoint: 'calculate'
                }
            ];

            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint(endpoint),
                data: this.model.attributes
            }).post().done(_.bind(function (data) {
                this.price = data.total * 100;
                this.render();
            }, this)).fail(function (xhr, err, result) {
            });
        }, this);

        if (PJQ.app.session.contact != null) {
            PJQ.app.session.preferences.fetch();
            if (!PJQ.app.session.contact.isFetched) {
                PJQ.app.session.contact.fetch({
                    success: _.bind(function () {
                        fnContinue();
                    }, this)
                });
            }
            else
                fnContinue();
        } else if (PJQ.app.session.user != null) {
            PJQ.app.session.preferences.fetch();
            if (!PJQ.app.session.user.isFetched) {
                PJQ.app.session.user.fetch({
                    success: _.bind(function () {
                        fnContinue();
                    }, this)
                });
            }
            else
                fnContinue();
        }

    },
    afterRender: function() {
        this.$('.file-count').text(_.size(this.options.entryIds));
        this.$('.unit-cost').text(PJQ.helpers.formatHelpers.formatCurrency(PJQ.app.session.project.orderSettings.get('downloadPerFileFee')));
        this.$('.total').text(PJQ.helpers.formatHelpers.formatCurrency(this.price));
        if (this.price)
            this.$('.btn-save').prop('disabled', false);
    },
    createOrder: function () {
        if (this.model == null) {
            this.model = new PJQ.models.drawings.Order({
                project: PJQ.app.session.project,
                description: "",
                poNumber: "",
                notes: "",
                largeFormatBinding: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ORDER_LARGE_FORMAT_BINDING_TYPE) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ORDER_LARGE_FORMAT_BINDING_TYPE) : "STAPLED",
                largeFormatPaperType: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ORDER_LARGE_FORMAT_PAPER_TYPE) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ORDER_LARGE_FORMAT_PAPER_TYPE) : "WHITE BOND",
                largeFormatQuantity: PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ORDER_LARGE_FORMAT_QUANTITY) > 0 ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ORDER_LARGE_FORMAT_QUANTITY) : 1,
                smallFormatBinding: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ORDER_SMALL_FORMAT_BINDING_TYPE) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ORDER_SMALL_FORMAT_BINDING_TYPE) : "STAPLED",
                smallFormatQuantity: PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ORDER_SMALL_FORMAT_QUANTITY) > 0 ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ORDER_SMALL_FORMAT_QUANTITY) : 1,
                smallFormatPaperType: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ORDER_SMALL_FORMAT_PAPER_TYPE) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ORDER_SMALL_FORMAT_PAPER_TYPE) : "WHITE BOND",
                halfSizeQuantity: 0,
                cdQuantity: 0,
                shippingSpeed: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ORDER_DELIVER_BY) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ORDER_DELIVER_BY) : "Next Day (Morning)",
                entryIds: this.options.entryIds
            });
        }

        this.model.recipients = null;
        let contact;
        if (PJQ.app.session.contact != null) {
            contact = PJQ.app.session.contact;
        } else if (PJQ.app.session.user != null) {
            contact = PJQ.app.session.user;
        } else {
            contact = new PJQ.models.contacts.Contact();
        }
        this.model.set({
            notifyEmail: contact.get('email'),
            billingCompanyName: contact.get('companyName'),
            billingContactName: contact.get('contactName'),
            billingPhone: contact.get('phone'),
            billingPhoneExtension: contact.get('phoneExtension'),
            billingAddress1: contact.get('address1'),
            billingAddress2: contact.get('address2'),
            billingCity: contact.get('city'),
            billingState: contact.get('state'),
            billingZip: contact.get('zip'),
            billingCountry: contact.get('country'),
            isDownload: true
        });
    },
    placeOrder: function() {
        this.model.save(null, {
            success: _.bind(function (result) {
                if (result.get('status') === 'NEW') {
                    this.removeModal();

                    new PJQ.views.BaseModal({
                        header: "Order Completed",
                        body: 'Order #' + result.get('orderId') + ' has been placed successfully.',
                        isShowCancelButton: false
                    });

                    if (typeof this.options.onOrderPlaced === 'function') {
                        this.options.onOrderPlaced();
                    }
                } else {
                    let orderType = 'Download';
                    window.location.href = window.location.origin + '/DesktopModules/PanteraModuleGlobal/OrderPayment.aspx?oc=PROJECT_WALLS&o=' + this.model.id + '&ot=' + orderType;
                }
            }, this)
        });
    }
});

PJQ.views.drawings.OrderPrintsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DRAWINGS, 'Modal-Order-Prints'),
        minWidth: '600px',
        maxWidth: '1400px',
        isSelectRecipients: false,
        onOrderPlaced: null,
        mode: PJQ.constants.files.modes.PRINT,
        subTemplates: {
            orderCalculatedItems: new PJQ.templating.Template(PJQ.constants.modules.DRAWINGS, 'ordering-calculated-items')
        },
    },
    events: {
        'change .input-select-recipients': 'selectRecipientsChanged',
        'click .btn-close': 'onCancel',
        'click .btn-save': 'onSave',
        'click .ordering-folder': 'selectFolder',
        'click .select-file': 'fileSelectChanged',
        'click .order-jump-step': 'goToStep',
        'click .view-file': 'viewFile',
        'click .delete-recipient': 'deleteRecipient',
        'click .edit-recipient': 'editRecipient',
        'click .select-all-files': 'selectAllFiles'
    },
    beforeModalCreated: function () {
        this.options.isAdmin = PJQ.app.session.project != null && PJQ.app.session.project.get('masterUserId') === PJQ.app.session.get('masterUserId');
        this.mode = this.options.mode ? this.options.mode : 'PRINTS';
        this.options.maxWidth = this.mode === PJQ.constants.files.modes.ALT_PRINT || (PJQ.app.session.project && PJQ.app.session.project.get('status').toLowerCase() === "busy") ? '1400px' : '600px';

        if (this.options.isAdmin && _.size(this.options.recipients) > 0) {
            this.options.isSelectRecipients = true;
        }

        // Fetch any updated preferences to make sure all are up to date
        if (PJQ.app.session.contact != null) {
            PJQ.app.session.preferences.fetch();
            if (!PJQ.app.session.contact.isFetched) {
                PJQ.app.session.contact.fetch({
                    success: _.bind(function () {
                        this.render();
                    }, this)
                });
            }
        } else if (PJQ.app.session.user != null) {
            PJQ.app.session.preferences.fetch();
            if (!PJQ.app.session.user.isFetched) {
                PJQ.app.session.user.fetch({
                    success: _.bind(function () {
                        this.render();
                    }, this)
                });
            }
        }
    },
    beforeRender: function () {
        this.createOrder();
    },
    selectRecipientsChanged: function () {
        this.options.isSelectRecipients = this.$('.input-select-recipients').prop('checked');
        this.render();
    },
    createOrder: function () {
        if (this.model == null) {
            this.model = new PJQ.models.drawings.Order({
                project: PJQ.app.session.project,
                description: "",
                poNumber: "",
                notes: "",
                largeFormatBinding: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ORDER_LARGE_FORMAT_BINDING_TYPE) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ORDER_LARGE_FORMAT_BINDING_TYPE) : "STAPLED",
                largeFormatPaperType: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ORDER_LARGE_FORMAT_PAPER_TYPE) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ORDER_LARGE_FORMAT_PAPER_TYPE) : "WHITE BOND",
                largeFormatQuantity: PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ORDER_LARGE_FORMAT_QUANTITY) > 0 ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ORDER_LARGE_FORMAT_QUANTITY) : 1,
                smallFormatBinding: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ORDER_SMALL_FORMAT_BINDING_TYPE) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ORDER_SMALL_FORMAT_BINDING_TYPE) : "STAPLED",
                smallFormatQuantity: PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ORDER_SMALL_FORMAT_QUANTITY) > 0 ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ORDER_SMALL_FORMAT_QUANTITY) : 1,
                smallFormatPaperType: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ORDER_SMALL_FORMAT_PAPER_TYPE) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ORDER_SMALL_FORMAT_PAPER_TYPE) : "WHITE BOND",
                halfSizeQuantity: 0,
                cdQuantity: 0,
                shippingSpeed: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ORDER_DELIVER_BY) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ORDER_DELIVER_BY) : "Next Day (Morning)",
                entryIds: this.options.entryIds
            });
        }

        if (this.options.isAdmin && this.options.isSelectRecipients) {
            this.model.recipients = new PJQ.collections.contacts.Contacts(this.options.recipients != null ? this.options.recipients : []);
        } else {
            this.model.recipients = null;
            let contact;
            if (PJQ.app.session.contact != null) {
                contact = PJQ.app.session.contact;
            } else if (PJQ.app.session.user != null) {
                contact = PJQ.app.session.user;
            } else {
                contact = new PJQ.models.contacts.Contact();
            }
            this.model.set({
                notifyEmail: contact.get('email'),
                billingCompanyName: contact.get('companyName'),
                billingContactName: contact.get('contactName'),
                billingPhone: contact.get('phone'),
                billingPhoneExtension: contact.get('phoneExtension'),
                billingAddress1: contact.get('address1'),
                billingAddress2: contact.get('address2'),
                billingCity: contact.get('city'),
                billingState: contact.get('state'),
                billingZip: contact.get('zip'),
                billingCountry: _.size(contact.get('country')) > 0 ? contact.get('country') : 'us',
                isDownload: this.mode === PJQ.constants.files.modes.DOWNLOAD
            });
        }
    },
    renderData: function () {
        return {
            isAdmin: this.options.isAdmin,
            isSelectRecipients: this.options.isSelectRecipients,
            mode: this.mode,
            model: this.model,
            price: this.price,
            isPaidDownload: this.options.isPaidDownload
        };
    },
    afterRender: function () {
        if (this.model != null) {
            if (this.options.isAdmin && this.options.isSelectRecipients) {
                new PJQ.views.contacts.ContactsSelectInput({
                    el: this.$('.order-recipients'),
                    context: PJQ.app.session.project != null ? PJQ.constants.contacts.contexts.PARTICIPANTS : PJQ.constants.contacts.contexts.CONTACTS,
                    selectedContact: this.model.recipients.models,
                    showSelectorAddress: true,
                    isSingleChoice: false,
                    onChange: _.bind(function (selectedContacts) {
                        this.model.recipients.reset(selectedContacts);
                    }, this)
                });
            } else {
                this.statePicker = new PJQ.inputs.Selectpicker({
                    el: this.$('.contact-edit-state'),
                    noneSelectedText: 'Select Value',
                    defaultValue: this.model.get('billingState'),
                    onChange: _.bind(function (value) {
                        this.model.set('billingState', value.toUpperCase());
                    }, this)
                });
                this.countryChanged();

                new PJQ.inputs.Selectpicker({
                    el: this.$('.contact-edit-country'),
                    noneSelectedText: 'Select Value',
                    defaultValue: this.model.get('billingCountry'),
                    onChange: _.bind(function (value) {
                        this.model.set('billingCountry', value.toUpperCase());
                        this.model.set('billingZip', '');
                        this.model.set('billingState', '');
                        this.statePicker.setValue('');
                        this.$('.contact-edit-zip').val('');
                        this.countryChanged();
                    }, this)
                });

                PJQ.helpers.inputHelpers.inputMaskPhone(this.$('.contact-edit-phone'));
                PJQ.helpers.inputHelpers.inputMaskPhone(this.$('.contact-edit-fax'));
                PJQ.helpers.inputHelpers.inputMaskPhone(this.$('.contact-edit-cell'));
            }

            /*
            new PJQ.views.files.FileSelectInput({
                el: this.$('.order-files'),
                project: this.model.project,
                selectedFiles: this.model.files,
                collection: this.options.collection,
                selectorOptions: {
                    header: 'Select files to order',
                    confirmButton: 'Update Order'
                },
                isShowChangeButton: true,
                onChange: _.bind(function (selectedFiles) {
                    this.model.files = selectedFiles;
                    this.calculateCost();
                }, this)
            });

             */

            new PJQ.inputs.Selectpicker({
                el: this.$('.order-lf-paper'),
                defaultValue: this.model.get('largeFormatPaperType'),
                onChange: _.bind(function (value) {
                    this.model.set('largeFormatPaperType', value.toUpperCase());
                }, this)
            });
            new PJQ.inputs.Selectpicker({
                el: this.$('.order-lf-binding'),
                defaultValue: this.model.get('largeFormatBinding'),
                onChange: _.bind(function (value) {
                    this.model.set('largeFormatBinding', value.toUpperCase());
                }, this)
            });

            new PJQ.inputs.Selectpicker({
                el: this.$('.order-sf-paper'),
                defaultValue: this.model.get('smallFormatPaperType'),
                onChange: _.bind(function (value) {
                    this.model.set('smallFormatPaperType', value.toUpperCase());
                }, this)
            });
            new PJQ.inputs.Selectpicker({
                el: this.$('.order-sf-binding'),
                defaultValue: this.model.get('smallFormatBinding'),
                onChange: _.bind(function (value) {
                    this.model.set('smallFormatBinding', value.toUpperCase());
                }, this)
            });

            new PJQ.inputs.Selectpicker({
                el: this.$('.order-shipping-speed'),
                defaultValue: this.model.get('shippingSpeed'),
                onChange: _.bind(function (value) {
                    this.model.set('shippingSpeed', value.toUpperCase());
                }, this)
            });

            if (this.price == null && this.mode === PJQ.constants.files.modes.DOWNLOAD) {
                this.calculateCost();
            }

            if(this.mode === PJQ.constants.files.modes.ALT_PRINT){
                this.goToStep(1)
                this.renderFolderPicker();
                this.renderAddressBook();
            }

            new PJQ.Binder(this.$el, this.model);
        } else {
            new PJQ.Loader(this.$('.order-loading'));
        }
    },
    deleteRecipient: function(e){
        let target = $(e.currentTarget),
            contactId = target.closest('.card-body').data('id');

        this.model.recipients.remove(contactId);
        this.calculateCost();
    },
    editRecipient: function(e){
        let target = $(e.currentTarget),
            contactId = target.closest('.card-body').data('id');

        new PJQ.views.contacts.BaseEditContactModal({
            model: this.model.recipients.get(contactId),
            onSave: _.bind(function () {
                this.calculateCost();
            }, this)
        });
    },
    selectAllFiles: function(e){
        let isChecked = $(e.currentTarget).prop('checked'),
            fileSelects = this.$('.select-file');

        if(isChecked){
            this.model.files = _.union(this.model.files, this.selectedFolderFiles);
        }
        else{
            _.each(this.selectedFolderFiles, function(file){
                this.model.files = _.without(this.model.files, file);
            }, this)
        }

        fileSelects.prop('checked', isChecked);

        this.$('.order-selected-file-count').text(this.model.files.length);
        this.$('.step-1-continue').attr('disabled', !_.size(this.model.files) > 0);
    },
    viewFile: function(e){
        let target = $(e.currentTarget),
            row = this.filesTable.getRow(target.closest('tr')),
            file = row.data();

        if (file.isImage()) {
            PJQ.app.view.renderPhotoViewer({
                model: file,
                canDownload: false,
                canDelete: false
            });
        }
        else if (file.canRender()) {
            new PJQ.views.files.FileViewer({
                model: file,
                isDisableDownload: true
            });
        }
    },
    renderFolderPicker: function(selectedFolder){
        let fnRender = _.bind(function(){
            this.folders = _.filter(this.attachments.models, function (attachment) {
                let isSecondLevel = false;
                if(attachment.get('isFolder') && attachment.get('entryId') !== -1){
                    let parent = this.attachments.get(attachment.get('folderId'));
                    if(parent){
                        isSecondLevel = parent.get('entryId') === -1 || parent.get('folderId') === 0;
                    }
                }
                return isSecondLevel && _.size(attachment.getFolderAttachments(true, {
                    hideFolders: true
                })) > 0;
            }, this);

            if (selectedFolder) {
                this.selectedFolder = _.find(this.attachments.models, function (folder) {
                    return folder.id === selectedFolder;
                })
            }
            else {
                this.selectedFolder = this.folders[0];
            }

            if(this.selectedFolder){
                this.selectedFolderFiles = _.filter(this.attachments.models, function (attachment) {
                    return attachment.get('folderId') === this.selectedFolder.get('entryId') && !attachment.get('isFolder');
                }, this)
            }

            let templateData = {
                models: this.folders,
                selectedFolder: this.selectedFolder
            }
            this.renderFilesTable();
        }, this);
        if(this.attachments == null || this.folders == null) {
            this.options.project.fetchAttachments({
                isShared: true,
                isPrivate: false,
                forceRecursive: true
            }, _.bind(function (attachments) {
                this.attachments = attachments;
                fnRender();
            }, this))
        }
        else{
            fnRender();
        }
    },
    renderAddressBook: function(){
        this.addressBookView = new PJQ.views.addressbook.AddressBook({
            el: this.$('.address-book'),
            selectionMode: PJQ.constants.addressBook.selectionMode.ADD_TO_PROJECT,
            disabledContacts: [],
            disabledContactGroups: null,
            onSelection: _.bind(function (contactsAll, contactsNoGroup, contactGroups) {
                this.$('.order-selected-contact-count').text(contactsAll.length);
                this.$('.step-2-continue').attr('disabled', !contactsAll.length > 0);
                this.selectedRecipients = contactsAll;
            }, this)
        });
    },
    renderFilesTable: function () {
        this.filesTable = new PJQ.views.dataTables.DataTable({
            el: this.$(".file-selector-table"),
            data: this.selectedFolderFiles,
            rowId: "cid",
            order: [0, 'asc'],
            language: {
                zeroRecords: 'Folder contains no files'
            },
            pageLength: 50,
            onRowDoubleClick: _.bind(function (row) {

            }, this),
            columns: [
                {
                    "columnData": '',
                    "title": '<div class="pretty p-default p-icon p-smooth fs-18 m-0"><input type="checkbox" class="select-all-files" /><div class="state"><label class="wd-0">&nbsp;</label></div></div>',
                    "width": "20px",
                    "data": "null",
                    "orderable": false,
                    "searchable": false,
                    "render": _.bind(this.renderFileSelect, this)
                },
                {
                    "title": "Name",
                    "data": "attributes.name",
                    "orderable": true
                },
                {
                    "title": "Folder",
                    "data": "",
                    "orderable": true,
                    "render": _.bind(function (data, a, b) {
                        return this.selectedFolder.get('name');
                    }, this)
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "width": "80px",
                    "render": _.bind(function (data, type, row) {
                        if(row.canRender() || row.isImage()){
                            return '<div class="text-align-right show-on-row-hover"><button type="button" class="btn btn-info view-file ht-30p wd-35p ml-1 fs-14"><span class="fal fa-eye"></span></button></div>';
                        }
                        else{
                            return '';
                        }
                    }, this)
                }
            ]
        });
    },
    selectFolder: function(e){
        let target = $(e.currentTarget);
        this.renderFolderPicker(target.data('id'));
    },
    renderFileSelect: function (data, type, row) {
        let isSelected = _.find(this.model.files, function(file){
            return file.get('entryId') === row.get('entryId')
        }, this) != null

        this.manageSelectAllButtonState();

        return ('<div class="text-align-center"><div class="pretty p-default p-curve fs-22 m-0">' +
            '<input type="checkbox"' + (isSelected  ? ' checked ' : '') + ' class="select-file' + '" />' +
            '<div class="state p-primary"><label class="wd-0">&nbsp;</label></div>' +
            '</div></div>');
    },
    fileSelectChanged: function (e) {
        let tr = $(e.currentTarget).closest('tr'),
            row = this.filesTable.getRow(tr),
            file = row.data();
        if ($(e.currentTarget).prop('checked')) {
            this.model.files.push(file);
        }
        else {
            this.model.files = _.without(this.model.files, file);
        }

        this.manageSelectAllButtonState();
        this.$('.order-selected-file-count').text(this.model.files.length);
        this.$('.step-1-continue').attr('disabled', !_.size(this.model.files) > 0);
    },
    countryChanged: function () {
        let country = this.model.get('billingCountry') && this.model.get('billingCountry').length > 0 ? this.model.get('billingCountry').toLowerCase() : 'us',
            options = '<option disabled value="">Select Value</option>';
        _.each(PJQ.constants.states[country], function (state) {
            options += '<option value="' + state.abbreviation.toLowerCase() + '">' + state.name + '</option>';
        });
        this.statePicker.$el.html(options);
        this.statePicker.refresh();
        if (this.model.get('billingState'))
            this.statePicker.setValue(this.model.get('billingState').toLowerCase());

        PJQ.helpers.inputHelpers.inputMaskZip(this.$('.contact-edit-zip'), country);
    },
    manageSelectAllButtonState: function() {
        let isSelectAll = true;
        _.each(this.selectedFolderFiles, function(row){
            if(isSelectAll){
                isSelectAll = _.find(this.model.files, function(file){
                    return file.get('entryId') === row.get('entryId')
                }, this) != null
            }
        }, this)

        this.$('.select-all-files').prop('checked', isSelectAll);
    },
    goToStep: function (step) {
        if(step.currentTarget){
            this.step = $(step.currentTarget).data('step')
        }
        else{
            this.step = step;
        }
        let thisStep = $('.step-' + this.step.toString()),
            thisStepHeader = $('.step-header-' + this.step.toString());
        this.$('[class*=step-]').not(thisStep).collapse('hide');
        this.$('[class*=step-header-]').not(thisStepHeader).removeClass('text-primary').addClass('text-dark op-4');
        thisStepHeader.removeClass('text-dark op-4').addClass('text-primary');

        if (this.step === 1) {
            this.$('.order-selected-file-count').parent().removeClass('text-dark op-4').addClass('text-info');
            this.$('.order-selected-contact-count').parent().removeClass('text-info').addClass('text-dark op-4');
        }
        else if (this.step === 2) {
            this.$('.order-selected-file-count').parent().removeClass('text-info').addClass('text-dark op-4');
            this.$('.order-selected-contact-count').parent().removeClass('text-dark op-4').addClass('text-info');
        }
        else if (this.step === 3) {
            this.$('.order-selected-contact-count').parent().removeClass('text-info').addClass('text-dark op-4');

            if(this.model.recipients == null){
                this.model.recipients = new PJQ.collections.contacts.Contacts();
            }
            this.model.recipients.reset(_.map(this.selectedRecipients, function(contact, a, b){
                return new PJQ.models.contacts.Contact({
                    contactId: contact,
                    id: contact
                });
            }, this));
            this.calculateCost();
        }


        // don't hide the footer if the project is offline
        let isOnline = false;
        if(!PJQ.app.session.project){
            isOnline = true;
        }
        else if(PJQ.app.session.project && PJQ.app.session.project.get('status').toLowerCase() !== "busy"){
            isOnline = true;
        }

        this.$('.modal-footer').attr('hidden', this.step !== 3 && isOnline);

        thisStep.collapse('show');
    },
    calculateCost: function () {
        this.model.beforeSave();
        let endpoint = this.model.project != null ? [
            {
                endpoint: 'projects',
                value: this.model.project.get('projectId')
            },
            {
                endpoint: 'orders'
            },
            {
                endpoint: this.mode === PJQ.constants.files.modes.ALT_PRINT ? 'calculatemultiple' : 'calculate'
            }
        ] : [
            {
                endpoint: 'orders'
            },
            {
                endpoint: 'calculate'
            }
        ];

        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint(endpoint),
            data: this.model.attributes
        }).post().done(_.bind(function (data) {
            if(this.mode === PJQ.constants.files.modes.ALT_PRINT){
                this.renderCalculatedTotals(data);
            }
            else{
                this.price = data.total * 100;
                this.render();
            }
        }, this)).fail(function (xhr, err, result) {
        });
    },
    renderCalculatedTotals: function(orders) {
        let templateData = {
            orders: orders
        }
        this.renderSubTemplate(false, this.options.subTemplates.orderCalculatedItems, this.$('.calculated-totals'), templateData);
    },
    onCancel: function () {
        this.removeModal();
    },
    onSave: function () {
        let hasError = false;

        if (this.options.isAdmin && this.options.isSelectRecipients) {
            if (_.size(this.model.recipients.models) === 0) {
                hasError = true;
            }
        }
        else if(this.mode === PJQ.constants.files.modes.ALT_PRINT){
            if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ORDER_PO_REQUIRED)) {
                let $po = this.$('.order-po-number');
                PJQ.helpers.inputHelpers.setInputError($po, true);
                if (_.size(this.model.get('poNumber')) === 0) {
                    PJQ.helpers.inputHelpers.setInputError($po, false);
                    hasError = true;
                }
            }
        }
        else{
            let $company = this.$('.contact-edit-company');
            PJQ.helpers.inputHelpers.setInputError($company, true);
            if (_.size($company.val()) === 0) {
                PJQ.helpers.inputHelpers.setInputError($company, false);
                hasError = true;
            }

            let $contact = this.$('.contact-edit-name');
            PJQ.helpers.inputHelpers.setInputError($contact, true);
            if (_.size($contact.val()) === 0) {
                PJQ.helpers.inputHelpers.setInputError($contact, false);
                hasError = true;
            }

            let $address1 = this.$('.contact-edit-address-1');
            PJQ.helpers.inputHelpers.setInputError($address1, true);
            if (_.size($address1.val()) === 0) {
                PJQ.helpers.inputHelpers.setInputError($address1, false);
                hasError = true;
            }

            let $city = this.$('.contact-edit-city');
            PJQ.helpers.inputHelpers.setInputError($city, true);
            if (_.size($city.val()) === 0) {
                PJQ.helpers.inputHelpers.setInputError($city, false);
                hasError = true;
            }

            let $zip = this.$('.contact-edit-zip');
            PJQ.helpers.inputHelpers.setInputError($zip, true);
            if (_.size($zip.val()) === 0) {
                PJQ.helpers.inputHelpers.setInputError($zip, false);
                hasError = true;
            }

            let $state = this.$('select.contact-edit-state');
            PJQ.helpers.inputHelpers.setInputError($state, true);
            if (_.size(this.model.get('billingState')) === 0) {
                PJQ.helpers.inputHelpers.setInputError($state, false);
                hasError = true;
            }

            let $country = this.$('select.contact-edit-country');
            PJQ.helpers.inputHelpers.setInputError($country, true);
            if (_.size(this.model.get('billingCountry')) === 0) {
                PJQ.helpers.inputHelpers.setInputError($country, false);
                hasError = true;
            }

            let $email = this.$('.contact-edit-email');
            PJQ.helpers.inputHelpers.setInputError($email, true);
            if (_.size($email.val()) === 0) {
                PJQ.helpers.inputHelpers.setInputError($email, false);
                hasError = true;
            }

            let $phone = this.$('.contact-edit-phone');
            PJQ.helpers.inputHelpers.setInputError($phone, true);
            if (_.size(this.model.get('billingPhone')) === 0) {
                PJQ.helpers.inputHelpers.setInputError($phone, false);
                hasError = true;
            }
        }

        if (_.size(this.options.entryIds) === 0)
            hasError = true;

        if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ORDER_PO_REQUIRED) && this.mode !== PJQ.constants.files.modes.DOWNLOAD) {
            let $po = this.$('.order-po-number');
            PJQ.helpers.inputHelpers.setInputError($po, true);
            if (_.size(this.model.get('poNumber')) === 0) {
                PJQ.helpers.inputHelpers.setInputError($po, false);
                hasError = true;
            }
        }

        if (hasError) {
            this.$('.ordering-error').removeClass('hidden');
        } else {
            this.$('.ordering-error').addClass('hidden');
            this.model.save(null, {
                success: _.bind(function (result) {
                    if (this.options.isAdmin && result.get('status') === 'NEW' && this.mode !== PJQ.constants.files.modes.DOWNLOAD) {
                        PJQ.notifications.notify.successNotify({
                            message: 'Order #' + result.get('orderId') + ' placed successfully'
                        });
                        this.removeModal();

                        if (typeof this.options.onOrderPlaced === 'function') {
                            this.options.onOrderPlaced();
                        }
                    } else {
                        let orderType = this.mode === PJQ.constants.files.modes.DOWNLOAD ? 'Download' : 'OrderPrints';
                        window.location.href = window.location.origin + '/DesktopModules/PanteraModuleGlobal/OrderPayment.aspx?oc=PROJECT_WALLS&o=' + this.model.id + '&ot=' + orderType;
                    }
                }, this)
            });
        }
    }
});

PJQ.models.drawings.Order = PJQ.models.BaseModel.extend({
    idAttribute: 'orderId',
    endpoint: function () {
        if (this.project != null) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.project.id
                },
                {
                    endpoint: 'orders'
                }
            ])
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'orders'
            }
        ])
    },
    parse: function (model) {
        if (model == null) {
            return model;
        }

        if (model.project != null) {
            this.project = model.project;
        }

        if (model.recipients != null) {
            this.recipients = model.recipients;
        }

        return model;
    },
    beforeSave: function () {
        this.set({
            recipients: this.recipients ? this.recipients.toJSON() : []
        })
    }
});

PJQ.views.drawings.DrawingUploadLogModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DRAWINGS, 'Modal-Upload-Log'),
        width: 800,
        maxWidth: '90%'
    },
    events: {
        'click .btn-revert-batch': 'revertBatch',
        'click .btn-notify': 'notify',
        'click .btn-publish-batch': 'publishBatch',
        'click .btn-delete-batch': 'deleteBatch',
        'click .btn-new-batch': 'newBatch',
        'click .btn-close': 'close'
    },
    beforeModalCreated: function () {
        this.collection = new PJQ.collections.drawings.DrawingBatches(null, {
            project: this.options.project
        });
        this.collection.fetch({
            success: _.bind(function () {
                this.render();
                this.listenTo(this.collection, 'fetch', this.render);
            }, this)
        });
    },
    afterRender: function () {
        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.upload-log'),
            data: this.collection.models,
            language: {
                zeroRecords: 'Click "Upload Drawings" to publish a new version'
            },
            isHideSearch: true,
            order: [3, 'desc'],
            columns: [
                {
                    "data": "attributes.drawingCount",
                    "render": _.bind(function (data, type, row) {
                        if (row.get('status') === 2) {
                            return '<div class="text-orange fs-16"><i class="fad fa-file"></i> ' + data.toString() + '</div>';
                        }
                        return '';
                    }, this),
                    "title": "",
                    "width": "80px"
                },
                {"data": "attributes.versionName", "title": "Version", "orderable": true},
                {
                    "data": "createdBy",
                    "render": _.bind(function (data) {
                        return PJQ.helpers.contacts.getContactAnchor({id: -data.id, name: data.get('companyName')});
                    }, this),
                    "title": "Created By"
                },
                {
                    "data": {
                        "_": function (row) {
                            return new Date(row.get('createdOn'));
                        },
                        "filter": "attributes.createdOn",
                        "display": function (row) {
                            return PJQ.helpers.dateHelpers.getDateString(new Date(row.get('createdOn')), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
                        }
                    },
                    "title": "Created On",
                    "width": "150px"
                },
                {
                    "data": "attributes.isPublished",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "render": _.bind(function (data, type, row) {
                        let status = row.get('status'),
                            content;
                        if (status === 0 || status === 1) {
                            content = '<span class="text-info fs-16 font-weight-light">Processing...</span>';
                        } else if (status === 2 && row.get('isPublished')) {
                            let btn = `<div class="btn-group">
                                <button type="button"
                                        class="btn btn-light dropdown-toggle btn-sm ml-2" data-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded="false">
                                    <i class="fad fa-ellipsis-v ml-1"></i>
                                </button>
                                <div class="dropdown-menu">
                                    <a class="dropdown-item btn-notify"
                                       href="javascript:void(0)">Send Notifications</a>
                                    <div class="dropdown-divider"></div>
                                    <a class="dropdown-item btn-revert-batch"
                                       href="javascript:void(0)">Un-Publish</a>
                                </div>
                            </div>`;
                            // let btn = '<button type="button" title="Revert" class="btn btn-light ml-2 btn-revert-batch"><i class="fad fa-undo"></i></button>';
                            content = '<span class="text-success fs-16 font-weight-light">Published</span>' + btn;
                        } else {
                            content = '<button type="button" class="btn btn-sm btn-success btn-publish-batch mr-1">Publish</button><button type="button" class="btn btn-sm btn-danger btn-delete-batch">Delete</button>';
                        }
                        return '<div class="text-align-center">' + content + '</div>';
                    }, this),
                    "width": '150px'
                }
            ],
            dom: '<"top"<"clear">>rt<"bottom"p<"clear">>'
        });

        _.each(this.collection.models, _.bind(function (batch) {
            this.checkBatchStatus(batch)
        }, this));
    },
    checkBatchStatus: function (batch) {
        if (batch.get('status') === 0 || batch.get('status') === 1) {
            batch.statusTimeout = setTimeout(_.bind(function () {
                batch.fetchStatus(_.bind(function (status) {
                    if (status === 2) {
                        // we want to fetch the batch now to get the correct drawing count
                        this.collection.fetch({
                            success: _.bind(function () {
                                this.dataTable.refresh();
                            }, this)
                        });
                        return;
                    }
                    this.checkBatchStatus(batch);
                }, this));
            }, this), 3000)
        }
    },
    notify: function (e) {
        this.removeModal();

        let row = this.dataTable.getRow($(e.currentTarget).closest('tr')),
            batch = row.data();
        new PJQ.views.drawings.BatchNotifyModal({
            batch: batch,
            versions: this.options.versions
        });
    },
    revertBatch: function (e) {
        let row = this.dataTable.getRow($(e.currentTarget).closest('tr')),
            batch = row.data();
        new PJQ.views.modals.YesNo({
            header: "Revert Upload",
            body: "Are you sure you want to revert?  This will un-publish all of the drawings in this upload.",
            onYes: _.bind(function () {
                batch.save(null, {
                    urlOptions: {
                        revert: true
                    },
                    success: _.bind(function () {
                        batch.set('isPublished', false);
                        this.dataTable.refresh();
                        this.options.versions.fetch({
                            success: _.bind(function () {
                                PJQ.notifications.notify.successNotify({
                                    message: 'Drawing upload reverted'
                                });
                            }, this)
                        });
                    }, this)
                });
            }, this)
        });
    },
    publishBatch: function (e) {
        let row = this.dataTable.getRow($(e.currentTarget).closest('tr')),
            batch = row.data();
        this.close();
        new PJQ.views.drawings.DrawingBatchModal({
            model: batch,
            versions: this.options.versions,
            project: this.options.project
        });
    },
    deleteBatch: function (e) {
        let $row = $(e.currentTarget).closest('tr'),
            row = this.dataTable.getRow($row),
            batch = row.data();
        new PJQ.views.modals.DeleteCancel({
            header: "Delete Upload",
            body: "Are you sure you want to delete this upload?",
            onDelete: _.bind(function () {
                batch.destroy({
                    success: _.bind(function () {
                        this.collection.remove(batch);
                        this.dataTable.removeRow(row);
                    }, this)
                });
            }, this)
        });
    },
    newBatch: function () {
        this.close();
        new PJQ.views.drawings.DrawingBatchModal({
            versions: this.options.versions,
            project: this.options.project
        });
    },
    close: function () {
        this.removeModal();
        _.each(this.collection.models, _.bind(function (batch) {
            if (batch.statusTimeout != null) {
                clearTimeout(batch.statusTimeout);
                batch.statusTimeout = null;
            }
        }, this));
    }
});

PJQ.views.drawings.SortDrawings = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DRAWINGS, 'Sort-Drawings'),
        onChange: null,
        showViewLink: true,
        batch: null,
        sortFullSet: false
    },
    events: {
        'click .btn-view-drawing': 'viewDrawing',
        'click .btn-sort-common': 'sortCommon',
        'click .btn-sort-alpha-num': 'sortAlphaNumeric',
        'click .btn-sort-up': 'sortDrawingUp',
        'click .btn-sort-down': 'sortDrawingDown',
        'click .btn-sort-top': 'sortTop',
        'click .btn-sort-bottom': 'sortBottom'
    },
    beforeFirstRender: function () {
        this.sortDrawings = [];
        this.fullset = [];
        let mergeCurrentSet = false;
        if (this.options.batch != null) {
            let hasCurrentSetChange = !this.options.batch.get('replaceCurrentSet') && null != this.options.batch.drawings.findWhere({
                isCurrentSet: true,
                isPublished: false
            });

            if (!hasCurrentSetChange) {
                this.options.batch.drawings.reset(this.options.batch.drawings.where({isPublished: false}));
            } else {
                mergeCurrentSet = true;
            }

            _.each(this.options.batch.drawings.models, function (drawing) {
                if (!drawing.get('isDeleted')) {
                    this.fullset.push(drawing);
                    this.sortDrawings.push({
                        drawing: drawing,
                        matches: []
                    });
                }
            }, this);

            _.each(this.sortDrawings.toReversed(), function (sortDrawing, index) {
                sortDrawing.drawing.set('sortOrder', index * -1);
            });

        } else if (this.options.sortVersion != null) {
            let curSet = this.options.versions.get(-1);
            mergeCurrentSet = null != _.find(this.options.sortVersion.drawings.models, (sDrawing) => {
                return curSet.drawings.findWhere({name: sDrawing.get('name')});
            });
        } else {
            mergeCurrentSet = true;
        }

        if (this.options.sortVersion != null && !mergeCurrentSet) {
            _.each(this.options.sortVersion.drawings.models, (drawing) => {
                this.sortDrawings.push({
                    drawing: drawing,
                    matches: []
                });
                this.fullset.push(drawing);
            });
        } else {
            let self = this,
                curSet = self.options.versions.get(-1);
            if (curSet != null) {
                _.each(curSet.drawings.models, function (drawing) {
                    let sortItem = _.find(self.sortDrawings, function (sortItem) {
                        return drawing.get('name') === sortItem.drawing.get('name');
                    });
                    if (sortItem != null) {
                        sortItem.matches.push(drawing);
                        sortItem.drawing.set('sortOrder', drawing.get('sortOrder'));
                    } else {
                        self.fullset.push(drawing);
                        self.sortDrawings.push({
                            drawing: drawing,
                            matches: []
                        });

                        if (self.options.batch != null) {
                            // we have to add this drawing to the batch so it gets saved with the new sort order
                            // it will save across all by name if the drawing being updated is already published
                            self.options.batch.drawings.add(drawing);
                        }
                    }
                });
            }

            _.each(self.options.versions.models, function (version) {
                _.each(version.drawings.models, function (drawing) {
                    if (!drawing.get('isDeleted')) {
                        let sortItem = _.find(self.sortDrawings, function (sortItem) {
                            return drawing.get('name') === sortItem.drawing.get('name');
                        });
                        if (sortItem != null) {
                            sortItem.matches.push(drawing);
                        } else if (self.options.sortFullSet) {
                            self.fullset.push(drawing);
                            self.sortDrawings.push({
                                drawing: drawing,
                                matches: []
                            });

                            if (self.options.batch != null) {
                                // we have to add this drawing to the batch so it gets saved with the new sort order
                                // it will save across all by name if the drawing being updated is already published
                                self.options.batch.drawings.add(drawing);
                            }
                        }
                    }
                });
            });

            // iterate through each of the models in order of their sort order and e-set their sort order
            // this is to ensure they are sequential with no gaps or duplicates
            if (self.options.batch != null) {
                let drawingsSorted = _.sortBy(self.options.batch.drawings.models, function (drawing) {
                    return drawing.get('sortOrder');
                });
                for (let i = 0; i < drawingsSorted.length; i++) {
                    drawingsSorted[i].set('sortOrder', i + 1);
                }
            }
        }
    },
    renderData: function () {
        return {
            showViewLink: this.options.showViewLink,
            sortDrawings: this.fullset,
            contextDrawing: this.options.contextDrawing
        };
    },
    afterRender: function () {
        let self = this;
        if (_.size(this.fullset) < 500) {
            self.drawingSortable = new PJQ.Sortable(self.$('.drawings-sort'), {
                containment: "parent",
                items: '.drawing-sort',
                multiple: true,
                connectWith: '.drawing-sort',
                onStop: function () {
                    self.setSortLabels();
                }
            });
        }
    },
    setSortLabels: function () {
        let self = this;
        self.$('.drawing-sort').each(function (index) {
            let id = $(this).data('id'),
                item = _.find(self.fullset, function (sortDrawing) {
                    return sortDrawing.id === id
                }),
                name = item.get("name"),
                sortItem = _.find(self.sortDrawings, function (sortDrawing) {
                    return sortDrawing.drawing.get('name') === name
                }),
                sortOrder = index + 1;

            sortItem.drawing.set('sortOrder', sortOrder);
            _.each(sortItem.matches, function (match) {
                match.set('sortOrder', sortOrder);
            });
            $(this).find('.sort-index').html(sortOrder.toString() + '.');
        });
        this.onChange();
    },
    viewDrawing: function (e) {
        let drawingId = $(e.currentTarget).closest('.drawing-sort').data('id'),
            drawing = _.find(this.fullset, function (d) {
                return d.id === drawingId;
            });
        new PJQ.views.drawings.DrawingViewer({
            model: drawing,
            contextVersion: this.options.versions.get(drawing.get('versionId')),
            batch: this.options.batch,
            versions: this.options.versions,
            onSortChange: _.bind(function () {
                this.onChange();
                this.render();
            }, this)
        });
    },
    sortCommon: function () {
        this.autoSort('common');
    },
    sortAlphaNumeric: function () {
        this.autoSort('alpha');
    },
    autoSort: function (type) {
        switch (type) {
            case 'common':
                this.fullset = this.fullset.sort(function (a, b) {
                    return PJQ.helpers.sortHelpers.sortCommonPageNumbers(a.get('name'), b.get('name'));
                });
                break;
            case 'alpha':
                this.fullset = this.fullset.sort(function (a, b) {
                    return PJQ.helpers.sortHelpers.sortAlphaNum(a.get('name'), b.get('name'));
                });
                break;
        }

        _.each(this.fullset, function (drawing, index) {
            let sortItem = _.find(this.sortDrawings, function (sortDrawing) {
                    return sortDrawing.drawing.get('name') === drawing.get('name');
                }),
                sortOrder = index + 1;
            sortItem.drawing.set('sortOrder', sortOrder);
            _.each(sortItem.matches, function (match) {
                match.set('sortOrder', sortOrder);
            });
        }, this);
        this.onChange();
        this.render();
    },
    sortDrawingUp: function (e) {
        let $drawing = $(e.currentTarget).closest('.drawing-sort');
        $drawing.insertBefore($drawing.prev());
        this.setSortLabels();
    },
    sortDrawingDown: function () {
        let $drawing = $(e.currentTarget).closest('.drawing-sort');
        $drawing.insertAfter($drawing.next());
        this.setSortLabels();
    },
    sortTop: function () {
        this.drawingSortable.moveSelectedTop();
    },
    sortBottom: function () {
        this.drawingSortable.moveSelectedBottom();
    },
    onChange: function () {
        if (typeof this.options.onChange === 'function') {
            this.options.onChange();
        }
    }
});

PJQ.views.drawings.SortDrawingsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DRAWINGS, 'Modal-Sort-Drawings'),
        width: 600,
        maxWidth: '90%',
        onDone: _.noop,
        sortFullSet: false
    },
    events: {
        'click .btn-done': 'done'
    },
    afterRender: function () {
        new PJQ.views.drawings.SortDrawings({
            el: this.$('.sort-drawings'),
            versions: this.options.versions,
            sortVersion: this.options.sortVersion,
            batch: this.options.batch,
            sortFullSet: this.options.sortFullSet
        });
    },
    done: function () {
        if (typeof this.options.onDone === 'function') {
            this.options.onDone();
        }
        this.removeModal();
    }
});

PJQ.views.drawings.AdvancedDownloadModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DRAWINGS, 'Modal-Advanced-Download'),
        width: 500,
        maxWidth: '90%',
        onDone: _.noop
    },
    events: {
        'click .btn-download': 'download'
    },
    renderData: function () {
        return {
            project: this.options.project,
            isPaidDownload: this.options.isPaidDownload,
            isPrintOrder: this.options.isPrintOrder
        };
    },
    afterRender: function () {
        if (this.options.isPrintOrder) {
            this.$('.context-title').text('Order Prints')
            this.$('.btn-download').text('Continue');
        }

        this.renderDrawingSelector();
    },
    renderDrawingSelector: function () {
        new PJQ.views.drawings.DrawingSelectorTree({
            el: this.$('.drawings-tree'),
            collection: this.collection,
            onChange: _.bind(function (versions) {
                this.selectedVersions = versions;

                let selDrawingCount = 0;
                _.each(versions, function (version) {
                    selDrawingCount += _.size(version.guids);
                });
                this.$('.btn-download').prop('disabled', selDrawingCount === 0);
            }, this)
        });
    },
    download: function () {
        let raster = this.$('.checkbox-raster').prop('checked'),
            merge = this.$('.checkbox-merge').prop('checked'),
            includeAttachments = this.$('.checkbox-attachments').prop('checked'),
            includeMyAnnotations = this.$('.checkbox-my-annotations').prop('checked'),
            includePublishedAnnotations = this.$('.checkbox-published-annotations').prop('checked');

        let dl = _.bind(function () {
            let entryIds = [];
            _.each(this.selectedVersions, function (selectedVersions) {
                entryIds.push(..._.map(selectedVersions.ids, function (id) {
                    return id * -1;
                }));
            });
            if (this.options.isPaidDownload) {
                if (PJQ.app.session.project != null && PJQ.app.session.project.get('masterUserId') === PJQ.app.session.get('masterUserId') && (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.CAN_ORDER_ON_ACCOUNT) || PJQ.app.session.hasPermission('documents.onAccount'))) {
                    new PJQ.views.drawings.OrderDownloadAdmin({
                        entryIds: entryIds,
                        orderSettings: this.options.orderSettings
                    });
                } else {
                    new PJQ.views.drawings.OrderPrintsModal({
                        mode: PJQ.constants.files.modes.DOWNLOAD,
                        entryIds: entryIds,
                        orderSettings: this.options.orderSettings
                    });
                }
            } else if (this.options.isPrintOrder) {
                new PJQ.views.drawings.OrderPrintsModal({
                    mode: PJQ.constants.files.modes.PRINT,
                    entryIds: entryIds,
                    orderSettings: this.options.orderSettings
                });
            } else {
                PJQ.helpers.drawings.createDownload(this.options.project, this.selectedVersions, {
                    raster: raster,
                    merge: merge,
                    includeAttachments: includeAttachments,
                    includeMyAnnotations: includeMyAnnotations,
                    includePublishedAnnotations: includePublishedAnnotations
                });
            }
        }, this);
        if (this.options.project != null) {
            this.options.project.checkDownloadRequirements(_.bind(function () {
                dl();
                this.removeModal();
            }, this));
        } else {
            dl();
        }
    }
});

PJQ.views.drawings.ManageVersionsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DRAWINGS, 'Modal-Manage-Versions'),
        width: 600,
        maxWidth: '90%'
    },
    events: {
        'click .btn-upload-to-version': 'uploadToVersion',
        'click .btn-new-batch': 'newBatch',
        'click .btn-sort-version': 'sortVersion',
        'click .btn-edit-version': 'editVersion',
        'click .btn-cancel-edit-version': 'cancelEditVersion',
        'click .btn-delete-version': 'deleteVersion',
        'click .btn-save-version': 'saveVersion',
        'click .btn-close': 'close'
    },
    beforeModalCreated: function () {
        if (this.collection == null) {
            this.collection = new PJQ.collections.drawings.Versions(null, {
                project: this.options.project
            });
            this.collection.fetch({
                success: _.bind(function () {
                    this.render();
                }, this)
            });
        }
    },
    afterRender: function () {
        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.upload-log'),
            data: _.filter(this.collection.models, function (version) {
                return version.id > 0;
            }),
            language: {
                zeroRecords: 'Click "Upload Drawings" to publish a new version'
            },
            onTableDraw: _.bind(function () {
                if (this.contextEditVersion != null) {
                    this.datePicker = new PJQ.inputs.Datepicker({
                        el: this.$('.input-version-date-issued'),
                        isShowTimezone: false,
                        datepickerOptions: {
                            format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE
                        },
                        onChange: _.bind(function (newDate) {
                            this.contextEditVersion.set('issuedOn', newDate);
                        }, this)
                    });
                }
            }, this),
            isHideSearch: true,
            order: [1, 'desc'],
            columns: [
                // {
                // 	"data": "attributes.drawings",
                // 	"render": _.bind(function (data, type, row) {
                // 		let drawingCount = _.size(row.drawings);
                // 		if (drawingCount > 0) {
                // 			return '<div class="text-orange fs-16"><i class="fad fa-file"></i> ' + drawingCount.toString() + '</div>';
                // 		}
                // 		else {
                // 			return '<div class="text-muted fs-16"><i class="fad fa-file"></i> ' + drawingCount.toString() + '</div>';
                // 		}
                // 	}, this),
                // 	"title": "",
                // 	"width": "50px"
                // },
                {
                    "data": {
                        "_": function (row) {
                            return new Date(row.get('name'));
                        },
                        "filter": "attributes.name",
                        "display": _.bind(function (row) {
                            if (this.contextEditVersion != null && this.contextEditVersion.id === row.id) {
                                return '<input type="text" class="form-control input-version-name" value="' + row.get('name') + '">';
                            } else {
                                return row.get('name');
                            }
                        }, this)
                    },
                    "title": "Version Name"
                },
                {
                    "data": {
                        "_": function (row) {
                            return new Date(row.get('issuedOn'));
                        },
                        "filter": "attributes.issuedOn",
                        "display": _.bind(function (row) {
                            if (this.contextEditVersion != null && this.contextEditVersion.id === row.id) {
                                return '<input type="text" class="form-control input-version-date-issued" value="' + row.get('issuedOn') + '" />';
                            } else {
                                return PJQ.helpers.dateHelpers.getDateString(new Date(row.get('issuedOn')), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                            }
                        }, this)
                    },
                    "title": "Issued On",
                    "width": "100px"
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    resizable: false,
                    "render": _.bind(function (data, type, row) {
                        let content = '';
                        if (this.contextEditVersion != null && this.contextEditVersion.id === row.id) {
                            content = '<button type="button" class="btn btn-success btn-save-version wd-30p mr-1"><i class="fal fa-save"></i></button><button type="button" class="btn btn-danger btn-cancel-edit-version wd-30p"><i class="fal fa-times"></i></button>';
                        } else {
                            let disabledAttr = this.contextEditVersion != null ? ' disabled ' : '';
                            content = '<button type="button" title="Upload Drawings" class="btn btn-success btn-upload-to-version wd-30p mr-1"' + disabledAttr + '><i class="fal fa-file-plus"></i></button><button type="button" class="btn btn-info btn-edit-version wd-30p mr-1"' + disabledAttr + '><i class="fal fa-pencil"></i></button><button type="button" class="btn btn-danger btn-delete-version wd-30p"' + disabledAttr + '><i class="fal fa-trash"></i></button>';
                        }
                        return '<div class="text-align-right" style="min-width:100px;">' + content + '</div>'
                    }, this),
                    "width": '100px'
                }
            ],
            dom: '<"top"<"clear">>rt<"bottom"p<"clear">>'
        });
    },
    newBatch: function () {
        this.close();
        new PJQ.views.drawings.DrawingBatchModal({
            versions: this.collection,
            project: this.options.project
        });
    },
    uploadToVersion: function (e) {
        let $row = $(e.currentTarget).closest('tr'),
            version = this.dataTable.getRow($row).data();
        this.close();
        new PJQ.views.drawings.DrawingBatchModal({
            version: version,
            project: this.options.project,
            versions: this.collection
        });
    },
    editVersion: function (e) {
        this.contextEditVersion = this.dataTable.getRow($(e.currentTarget).closest('tr')).data();
        this.dataTable.refresh();
    },
    cancelEditVersion: function () {
        this.contextEditVersion = null;
        this.dataTable.refresh();
    },
    saveVersion: function (e) {
        let $row = $(e.currentTarget).closest('tr'),
            version = this.dataTable.getRow($row).data(),
            $name = $row.find('.input-version-name');
        version.set('name', $name.val());

        let isNameValid = _.size(version.get('name')) > 0;
        PJQ.helpers.inputHelpers.setInputError($name, isNameValid);

        let isIssuedOnValid = version.get('issuedOn') != null;
        PJQ.helpers.inputHelpers.setInputError(this.$('.input-version-date-issued'), isIssuedOnValid);

        if (isNameValid && isIssuedOnValid) {
            version.save(null, {
                success: _.bind(function () {
                    this.contextEditVersion = null;
                    this.dataTable.refresh();
                }, this)
            });
        }
    },
    deleteVersion: function (e) {
        let $row = $(e.currentTarget).closest('tr'),
            row = this.dataTable.getRow($row),
            version = row.data();
        new PJQ.views.modals.DeleteCancel({
            header: "Delete Version",
            body: "Are you sure you want to delete this version?",
            onDelete: _.bind(function () {
                version.destroy({
                    success: _.bind(function () {
                        this.collection.remove(version);
                        this.dataTable.removeRow(row);
                    }, this)
                });
            }, this)
        });
    },
    close: function () {
        this.removeModal();
        _.each(this.collection.models, _.bind(function (batch) {
            if (batch.statusTimeout != null) {
                clearTimeout(batch.statusTimeout);
                batch.statusTimeout = null;
            }
        }, this));
    }
});

PJQ.views.drawings.BatchNotifyModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DRAWINGS, 'modal-batch-notify'),
        subTemplates: {
            emailBadge: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Share-Email-Badge')
        },
        maxWidth: 650,
    },
    events: {
        'click .btn-back': 'previousStep',
        'click .btn-next': 'nextStep',
        'click .btn-send': 'send',
        'click .btn-cancel': 'cancel',
        'click .btn-add-project-contacts': 'addProjectContacts',
        'keyup .input-share-search': 'searchChanged',
        'focus .input-share-search': 'focusSearch',
        'click .share-email-delete': 'deleteEmail',
        'mousedown .modal-dialog': 'checkIsFocused'
    },
    beforeModalCreated: async function () {
        if (this.options.project == null) {
            this.options.project = PJQ.app.session.project;
        }

        this.isFetched = false;
        this.step = 1;

        this.selectedEmailsTo = [];
        this.selectedEmailsCC = [];

        let verAppend = null;
        if (this.options.versions != null) {
            let version = this.options.versions.get(this.options.batch.get('versionId'));
            if (version != null) {
                verAppend = ' (' + version.get('name') + ')';
            }
        }

        this.model = new PJQ.models.drawings.DrawingBatchNotification({
            batchId: this.options.batch.id,
            subject: 'Drawings Published to ' + this.options.project.get('projectName') + (verAppend ?? ""),
            message: ''
        });

        this.isFetched = true;
        this.render();
    },
    renderData: function () {
        return {
            model: this.model,
            step: this.step,
            batch: this.options.batch,
            selectedEmailsTo: this.selectedEmailsTo,
            selectedEmailsCC: this.selectedEmailsCC
        }
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        new PJQ.StepIndicator(this.$('.steps-outer'), {
            steps: [{
                name: 'Compose Email'
            }, {
                name: 'Review & Send'
            }],
            activeStep: this.step - 1
        });

        switch (this.step) {
            case 1:
                this.bodyEditor = new PJQ.inputs.HTMLEditor({
                    el: this.$('.email-message'),
                    editorHeight: 300,
                    isHideTokens: true,
                    onChange: (contents) => {
                        this.model.set('message', contents);
                    }
                });

                _.each(this.selectedEmailsTo, (email) => {
                    this.renderEmail(email, 'to');
                });

                _.each(this.selectedEmailsCC, (email) => {
                    this.renderEmail(email, 'cc');
                })
                break;
            case 2:
                break;
            case 3:
                break;
        }
    },
    addProjectContacts: function () {
        this.selector = new PJQ.views.contacts.SelectContactsModal({
            context: PJQ.constants.contacts.contexts.PROJECTCONTACTS,
            enableSelectAll: true,
            isSingleChoice: false,
            // saveButtonText: this.options.saveButtonText,
            onSave: (newContacts) => {
                let emails = _.filter(_.map(newContacts, (contact) => {
                    return contact.get('email');
                }), (email) => {
                    return _.size(email) > 0;
                });
                _.each(emails, (email) => {
                    if (_.contains(this.selectedEmailsTo, email)) {
                        return;
                    }
                    this.selectedEmailsTo.push(email);
                    this.renderEmail(email, 'to');
                });
            }
        });
    },
    previousStep: function () {
        this.step--;
        this.render();
    },
    nextStep: function () {
        switch (this.step) {
            case 1:
                let toValid = _.size(this.selectedEmailsTo) > 0;
                PJQ.helpers.inputHelpers.setInputError(this.$('.input-to'), toValid);

                let subject = this.$('.input-subject').val(),
                    subjectValid = _.size(subject) > 0;
                this.model.set('subject', subject);
                PJQ.helpers.inputHelpers.setInputError(this.$('.input-subject'), subjectValid);

                if (!subjectValid || !toValid) {
                    return;
                }
                break;
            case 2:
                break;
            case 3:
                break;
        }

        this.step++;
        this.render();
    },
    focusSearch: function (e) {
        this.focusType = $(e.currentTarget).data('email-line');
        if (this.contactEmailSelector != null)
            this.contactEmailSelector.remove();

        this.contactEmailSelector = new PJQ.views.email.ContactSearchSelect({
            el: this.focusType === "to" ? this.$('.contact-emails-to') : this.$('.contact-emails-cc'),
            selectedEmails: this.focusType === "to" ? this.selectedEmailsTo : this.selectedEmailsCC,
            search: this.getFocusSearchText(),
            project: this.options.project,
            onAdd: (email) => {
                this.renderEmail(email);
            }
        });
    },
    checkIsFocused: function (e) {
        if (this.$(e.target).closest('.share-contact').length > 0) {
            return;
        }

        // Removes contact email selector if not selecting a contact, or entering an email
        let target = $(e.target),
            targetParent = $(e.target.parentElement);

        if (this.focusType != null
            && !target.hasClass('share-contact')
            && !targetParent.hasClass('share-contact')
            && !target.hasClass('input-share-search')
            && !target.hasClass('share-contact-email')
            && !target.hasClass('share-email-entry')
            && !target.hasClass('share-contact-name')) {
            this.contactEmailSelector.remove();
            this.focusType = null;
        }
    },
    getFocusSearchText: function () {
        return this.focusType != null ? this.$('.input-share-search[data-email-line="' + this.focusType + '"]').val().toLowerCase() : this.$('.input-share-search').val().toLowerCase();
    },
    searchChanged: function () {
        if (this.contactEmailSelector == null) {
            return;
        }

        this.contactEmailSelector.searchChanged(this.getFocusSearchText());
    },
    renderRecipientCount: function () {
        let emailCount = _.size(this.selectedEmailsTo) + _.size(this.selectedEmailsCC);
        this.$('.recipient-count').html(emailCount.toString() + (emailCount === 1 ? ' recipient' : ' recipients'));
    },
    renderEmail: function (email, type = null) {
        this.renderSubTemplate(true, this.options.subTemplates.emailBadge, this.$('.share-selected-emails[data-email-line="' + (type ?? this.focusType) + '"]'), {
            email: email
        });
        this.$('.input-share-search').val('');
        this.$('.modal-share-send').prop('disabled', false);
        this.renderRecipientCount();
        this.$('.input-share-search[data-email-line="' + this.focusType + '"]').focus();
    },
    deleteEmail: function (e) {
        let emailContainer = $(e.currentTarget).closest('.share-email'),
            emailLineType = $(e.currentTarget).closest('.share-selected-emails').data('email-line'),
            emailArray = emailLineType === "to" ? this.selectedEmailsTo : this.selectedEmailsCC
        emailArray = _.without(emailArray, emailContainer.data('email').toLowerCase());

        if (emailLineType === "to")
            this.selectedEmailsTo = emailArray
        else
            this.selectedEmailsCC = emailArray

        emailContainer.remove();
        this.searchChanged();
        this.$('.modal-share-send').prop('disabled', _.size(emailArray) === 0);
        this.renderRecipientCount();
    },
    send: function () {
        let loader = new PJQ.Loader(this.$('.modal-content'));
        this.model.set({
            to: this.selectedEmailsTo,
            cc: this.selectedEmailsCC
        })

        this.model.save(null, {
            success: () => {
                PJQ.notifications.notify.successNotify({
                    message: 'Published Drawings Notification sent'
                });
                this.removeModal();
            },
            error: () => {
                PJQ.notifications.notify.errorNotify({
                    message: 'Encountered an error sending notification, please contact customer service'
                });
            },
        });
    },
    cancel: function () {
        new PJQ.views.modals.YesNo({
            header: "Cancel Notification?",
            body: "Are you sure you want to cancel sending this notification?",
            onYes: () => {
                this.removeModal();
            }
        });
    }
});